export const submenus = {
    31:{
        casino: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/live-casino/roulette',
                        icon: '',
                        label: 'TITLE@ROULETTESIDEBAR',
                        authkey: 'showRoulette'
                    },
                    {
                        id: '2',
                        url: '/live-casino/blackjack',
                        icon: '',
                        label: 'TITLE@BLACKJACKSIDEBAR',
                        authkey: 'showBlackjack'
                    },
                    {
                        id: '3',
                        url: '/live-casino/baccarat',
                        icon: '',
                        label: 'TITLE@BACCARAT',
                        authkey: 'showBaccarat'
                    },
                    {
                        id: '4',
                        url: '/live-casino/dragon-tiger',
                        icon: '',
                        label: 'TITLE@DRAGON_TIGER',
                        authkey: 'showDragontiger'
                    }
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@ENJOY'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm3',
                    url:'/popular-games',
                    image: 'DROPDOWN_POPULAR.png',
                    label: 'TITLE@populargames'
                },
                {

                    id: 'rm1',
                    url:'/live-casino',
                    image: 'DROPDOWN_CASINO_LIVE_CASINO.png',
                    label: 'TITLE@LIVECASINO',
                    authkey: 'showOnlineCasinoGamesLink'
                },
                {
                    id: 'rm2',
                    url:'/slots',
                    image: 'DROPDOWN_SLOT_BINGO.png',
                    label: 'TITLE@SLOTBINGO'
                }
            
             
                    ]
        },
        instant_games: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/instant-games/smartsoft/plinkox',
                        icon: '',
                        label: "TITLE@Plinko",
                        authkey: "showInstantThumbs"
                    },
                    // {
                    //     id: '2',
                    //     url: '/instant-games/smartsoft/footballx',
                    //     icon: '',
                    //     label: 'TITLE@Footballx',
                    //     authkey: "showInstantThumbs"
                    // },
                    // {
                    //     id: '3',
                    //     url: '/instant-games/smartsoft/balloon',
                    //     icon: '',
                    //     label: 'TITLE@Baloon',
                    //     authkey: "showInstantThumbs"
                    // },
                    {
                        id: '4',
                        url: '/instant-games/inout/chicken-road-2',
                        icon: '',
                        authkey:"showInstantThumbs",
                        label: "TITLE@ChickenRoad2"
                    },
                    {
                        id: '5',
                        url: '/instant-games/galaxsys/ninja-crash',
                        icon: '',
                        authkey:"showInstantThumbs",
                        label: "TITLE@ninjacrush"
                    },
                  
                    {
                        id: '7',
                        url: '/instant-games',
                        icon: '',
                        authkey:"showInstantThumbs",
                        label: "HEADER@VIEWALL"
                    }
                
                
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@ExploreALL'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm1',
                    url: '/instant-games/spribe/aviator',
                    image: 'aviator-instant-cashsite-dropdown.png',
                    label: 'TITLE@AVIATOR',
                    authkey: "showInstantThumbs"
                },
                {
                    id: 'rm2',
                    url: '/instant-games/smartsoft/jetx',
                    image: 'jetx-instant-cashsite-drowpdown.png',
                    label: 'TITLE@JetX',
                    authkey: "showInstantThumbs"
                },
                {
                    id: 'rm3',
                    url: '/instant-games/aviatrix/play-aviatrix',
                    image: 'AviatriXdropdown.png',
                    label: 'GAME@AVIATRIX',
                    authkey: "showInstantThumbs"
                }
                
            ]
        },
        hotgames: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/live-casino/evolution/monopoly-live',
                        icon: '',
                        label: 'TITLE@MonopolyLive',
                        authkey: 'showTeenpatti'
                    },
                    {
                        id: '2',
                        url: '/live-casino/evolution/funky-time',
                        icon: '',
                        label: 'TITLE@FunkyTimes',
                        authkey: 'showTeenpatti2020'
                    },
                    {
                        id: '3',
                        url: '/live-casino/evolution/lightning-dice',
                        icon: '',
                        label: 'TITLE@LightningDice',
                        authkey: 'showTeenpatti2020'
                    },
                    {
                        id: '4',
                        url: '/live-casino/dragon-tiger',
                        icon: '',
                        label: 'TITLE@DragonTiger',
                        authkey: 'showTeenpatti2020'
                    },
                    {
                        id: '5',
                        url: '/instant-games/smartsoft/cricketx',
                        icon: '',
                        label: 'TITLE@CricketX',
                        authkey: 'showTeenpatti2020'
                    },
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@PLAYANDNEVER'
                    },
                ]
            },
            rightMenu: [

                {
                    id: 'rm1',
                    url:'/instant-games/spribe/mines',
                    image: 'spribe-minesdropdown.png',
                    label: 'TITLE@Mines',
                    authkey: 'showTeenpattiLink'
                },
                {
                    id: 'rm2',
                    url:'/live-casino/evolution/crazy-time',
                    image: 'DROPDOWN_CRAZY_TIME.png',
                    label: "TITLE@crazytime",
                    authkey: 'showTeenpattiLink'
                },
                {
                    id: 'rm3',
                    url:'/live-casino/evolution/lightning-roulette',
                    image: 'DROPDOWN_LIGHTNING_ROULETTE.png',
                    label: 'TITLE@LIGHTINGROULETTE',
                    authkey: 'showTeenpattiLink'
                }
               
            ]
        },
        sports: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/betting-exchange/cricket',
                        icon: '',
                        label: 'SPORT@CRICKET',
                        authkey: 'showSportCricket'
                    },
                    {
                        id: '2',
                        url: '/betting-exchange/football',
                        icon: '',
                        label: 'SPORT@FOOTBALL',
                        authkey: 'showSportFootball'
                    },
                    {
                        id: '3',
                        url: '/betting-exchange/tennis',
                        icon: '',
                        label: 'SPORT@TENNIS',
                        authkey: 'showSportTennis'
                    },
                    // {
                    //     id: '4',
                    //     url: '/betting-exchange/volleyball',
                    //     icon: '',
                    //     label: 'SPORT@VolleyBall',
                    //     authkey: 'showSportVolleyball'
                    // },
                    // {
                    //     id: '5',
                    //     url: '/virtualSports/vci',
                    //     icon: '',
                    //     label: 'TITLE@VIRTUALSPORTS',
                    //     authkey: 'showVirtualSportsvfec'
                    // },
                    {
                        id: '6',
                        url: '/sports/',
                        icon: '',
                        label: 'TITLE@AllSports',
                        authkey: 'showAllSports'
                    },
                    // {
                    //     id: '7',
                    //     url: '/saba-sports',
                    //     icon: '',
                    //     label: 'TITLE@SabaSports',
                    //     authkey: 'showSabaSportsStatement'
                    // }
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@GOONTURN'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm1',
                    url:'/betting-exchange',
                    image: 'DROPDOWN_EXCHANGE_NEW.png',
                    label: 'TITLE@EXCHANGE',
                    authkey: 'showExchangeLink',
                    itemsCount: '5'
                },
                // {
                //     id: 'rm5',
                //     url:'/premium-sportsbook/kabaddi-betting',
                //     image: 'kabbadiYolo.png',
                //     label: 'MENU@Kabbadi',
                //     authkey: 'showProKabbadi',
                //     itemsCount: '5'
                // },
                {
                    id: 'rm2',
                    url:'/premium-sportsbook',
                    image: 'premiumSportsbookDropdownYolo1.png',
                    label: 'TITLE@PREMIUM_SPORTSBOOK',
                    authkey: 'showPremiumSportsLink',
                    itemsCount: '5'
                },
                {
                    id: 'rm3',
                    url:'/sportsbook',
                    image: 'DROPDOWN_SPORTSBOOK_NEW.png',
                    label: 'MENU@SPORTBOOK',
                    authkey: 'showSportBookLink',
                    itemsCount: '5'
                },
                {
                    id: 'rm4',
                    url:'/saba-sports',
                    image: 'YoloSabaDesk.png',
                    label: 'TITLE@SabaSports',
                    authkey: 'showSabaSportsStatement',
                    itemsCount: '5'
                },
                // {
                //     id: 'rm4',
                //     url:'/virtualSports/vci',
                //     image: 'virtualSportsDesktopDropdown.png',
                //     label: 'GAME@VIRTUALSPORTS',
                //     authkey: 'showVirtualSportsvfel'
                // },
            ]
        },
        promotions: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/promotions/welcome-bonus',
                        icon: '',
                        label: "PROMOTIONSTITLE@WELCOME"
                    },
                    {
                        id: '2',
                        url: '/promotions/refill-bonus',
                        icon: '',
                        label: 'PROMOTIONSTITLE@REFILL',
                        authkey: "showRefillBonus"
                    },
                    {
                        id: '3',
                        url: '/promotions/cashback-bonus',
                        icon: '',
                        label: 'PROMOTIONSTITLE@CASHBACK',
                        authkey: "showCashbackBonus"
                    },
                    {
                        id: '4',
                        url: '/promotions/referral-bonus',
                        icon: '',
                        authkey:"showReferralBonus",
                        label: "ProBonus@Referral"
                    },   
                    {
                        id: '5',
                        url: '/promotions/big-bash',
                        icon: '',
                        authkey:"showBBLBonus",
                        label: "PROMOTIONS@BBLBonus"
                    },
                    {
                        id: '6',
                        url: '/promotions/arjith_promo',
                        icon: '',
                        authkey:"showSingWithYolo",
                        label: "PROMOTIONS@singYolo"
                    },
                    {
                        id: '7',
                        url: '/promotions/jetx-tournament',
                        icon: '',
                        authkey:"jetxpromo",                                 
                        label:"jetx"
                    },
                    {
                        id: '8',
                        url: '/promotions/crazyCrash',
                        icon: '',
                        authkey:"showCrazyCrashPromo",
                        label:"PROMOTIONS@crazyCrashPromo"
                    },
                    {   id: '9',
                        url: '/promotions/aviator-bonus',
                        icon: '',
                        authkey:"showAviatorBonus",
                        label:"PROMOTIONS@AviatorBonus"
                    },   
                    {
                        id: '10',
                        url: '/promotions/evolution-first-bet',
                        icon: '',
                        authkey:"showEvolutionpromo",
                        label: "PROMOTIONS@firstperson"
                    },
                    {
                        id: '11',
                        url: '/promotions/funkytime',
                        icon: '',
                        authkey:"showFunkytimePromo",
                        label: "PROMOTIONS@funkytime"
                    },
                    {
                        id: '15',
                        url: '/promotions/evo-baccarat',
                        icon: '',
                        authkey:"showEvoCasinoCupPromo",
                        label: "PROMOTIONS@EvoCasinoCupPromo"
                    },
                    {
                        id: '12',
                        url: '/promotions/worldcup-cashback-bonanza',
                        icon: '',
                        authkey:"showWCBonusPromo",
                        label: "PROMOTIONS@WCCBONAZA"
                    },
                    {
                        id: '13',
                        url: '/promotions/platinum-rush',
                        icon: '',
                        authkey:"showPlatinumRush",
                        label: "PROMOTIONS@Platinumrush"
                    },
                    {
                        id: '14',
                        url: '/promotions/worldcup-betboost',
                        icon: '',
                        authkey:"showWCBonusPromo",
                        label: "TITLE@wcbetboost"
                    },
                    {
                        id: '15',
                        url: '/promotions/catch99-s2',
                        icon: '',
                        authkey:"showCatch99Bonus",
                        label: "PROMOTIONS@CATCH99"
                    },
                    // {
                    //     id: '16',
                    //     url: '/promotions/evolution-crazy-pachinko',
                    //     icon: '',
                    //     authkey:"showCrazyPachinkoPromo",
                    //     label: "TITLE@EvoCrazyPachinko"
                    // },
                    {
                        id: '17',
                        url: '/promotions/jetx-celestial-rush',
                        icon: '',
                        authkey:"showJetXCelestialRush",
                        label: "PROMOTIONS@JetxCelestial"
                    },
                    {
                        id: '18',
                        url: '/promotions/aviatrix-double-dhamaka',
                        icon: '',
                        authkey:"showAviatrixPromo",
                        label: "PROMOTIONS@AviatrixDoubleDhamaka"
                    },
                    {
                        id: '19',
                        url: '/promotions/cricket-cashback-marathon',
                        icon: '',
                        authkey:"showcircketCashbackMarathon",
                        label: "PROMOTIONS@CricketCashbackMarathon"
                    },
                    {
                        id: '20',
                        url: '/promotions/crazytime-epic-bonanza',
                        icon: '',
                        authkey:"showCrazyTimePromo",
                        label: "PROMOTIONS@CrazyTimeEpicBonanza"
                    },
                    {
                        id: '21',
                        url: '/promotions/aviator-high-flyer',
                        icon: '',
                        authkey:"showAviatorHighFlyerPromo",
                        label: "PROMOTIONS@AviatorHighFlyer"
                    }, 
                    {
                        id: '22',
                        url: '/promotions/smartsoft-spin-and-win',
                        icon: '',
                        authkey:"showSmartsoft",
                        label: "PROMOTIONS@Smartsoft"
                    },


                    {
                        id: '23',
                        url: '/promotions/evolution-casino-cup',
                        icon: '',
                        authkey:"showEvolutionCasionCup",
                        label: "PROMOTIONS@EvolutionCasionCup"
                    },




                    {
                        id: '24',
                        url: '/promotions/IPL-Betting-dhamaka-Power-Play-Bonus',
                        icon: '',
                        authkey:"shoeIPLpowerPlay",
                        label: "PROMOTIONS@IPLPOWERPLAY1"
                    },



                    {
                        id: '25',
                        url: '/promotions/indian-galaxsys-league',
                        icon: '',
                        authkey:"showIndianGalaxysLeague",
                        label: "PROMOTIONS@IndianGalaxsysLeague"
                    },
                   
                    



                        {
                        id: '26',
                        url: '/promotions/ipl-betting-dhamaka',
                        icon: '',
                        authkey:"showIplPromo",
                        label: "PROMOTIONS@iplmatka"},



                        {
                            id: '27',
                            url: '/promotions/double-cashback',
                            icon: '',
                            authkey:"showDoubleCashBack",
                            label: "PROMOTIONS@DoubleCashback"
                        },


                        {
                        id: '28',
                        url: '/promotions/aviator-sky-bound-miles',
                        icon: '',
                        authkey:"showAviatorSkyBoundMiles",
                        label: "PROMOTIONS@AviatorSkyBoundMiles"
                    },
                    {
                        id: '29',
                        url: '/promotions/wc-lossback',
                        icon: '',
                        authkey:"showWorldCupLossbackYolo",
                        label: "PROMOTIONS@WorldCupLossbackBonus"
                    },
                    {
                        id: '30',
                        url: '/promotions/wc-doubleCashback',
                        icon: '',
                        authkey:"showWorldCupDoubleCashbackBonus",
                        label: "PROMOTIONS@WorldCupDailyDepositBonus"
                    },
                    {
                        id: '31',
                        url: '/promotions/wc-evolutionCasinoCup',
                        icon: '',
                        authkey:"showWorldCupEvolutionCasinoCup",
                        label: "PROMOTIONS@WorldCupEvolutionCasinoCupBonus"
                    },
                    {
                        id: '34',
                        url: '/promotions/smartsoft-spin-and-win',
                        icon: '',
                        authkey:"showSmartSoftJetxCelestial",
                        label: "PROMOTIONS@SmartSoftJetxCelestial"
                    },
                    {
                        id: '35',
                        url: '/promotions/mines-legend-trophy',
                        icon: '',
                        authkey:"showMinesLegendTrophyPromo",
                        label: "PROMOTIONS@MinesLegendTrophy"
                    },
                    {
                        id: '36',
                        url: '/promotions/caribbean-premier-league',
                        icon: '',
                        authkey:"showCaribbeanLeagueBonusPromo",
                        label: "PROMOTIONS@CaribbeanLeagueBonus"
                    },
                    {
                        id: '37',
                        url: '/promotions/evolution-roulette-cup',
                        icon: '',
                        authkey:"showEvolutionRouletteCupPromo",
                        label: "PROMOTIONS@EvolutionRouletteCup"
                    },
                    {
                        id: '38',
                        url: '/promotions/aviatrix-fly-and-play',
                        icon: '',
                        authkey:"showAviatrixFlyAndPlayPromo",
                        label: "PROMOTIONS@AviatrixFlyAndPlay"
                    },
                    {
                        id: '39',
                        url: '/promotions/aviatrix-jet-to-cash',
                        icon: '',
                        authkey:"showAviatrixJetToCrash",
                        label: "PROMOTIONS@AviatrixJetToCrash"
                    },
                    {
                        id: '40',
                        url: '/promotions/aviator-rain',
                        icon: '',
                        authkey:"showAviatorRainPromo",
                        label: "PROMOTIONS@AviatorRainPromo"
                    },
                    {
                        id: '41',
                        url: '/promotions/jet-set-with-jetx',
                        icon: '',
                        authkey:"showJetSetWithJetXPromo",
                        label: "PROMOTIONS@JetSetWithJetX"
                    },
                    {
                        id: '42',
                        url: '/promotions/womens-world-cup',
                        icon: '',
                        authkey:"showWomensWorldCupPromo",
                        label: "PROMOTIONS@WomensWorldCup"
                    },
                    {
                        id: '43',
                        url: '/promotions/big-bash-big-cash',
                        icon: '',
                        authkey:"showBigBashBigCashPromo",
                        label: "PROMOTIONS@BigBashBigCash"
                    },
                    {
                        id: '44',
                        url: '/promotions/the-live-jackpot',
                        icon: '',
                        authkey:"showLiveJackPot2025Promo",
                        label: "PROMOTIONS@LiveJackPot2025"
                    },
                    {
                        id: '45',
                        url: '/promotions/instant-challenge-2025',
                        icon: '',
                        authkey:"showInstantChallengePromo",
                        label: "PROMOTIONS@InstantChallengePromo"
                    },
                    {
                        id: '46',
                        url: '/promotions/super-slots-challenge',
                        icon: '',
                        authkey:"showSuperSlotsChallengePromo",
                        label: "PROMOTIONS@SuperSlotsChallenge"
                    },
                    {
                        id: '47',
                        url: '/promotions/icc-champions-trophy',
                        icon: '',
                        authkey:"showChampionsTrophyPromo",
                        label: "PROMOTIONS@ChampionsTrophy"
                    },
                    {
                        id: '49',
                        url: '/promotions/daily-leaderboard',
                        icon: '',
                        authkey:"showDailyLeaderboard",
                        label: "PROMOTIONS@DailyLeaderBoard"
                    },
                    {
                        id: '50',
                        url: '/promotions/aviatrix-sky-high-challenge',
                        icon: '',
                        authkey:"showAviatrixSkyHighChallengePromo",
                        label: "PROMOTIONS@AviatrixSKYHighChallenge"
                    },
                    {
                        id: '51',
                        url: '/promotions/lightning-cashback',
                        icon: '',
                        authkey:"showLightningCashback2k25",
                        label: "PROMOTIONS@LightningCashback2k25"
                    },
                    {
                        id: '52',
                        url: '/promotions/galaxsys-tournament',
                        icon: '',
                        authkey:"showGalaxsysTournament",
                        label: "PROMOTIONS@GalaxsysTournamentPromo"
                    },
                    {
                        id: '53',
                        url: '/promotions/smartsoft-price-drop',
                        icon: '',
                        authkey:"showSmartSoftPriceDrop",
                        label: "PROMOTIONS@SmartSoftPriceDropTitle"
                    },
                    {
                        id: '53',
                        url: '/promotions/smartsoft-fly-to-the-top',
                        icon: '',
                        authkey:"showSmartsoftFlyOnTop",
                        label: "PROMOTIONS@SmartSoftFlyOnTop"
                    },
                    {
                        id: '54',
                        url: '/promotions/jili-jackpot-league',
                        icon: '',
                        authkey:"ShowJiliSpinWinLeaguePromo",
                        label: "PROMOTIONS@JiliSpinWinLeague"
                    },
                    {
                        id: '55',
                        url: '/promotions/crazy-prize-drop',
                        icon: '',
                        authkey:"ShowCrazyPrizeDropPromo",
                        label: "PROMOTIONS@EvolutionCrazyPrizeDrop"
                    },
                    {
                        id: '56',
                        url: '/promotions/ipl-jackpot',
                        icon: '',
                        authkey:"showIPLJackpotPromo",
                        label: "PROMOTIONS@IPLJackpotPromo2k25"
                    },
                    {
                        id: '57',
                        url: '/promotions/100-lossback-bonus',
                        icon: '',
                        authkey:"show100LossBackPromo25",
                        label: "PROMOTIONS@HundredLossbackPromo"
                    },
                    {
                        id: '58',
                        url: '/promotions/jili-bonus-spin',
                        icon: '',
                        authkey:"showJiliPlayPatrioticPromo",
                        label: "PROMOTIONS@JiliPlayPatrioticPromo"
                    },
                    {
                        id: '59',
                        url: '/promotions/78th-freedom-flyer',
                        icon: '',
                        authkey:"showFreedomFlyerPromo",
                        label: "PROMOTIONS@FreedomFlyerPromo2k25"
                    },
                    {
                        id: '60',
                        url: '/promotions/twenty-free-spins',
                        icon: '',
                        authkey:"showFreeSpinsPromo",
                        label: "PROMOTIONS@TwentyFreeSpins"
                    },
                    {
                        id: '61',
                        url: '/promotions/aviator-bet-to-win-boost',
                        icon: '',
                        authkey:"ShowAviatorBetToWinBoostPromo",
                        label: "PROMOTIONS@AviatorBetToWinBoost"
                    },
                    {
                        id: '62',
                        url: '/promotions/asiacup-cashback',
                        icon: '',
                        authkey:"showYoloCashbackSixer",
                        label: "PROMOTIONS@YoloCashbackSixer"
                    },
                    {
                        id: '63',
                        url: '/promotions/weekly-leaderboard',
                        icon: '',
                        authkey:"showWeeklyLeaderboard",
                        label: "PROMOTIONS@WeeklyLeaderBoard"
                    },
                    {
                        id: '64',
                        url: '/promotions/super-chicken-rush',
                        icon: '',
                        authkey:"showSuperChickenRushPromo",
                        label: "PROMOTIONS@superChickenRushPromo"
                    },
                    {
                        id: '66',
                        url: '/promotions/surprise-evolution',
                        icon: '',
                        authkey:"showSurpriseDhamakaPromo",
                        label: "PROMOTIONS@SurpriseDhamaka"
                    },
                    {
                        id: '67',
                        url: '/promotions/wbbl',
                        icon: '',
                        authkey:"showWBBLPromo",
                        label: "PROMOTIONS@WBBL"
                    },
                    {
                        id: '68',
                        url: '/promotions/international-league-t20',
                        icon: '',
                        authkey:"showILT20Promo",
                        label: "PROMOTIONS@ILT20Promo"
                    },
                    {
                        id: '71',
                        url: '/promotions/exchange-safety-net',
                        icon: '',
                        authkey:"showHundredSafetyPromo",
                        label: "PROMOTIONS@ExchangeSafetyPromo"
                    },
                    {
                        id: '72',
                        url: '/promotions/aviator-26-free-bets-bonanza',
                        icon: '',
                        authkey:"ShowAviator26FBBPromo",
                        label: "PROMOTIONS@Aviator26FBBPromo"
                    },
                    {
                        id: '73',
                        url: '/promotions/deposit-with-6-win-26x-bonus',
                        icon: '',
                        authkey:"showDeposit6x26xBonusPromo",
                        label: "PROMOTIONS@Deposit6x26xBonusPromo"
                    },
                    {
                        id: '74',
                        url: '/promotions/monday-happy-hours',
                        icon: '',
                        authkey:"showMondayHappyHourPromo",
                        label: "PROMOTIONS@MondayHappyHourPromo"
                    },
                    {
                        id: '75',
                        url: '/promotions/chicken-road',
                        icon: '',
                        authkey:"showChickenRoadPromo",
                        label: "PROMOTIONS@chickenRoadPromo"
                    },
                    {
                        id: '76',
                        url: '/promotions/evolution-live-rewards',
                        icon: '',
                        authkey:"showEvoLiveRewrds2k26Promo",
                        label: "PROMOTIONS@EvoLiveRewrdsPromo"
                    },
                    {
                        id: '77',
                        url: '/promotions/welcome-free-spins',
                        icon: '',
                        authkey:"showWelcomeFreeSpins",
                        label: "PROMOTIONS@WelcomeFreeSpinsPromo"
                    },
                    {
                        id: '78',
                        url: '/promotions/aviator-free-bets-with-ipl-bets',
                        icon: '',
                        authkey:"showAviatorFreeBetsWthIPLBetsPromo",
                        label: "PROMOTIONS@AviatorFreeBetsWthIPLBetsPromo"
                    },
                    {
                        id: '79',
                        url: '/promotions/leaderboard-2026',
                        icon: '',
                        authkey:"showLeaderboard2k26Promo",
                        label: "PROMOTIONS@LeaderboardPromoTitle"
                    },
                    {
                        id: '80',
                        url: '/promotions/free-spins-jili',
                        icon: '',
                        authkey:"showJiliFreeSpinsPromo",
                        label: "PROMOTIONS@jiliFreeSpinsPromo"
                    },
                    {
                        id: '81',
                        url: '/promotions/weekly-deposits',
                        icon: '',
                        authkey:"showWeeklyDesposit",
                        label: "PROMOTIONS@WeeklyDespositPromo"
                    },
                    {
                        id: '82',
                        url: '/promotions/evolution-powerplay-strike',
                        icon: '',
                        authkey:"showEvolutionpPowerPlayPromo",
                        label: "PROMOTIONS@EvoPowerplayStrikePromo"
                    },
                    {
                        id: '83',
                        url: '/promotions/daily-betback',
                        icon: '',
                        authkey:"showDailyBetBackPromo",
                        label: "PROMOTIONS@DailyBetBackPromo"
                    },
                    {
                        id: '84',
                        url: '/promotions/playtech-new-launch-win-big',
                        icon: '',
                        authkey:"showPlaytechNewLaunch",
                        label: "PROMOTIONS@PlaytechNewLaunchPromo"
                    },
                    {
                        id: '85',
                        url: '/promotions/place-9-bets-win-up-to-99x',
                        icon: '',
                        authkey:"showPlace9BetsWinUpTo99X",
                        label: "PROMOTIONS@Place9BetsWinUpTo99XPromo"
                    },
                    {
                        id: '86',
                        url: '/promotions/up-to-100-free-spins-on-ganesh-gold',
                        icon: '',
                        authkey:"show100FreeSpinOnGaneshGold",
                        label: "PROMOTIONS@100FreeSpinOnGaneshGold"
                    }
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@ExploreALL'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm1',
                    url: '/promotions/welcome-bonus',
                    image: 'DROPDOWN_WELCOME_BONUS_NEW.png',
                    label: 'PROMOTIONSTITLE@WELCOME',
                    authkey: "showWelcomeBonus"
                },
                {
                    id: 'rm2',
                    url: '/promotions/refill-bonus',
                    image: 'DROPDOWN_REFILLBONUS_NEW.png',
                    label: 'PROMOTIONSTITLE@REFILL',
                    authkey: "showRefillBonus"
                },
                {
                    id: 'rm3',
                    url: '/promotions/cashback-bonus',
                    image: 'DROPDOWN_CASHBACKBONUS_NEW.png',
                    label: 'PROMOTIONSTITLE@CASHBACK',
                    authkey: "showCashbackBonus"
                }
            ]
        },
    },
    32:{
        casino: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/live-casino/roulette',
                        icon: '',
                        label: 'TITLE@ROULETTESIDEBAR',
                        authkey: 'showRoulette'
                    },
                    {
                        id: '2',
                        url: '/live-casino/blackjack',
                        icon: '',
                        label: 'TITLE@BLACKJACKSIDEBAR',
                        authkey: 'showBlackjack'
                    },
                    {
                        id: '3',
                        url: '/live-casino/baccarat',
                        icon: '',
                        label: 'TITLE@BACCARAT',
                        authkey: 'showBaccarat'
                    },
                    {
                        id: '4',
                        url: '/live-casino/dragon-tiger',
                        icon: '',
                        label: 'TITLE@DRAGON_TIGER',
                        authkey: 'showDragontiger'
                    }
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@ENJOY'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm3',
                    url:'/popular-games',
                    image: 'DROPDOWN_POPULAR.png',
                    label: 'TITLE@populargames'
                },
                {
                    id: 'rm1',
                    url:'/live-casino',
                    image: 'DROPDOWN_CASINO_LIVE_CASINO.png',
                    label: 'TITLE@LIVECASINO',
                    authkey: 'showOnlineCasinoGamesLink'
                },
                {
                    id: 'rm2',
                    url:'/slots',
                    image: 'DROPDOWN_SLOT_BINGO.png',
                    label: 'TITLE@SLOTBINGO'
                }
            
            ]
        },
        instant_games: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/instant-games/smartsoft/plinkox',
                        icon: '',
                        label: "TITLE@Plinko",
                        authkey: "showInstantThumbs"
                    },
                    // {
                    //     id: '2',
                    //     url: '/instant-games/smartsoft/footballx',
                    //     icon: '',
                    //     label: 'TITLE@Footballx',
                    //     authkey: "showInstantThumbs"
                    // },
                    // {
                    //     id: '3',
                    //     url: '/instant-games/smartsoft/balloon',
                    //     icon: '',
                    //     label: 'TITLE@Baloon',
                    //     authkey: "showInstantThumbs"
                    // },
                    {
                        id: '4',
                        url: '/instant-games/inout/chicken-road-2',
                        icon: '',
                        authkey:"showInstantThumbs",
                        label: "TITLE@ChickenRoad2"
                    },
                    {
                        id: '5',
                        url: '/instant-games/galaxsys/ninja-crash',
                        icon: '',
                        authkey:"showInstantThumbs",
                        label: "TITLE@ninjacrush"
                    },
                    
                    {
                        id: '7',
                        url: '/instant-games',
                        icon: '',
                        authkey:"showInstantThumbs",
                        label: "HEADER@VIEWALL"
                    }
                
                
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@ExploreALL'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm1',
                    url: '/instant-games/spribe/aviator',
                    image: 'aviator-instant-cashsite-dropdown.png',
                    label: 'TITLE@AVIATOR',
                    authkey: "showInstantThumbs"
                },
                {
                    id: 'rm2',
                    url: '/instant-games/smartsoft/jetx',
                    image: 'jetx-instant-cashsite-drowpdown.png',
                    label: 'TITLE@JetX',
                    authkey: "showInstantThumbs"
                },
                {
                    id: 'rm3',
                    url: '/instant-games/aviatrix/play-aviatrix',
                    image: 'AviatriXdropdown.png',
                    label: 'GAME@AVIATRIX',
                    authkey: "showInstantThumbs"
                }
            ]
        },
        hotgames: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/live-casino/evolution/monopoly-live',
                        icon: '',
                        label: 'TITLE@MonopolyLive',
                        authkey: 'showTeenpatti'
                    },
                    {
                        id: '2',
                        url: '/live-casino/evolution/funky-time',
                        icon: '',
                        label: 'TITLE@FunkyTimes',
                        authkey: 'showTeenpatti2020'
                    },
                    {
                        id: '3',
                        url: '/live-casino/evolution/lightning-dice',
                        icon: '',
                        label: 'TITLE@LightningDice',
                        authkey: 'showTeenpatti2020'
                    },
                    {
                        id: '4',
                        url: '/live-casino/dragon-tiger',
                        icon: '',
                        label: 'TITLE@DragonTiger',
                        authkey: 'showTeenpatti2020'
                    },
                    {
                        id: '5',
                        url: '/instant-games/smartsoft/cricketx',
                        icon: '',
                        label: 'TITLE@CricketX',
                        authkey: 'showTeenpatti2020'
                    },
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@PLAYANDNEVER'
                    },
                ]
            },
            rightMenu: [
             
                {
                    id: 'rm1',
                    url:'/instant-games/spribe/mines',
                    image: 'spribe-minesdropdown.png',
                    label: 'TITLE@Mines',
                    authkey: 'showTeenpattiLink'
                },
                {
                    id: 'rm2',
                    url:'/live-casino/evolution/crazy-time',
                    image: 'DROPDOWN_CRAZY_TIME.png',
                    label: "TITLE@crazytime",
                    authkey: 'showTeenpattiLink'
                },
                {
                    id: 'rm3',
                    url:'/live-casino/evolution/lightning-roulette',
                    image: 'DROPDOWN_LIGHTNING_ROULETTE.png',
                    label: 'TITLE@LIGHTINGROULETTE',
                    authkey: 'showTeenpattiLink'
                }
               
            ]
        },
        sports: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/betting-exchange/cricket',
                        icon: '',
                        label: 'SPORT@CRICKET',
                        authkey: 'showSportCricket'
                    },
                    {
                        id: '2',
                        url: '/betting-exchange/football',
                        icon: '',
                        label: 'SPORT@FOOTBALL',
                        authkey: 'showSportFootball'
                    },
                    {
                        id: '3',
                        url: '/betting-exchange/tennis',
                        icon: '',
                        label: 'SPORT@TENNIS',
                        authkey: 'showSportTennis'
                    },
                    // {
                    //     id: '4',
                    //     url: '/betting-exchange/volleyball',
                    //     icon: '',
                    //     label: 'SPORT@VolleyBall',
                    //     authkey: 'showSportVolleyball'
                    // },
                    // {
                    //     id: '5',
                    //     url: '/virtualSports/vci',
                    //     icon: '',
                    //     label: 'TITLE@VIRTUALSPORTS',
                    //     authkey: 'showVirtualSportsvfec'
                    // },
                    {
                        id: '6',
                        url: '/sports/tournaments/',
                        icon: '',
                        label: 'TITLE@Tournaments',
                        authkey: 'showTournaments'
                    },
                    // {
                    //     id: '7',
                    //     url: '/saba-sports',
                    //     icon: '',
                    //     label: 'TITLE@SabaSports',
                    //     authkey: 'showSabaSportsStatement'
                    // }
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@GOONTURN'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm1',
                    url:'/betting-exchange',
                    image: 'DROPDOWN_EXCHANGE_NEW.png',
                    label: 'TITLE@EXCHANGE',
                    authkey: 'showExchangeLink',
                    itemsCount: '5'
                },
                // {
                //     id: 'rm5',
                //     url:'/premium-sportsbook/kabaddi-betting',
                //     image: 'kabbadiYolo.png',
                //     label: 'MENU@Kabbadi',
                //     authkey: 'showProKabbadi',
                //     itemsCount: '5'
                // },
                {
                    id: 'rm2',
                    url:'/premium-sportsbook',
                    image: 'premiumSportsbookDropdownYolo1.png',
                    label: 'TITLE@PREMIUM_SPORTSBOOK',
                    authkey: 'showPremiumSportsLink',
                    itemsCount: '5'
                },
                {
                    id: 'rm3',
                    url:'/sportsbook',
                    image: 'DROPDOWN_SPORTSBOOK_NEW.png',
                    label: 'MENU@SPORTBOOK',
                    authkey: 'showSportBookLink',
                    itemsCount: '5'
                },
                {
                    id: 'rm4',
                    url:'/saba-sports',
                    image: 'YoloSabaDesk.png',
                    label: 'TITLE@SabaSports',
                    authkey: 'showSabaSportsStatement',
                    itemsCount: '5'
                },
                // {
                //     id: 'rm4',
                //     url:'/virtualSports/vci',
                //     image: 'virtualSportsDesktopDropdown.png',
                //     label: 'GAME@VIRTUALSPORTS',
                //     authkey: 'showVirtualSportsvfel'
                // },
            ]
        },
        promotions: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/promotions/welcome-bonus',
                        icon: '',
                        label: "PROMOTIONSTITLE@WELCOME"
                    },
                    {
                        id: '2',
                        url: '/promotions/refill-bonus',
                        icon: '',
                        label: 'PROMOTIONSTITLE@REFILL',
                        authkey: "showRefillBonus"
                    },
                    {
                        id: '3',
                        url: '/promotions/cashback-bonus',
                        icon: '',
                        label: 'PROMOTIONSTITLE@CASHBACK',
                        authkey: "showCashbackBonus"
                    },
                    {
                        id: '4',
                        url: '/promotions/referral-bonus',
                        icon: '',
                        authkey:"showReferralBonus",
                        label: "ProBonus@Referral"
                    },   
                    {
                        id: '5',
                        url: '/promotions/big-bash',
                        icon: '',
                        authkey:"showBBLBonus",
                        label: "PROMOTIONS@BBLBonus"
                    },
                    {
                        id: '6',
                        url: '/promotions/arjith_promo',
                        icon: '',
                        authkey:"showSingWithYolo",
                        label: "PROMOTIONS@singYolo"
                    },
                    {
                        id: '7',
                        url: '/promotions/jetx-tournament',
                        icon: '',
                        authkey:"jetxpromo",                                 
                        label:"jetx"
                    },
                    {
                        id: '8',
                        url: '/promotions/crazyCrash',
                        icon: '',
                        authkey:"showCrazyCrashPromo",
                        label:"PROMOTIONS@crazyCrashPromo"
                    },
                    {   id: '9',
                        url: '/promotions/aviator-bonus',
                        icon: '',
                        authkey:"showAviatorBonus",
                        label:"PROMOTIONS@AviatorBonus"
                    },   
                    {
                        id: '10',
                        url: '/promotions/evolution-first-bet',
                        icon: '',
                        authkey:"showEvolutionpromo",
                        label: "PROMOTIONS@firstperson"
                    },
                    {
                        id: '11',
                        url: '/promotions/funkytime',
                        icon: '',
                        authkey:"showFunkytimePromo",
                        label: "PROMOTIONS@funkytime"
                    },
                    {
                        id: '15',
                        url: '/promotions/evo-baccarat',
                        icon: '',
                        authkey:"showEvoCasinoCupPromo",
                        label: "PROMOTIONS@EvoCasinoCupPromo"
                    },
                    
                    {
                        id: '12',
                        url: '/promotions/worldcup-cashback-bonanza',
                        icon: '',
                        authkey:"showWCBonusPromo",
                        label: "PROMOTIONS@WCCBONAZA"
                    },
                    {
                        id: '13',
                        url: '/promotions/platinum-rush',
                        icon: '',
                        authkey:"showPlatinumRush",
                        label: "PROMOTIONS@Platinumrush"
                    },
                    {
                        id: '14',
                        url: '/promotions/worldcup-betboost',
                        icon: '',
                        authkey:"showWCBonusPromo",
                        label: "TITLE@wcbetboost"
                    },
                    {
                        id: '15',
                        url: '/promotions/catch99-s2',
                        icon: '',
                        authkey:"showCatch99Bonus",
                        label: "PROMOTIONS@CATCH99"
                    },
                    // {
                    //     id: '16',
                    //     url: '/promotions/evolution-crazy-pachinko',
                    //     icon: '',
                    //     authkey:"showCrazyPachinkoPromo",
                    //     label: "TITLE@EvoCrazyPachinko"
                    // },
                    {
                        id: '17',
                        url: '/promotions/jetx-celestial-rush',
                        icon: '',
                        authkey:"showJetXCelestialRush",
                        label: "PROMOTIONS@JetxCelestial"
                    },
                    {
                        id: '18',
                        url: '/promotions/aviatrix-double-dhamaka',
                        icon: '',
                        authkey:"showAviatrixPromo",
                        label: "PROMOTIONS@AviatrixDoubleDhamaka"
                    },
                    {
                        id: '19',
                        url: '/promotions/cricket-cashback-marathon',
                        icon: '',
                        authkey:"showcircketCashbackMarathon",
                        label: "PROMOTIONS@CricketCashbackMarathon"
                    },
                    {
                        id: '20',
                        url: '/promotions/crazytime-epic-bonanza',
                        icon: '',
                        authkey:"showCrazyTimePromo",
                        label: "PROMOTIONS@CrazyTimeEpicBonanza"
                    },
                    {
                        id: '21',
                        url: '/promotions/aviator-high-flyer',
                        icon: '',
                        authkey:"showAviatorHighFlyerPromo",
                        label: "PROMOTIONS@AviatorHighFlyer"
                    },
                    {
                        id: '22',
                        url: '/promotions/smartsoft-spin-and-win',
                        icon: '',
                        authkey:"showSmartsoft",
                        label: "PROMOTIONS@Smartsoft"
                    },



                    {
                        id: '23',
                        url: '/promotions/evolution-casino-cup',
                        icon: '',
                        authkey:"showEvolutionCasionCup",
                        label: "PROMOTIONS@EvolutionCasionCup"
                    },




                    {
                        id: '24',
                        url: '/promotions/IPL-Betting-dhamaka-Power-Play-Bonus',
                        icon: '',
                        authkey:"shoeIPLpowerPlay",
                        label: "PROMOTIONS@IPLPOWERPLAY1"
                    },



                    {
                        id: '25',
                        url: '/promotions/indian-galaxsys-league',
                        icon: '',
                        authkey:"showIndianGalaxysLeague",
                        label: "PROMOTIONS@IndianGalaxsysLeague"
                    },
                   
                    

                        {
                        id: '26',
                        url: '/promotions/ipl-betting-dhamaka',
                        icon: '',
                        authkey:"showIplPromo",
                        label: "PROMOTIONS@iplmatka"},



                        {
                            id: '27',
                            url: '/promotions/double-cashback',
                            icon: '',
                            authkey:"showDoubleCashBack",
                            label: "PROMOTIONS@DoubleCashback"
                        },


                        {
                        id: '28',
                        url: '/promotions/aviator-sky-bound-miles',
                        icon: '',
                        authkey:"showAviatorSkyBoundMiles",
                        label: "PROMOTIONS@AviatorSkyBoundMiles"
                    },
                    {
                        id: '29',
                        url: '/promotions/wc-lossback',
                        icon: '',
                        authkey:"showWorldCupLossbackYolo",
                        label: "PROMOTIONS@WorldCupLossbackBonus"
                    },
                    {
                        id: '30',
                        url: '/promotions/wc-doubleCashback',
                        icon: '',
                        authkey:"showWorldCupDoubleCashbackBonus",
                        label: "PROMOTIONS@WorldCupDailyDepositBonus"
                    },
                    {
                        id: '31',
                        url: '/promotions/wc-evolutionCasinoCup',
                        icon: '',
                        authkey:"showWorldCupEvolutionCasinoCup",
                        label: "PROMOTIONS@WorldCupEvolutionCasinoCupBonus"
                    },
                    {
                        id: '34',
                        url: '/promotions/smartsoft-spin-and-win',
                        icon: '',
                        authkey:"showSmartSoftJetxCelestial",
                        label: "PROMOTIONS@SmartSoftJetxCelestial"
                    },
                    {
                        id: '35',
                        url: '/promotions/mines-legend-trophy',
                        icon: '',
                        authkey:"showMinesLegendTrophyPromo",
                        label: "PROMOTIONS@MinesLegendTrophy"
                    },
                    {
                        id: '36',
                        url: '/promotions/caribbean-premier-league',
                        icon: '',
                        authkey:"showCaribbeanLeagueBonusPromo",
                        label: "PROMOTIONS@CaribbeanLeagueBonus"
                    },
                    {
                        id: '37',
                        url: '/promotions/evolution-roulette-cup',
                        icon: '',
                        authkey:"showEvolutionRouletteCupPromo",
                        label: "PROMOTIONS@EvolutionRouletteCup"
                    },
                    {
                        id: '38',
                        url: '/promotions/aviatrix-fly-and-play',
                        icon: '',
                        authkey:"showAviatrixFlyAndPlayPromo",
                        label: "PROMOTIONS@AviatrixFlyAndPlay"
                    },
                    {
                        id: '39',
                        url: '/promotions/aviatrix-jet-to-cash',
                        icon: '',
                        authkey:"showAviatrixJetToCrash",
                        label: "PROMOTIONS@AviatrixJetToCrash"
                    },
                    {
                        id: '40',
                        url: '/promotions/aviator-rain',
                        icon: '',
                        authkey:"showAviatorRainPromo",
                        label: "PROMOTIONS@AviatorRainPromo"
                    },
                    {
                        id: '41',
                        url: '/promotions/jet-set-with-jetx',
                        icon: '',
                        authkey:"showJetSetWithJetXPromo",
                        label: "PROMOTIONS@JetSetWithJetX"
                    },
                    {
                        id: '42',
                        url: '/promotions/womens-world-cup',
                        icon: '',
                        authkey:"showWomensWorldCupPromo",
                        label: "PROMOTIONS@WomensWorldCup"
                    },
                    {
                        id: '43',
                        url: '/promotions/big-bash-big-cash',
                        icon: '',
                        authkey:"showBigBashBigCashPromo",
                        label: "PROMOTIONS@BigBashBigCash"
                    },
                    {
                        id: '44',
                        url: '/promotions/the-live-jackpot',
                        icon: '',
                        authkey:"showLiveJackPot2025Promo",
                        label: "PROMOTIONS@LiveJackPot2025"
                    },
                    {
                        id: '45',
                        url: '/promotions/instant-challenge-2025',
                        icon: '',
                        authkey:"showInstantChallengePromo",
                        label: "PROMOTIONS@InstantChallengePromo"
                    },
                    {
                        id: '46',
                        url: '/promotions/super-slots-challenge',
                        icon: '',
                        authkey:"showSuperSlotsChallengePromo",
                        label: "PROMOTIONS@SuperSlotsChallenge"
                    },
                    {
                        id: '47',
                        url: '/promotions/icc-champions-trophy',
                        icon: '',
                        authkey:"showChampionsTrophyPromo",
                        label: "PROMOTIONS@ChampionsTrophy"
                    },
                    {
                        id: '49',
                        url: '/promotions/daily-leaderboard',
                        icon: '',
                        authkey:"showDailyLeaderboard",
                        label: "PROMOTIONS@DailyLeaderBoard"
                    },
                    {
                        id: '50',
                        url: '/promotions/aviatrix-sky-high-challenge',
                        icon: '',
                        authkey:"showAviatrixSkyHighChallengePromo",
                        label: "PROMOTIONS@AviatrixSKYHighChallenge"
                    },
                    {
                        id: '51',
                        url: '/promotions/lightning-cashback',
                        icon: '',
                        authkey:"showLightningCashback2k25",
                        label: "PROMOTIONS@LightningCashback2k25"
                    },
                    {
                        id: '52',
                        url: '/promotions/galaxsys-tournament',
                        icon: '',
                        authkey:"showGalaxsysTournament",
                        label: "PROMOTIONS@GalaxsysTournamentPromo"
                    },
                    {
                        id: '53',
                        url: '/promotions/smartsoft-price-drop',
                        icon: '',
                        authkey:"showSmartSoftPriceDrop",
                        label: "PROMOTIONS@SmartSoftPriceDropTitle"
                    },
                    {
                        id: '53',
                        url: '/promotions/smartsoft-fly-to-the-top',
                        icon: '',
                        authkey:"showSmartsoftFlyOnTop",
                        label: "PROMOTIONS@SmartSoftFlyOnTop"
                    },
                    {
                        id: '54',
                        url: '/promotions/jili-jackpot-league',
                        icon: '',
                        authkey:"ShowJiliSpinWinLeaguePromo",
                        label: "PROMOTIONS@JiliSpinWinLeague"
                    },
                    {
                        id: '55',
                        url: '/promotions/crazy-prize-drop',
                        icon: '',
                        authkey:"ShowCrazyPrizeDropPromo",
                        label: "PROMOTIONS@EvolutionCrazyPrizeDrop"
                    },
                    {
                        id: '56',
                        url: '/promotions/ipl-jackpot',
                        icon: '',
                        authkey:"showIPLJackpotPromo",
                        label: "PROMOTIONS@IPLJackpotPromo2k25"
                    },
                    {
                        id: '57',
                        url: '/promotions/100-lossback-bonus',
                        icon: '',
                        authkey:"show100LossBackPromo25",
                        label: "PROMOTIONS@HundredLossbackPromo"
                    },
                    {
                        id: '58',
                        url: '/promotions/jili-bonus-spin',
                        icon: '',
                        authkey:"showJiliPlayPatrioticPromo",
                        label: "PROMOTIONS@JiliPlayPatrioticPromo"
                    },
                    {
                        id: '59',
                        url: '/promotions/78th-freedom-flyer',
                        icon: '',
                        authkey:"showFreedomFlyerPromo",
                        label: "PROMOTIONS@FreedomFlyerPromo2k25"
                    },
                    {
                        id: '60',
                        url: '/promotions/twenty-free-spins',
                        icon: '',
                        authkey:"showFreeSpinsPromo",
                        label: "PROMOTIONS@TwentyFreeSpins"
                    },
                    {
                        id: '61',
                        url: '/promotions/aviator-bet-to-win-boost',
                        icon: '',
                        authkey:"ShowAviatorBetToWinBoostPromo",
                        label: "PROMOTIONS@AviatorBetToWinBoost"
                    },
                    {
                        id: '62',
                        url: '/promotions/asiacup-cashback',
                        icon: '',
                        authkey:"showYoloCashbackSixer",
                        label: "PROMOTIONS@YoloCashbackSixer"
                    },
                    {
                        id: '63',
                        url: '/promotions/weekly-leaderboard',
                        icon: '',
                        authkey:"showWeeklyLeaderboard",
                        label: "PROMOTIONS@WeeklyLeaderBoard"
                    },
                    {
                        id: '64',
                        url: '/promotions/super-chicken-rush',
                        icon: '',
                        authkey:"showSuperChickenRushPromo",
                        label: "PROMOTIONS@superChickenRushPromo"
                    },
                    {
                        id: '66',
                        url: '/promotions/surprise-evolution',
                        icon: '',
                        authkey:"showSurpriseDhamakaPromo",
                        label: "PROMOTIONS@SurpriseDhamaka"
                    },
                    {
                        id: '67',
                        url: '/promotions/wbbl',
                        icon: '',
                        authkey:"showWBBLPromo",
                        label: "PROMOTIONS@WBBL"
                    },
                    {
                        id: '68',
                        url: '/promotions/international-league-t20',
                        icon: '',
                        authkey:"showILT20Promo",
                        label: "PROMOTIONS@ILT20Promo"
                    },
                    {
                        id: '71',
                        url: '/promotions/exchange-safety-net',
                        icon: '',
                        authkey:"showHundredSafetyPromo",
                        label: "PROMOTIONS@ExchangeSafetyPromo"
                    },
                    {
                        id: '72',
                        url: '/promotions/aviator-26-free-bets-bonanza',
                        icon: '',
                        authkey:"ShowAviator26FBBPromo",
                        label: "PROMOTIONS@Aviator26FBBPromo"
                    },
                    {
                        id: '73',
                        url: '/promotions/deposit-with-6-win-26x-bonus',
                        icon: '',
                        authkey:"showDeposit6x26xBonusPromo",
                        label: "PROMOTIONS@Deposit6x26xBonusPromo"
                    },
                    {
                        id: '74',
                        url: '/promotions/monday-happy-hours',
                        icon: '',
                        authkey:"showMondayHappyHourPromo",
                        label: "PROMOTIONS@MondayHappyHourPromo"
                    },
                    {
                        id: '75',
                        url: '/promotions/chicken-road',
                        icon: '',
                        authkey:"showChickenRoadPromo",
                        label: "PROMOTIONS@chickenRoadPromo"
                    },
                    {
                        id: '76',
                        url: '/promotions/evolution-live-rewards',
                        icon: '',
                        authkey:"showEvoLiveRewrds2k26Promo",
                        label: "PROMOTIONS@EvoLiveRewrdsPromo"
                    },
                    {
                        id: '77',
                        url: '/promotions/welcome-free-spins',
                        icon: '',
                        authkey:"showWelcomeFreeSpins",
                        label: "PROMOTIONS@WelcomeFreeSpinsPromo"
                    },
                    {
                        id: '78',
                        url: '/promotions/aviator-free-bets-with-ipl-bets',
                        icon: '',
                        authkey:"showAviatorFreeBetsWthIPLBetsPromo",
                        label: "PROMOTIONS@AviatorFreeBetsWthIPLBetsPromo"
                    },
                    {
                        id: '79',
                        url: '/promotions/leaderboard-2026',
                        icon: '',
                        authkey:"showLeaderboard2k26Promo",
                        label: "PROMOTIONS@LeaderboardPromoTitle"
                    },
                    {
                        id: '80',
                        url: '/promotions/free-spins-jili',
                        icon: '',
                        authkey:"showJiliFreeSpinsPromo",
                        label: "PROMOTIONS@jiliFreeSpinsPromo"
                    },
                    {
                        id: '81',
                        url: '/promotions/weekly-deposits',
                        icon: '',
                        authkey:"showWeeklyDesposit",
                        label: "PROMOTIONS@WeeklyDespositPromo"
                    },
                    {
                        id: '82',
                        url: '/promotions/evolution-powerplay-strike',
                        icon: '',
                        authkey:"showEvolutionpPowerPlayPromo",
                        label: "PROMOTIONS@EvoPowerplayStrikePromo"
                    },
                    {
                        id: '83',
                        url: '/promotions/daily-betback',
                        icon: '',
                        authkey:"showDailyBetBackPromo",
                        label: "PROMOTIONS@DailyBetBackPromo"
                    },
                    {
                        id: '84',
                        url: '/promotions/playtech-new-launch-win-big',
                        icon: '',
                        authkey:"showPlaytechNewLaunch",
                        label: "PROMOTIONS@PlaytechNewLaunchPromo"
                    },
                    {
                        id: '85',
                        url: '/promotions/place-9-bets-win-up-to-99x',
                        icon: '',
                        authkey:"showPlace9BetsWinUpTo99X",
                        label: "PROMOTIONS@Place9BetsWinUpTo99XPromo"
                    },
                    {
                        id: '86',
                        url: '/promotions/up-to-100-free-spins-on-ganesh-gold',
                        icon: '',
                        authkey:"show100FreeSpinOnGaneshGold",
                        label: "PROMOTIONS@100FreeSpinOnGaneshGold"
                    }
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@ExploreALL'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm1',
                    url: '/promotions/welcome-bonus',
                    image: 'DROPDOWN_WELCOME_BONUS_NEW.png',
                    label: 'PROMOTIONSTITLE@WELCOME',
                    authkey: "showWelcomeBonus"
                },
                {
                    id: 'rm2',
                    url: '/promotions/refill-bonus',
                    image: 'DROPDOWN_REFILLBONUS_NEW.png',
                    label: 'PROMOTIONSTITLE@REFILL',
                    authkey: "showRefillBonus"
                },
                {
                    id: 'rm3',
                    url: '/promotions/cashback-bonus',
                    image: 'DROPDOWN_CASHBACKBONUS_NEW.png',
                    label: 'PROMOTIONSTITLE@CASHBACK',
                    authkey: "showCashbackBonus"
                }
            ]
        },
    },
    33:{
        casino: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/live-casino/roulette',
                        icon: '',
                        label: 'TITLE@ROULETTESIDEBAR',
                        authkey: 'showRoulette'
                    },
                    {
                        id: '2',
                        url: '/live-casino/blackjack',
                        icon: '',
                        label: 'TITLE@BLACKJACKSIDEBAR',
                        authkey: 'showBlackjack'
                    },
                    {
                        id: '3',
                        url: '/live-casino/baccarat',
                        icon: '',
                        label: 'TITLE@BACCARAT',
                        authkey: 'showBaccarat'
                    },
                    {
                        id: '4',
                        url: '/live-casino/dragon-tiger',
                        icon: '',
                        label: 'TITLE@DRAGON_TIGER',
                        authkey: 'showDragontiger'
                    }
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@ENJOY'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm3',
                    url:'/popular-games',
                    image: 'DROPDOWN_POPULAR.png',
                    label: 'TITLE@populargames'
                },
                {
                    id: 'rm1',
                    url:'/live-casino',
                    image: 'DROPDOWN_CASINO_LIVE_CASINO.png',
                    label: 'TITLE@LIVECASINO',
                    authkey: 'showOnlineCasinoGamesLink'
                },
                {
                    id: 'rm2',
                    url:'/slots',
                    image: 'DROPDOWN_SLOT_BINGO.png',
                    label: 'TITLE@SLOTBINGO'
                }
            
            ]
        },
        instant_games: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/instant-games/smartsoft/plinkox',
                        icon: '',
                        label: "TITLE@Plinko",
                        authkey: "showInstantThumbs"
                    },
                    // {
                    //     id: '2',
                    //     url: '/instant-games/smartsoft/footballx',
                    //     icon: '',
                    //     label: 'TITLE@Footballx',
                    //     authkey: "showInstantThumbs"
                    // },
                    // {
                    //     id: '3',
                    //     url: '/instant-games/smartsoft/balloon',
                    //     icon: '',
                    //     label: 'TITLE@Baloon',
                    //     authkey: "showInstantThumbs"
                    // },
                    {
                        id: '4',
                        url: '/instant-games/inout/chicken-road-2',
                        icon: '',
                        authkey:"showInstantThumbs",
                        label: "TITLE@ChickenRoad2"
                    },
                    {
                        id: '5',
                        url: '/instant-games/galaxsys/ninja-crash',
                        icon: '',
                        authkey:"showInstantThumbs",
                        label: "TITLE@ninjacrush"
                    },
                   
                    {
                        id: '7',
                        url: '/instant-games',
                        icon: '',
                        authkey:"showInstantThumbs",
                        label: "HEADER@VIEWALL"
                    },
                
                
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@ExploreALL'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm1',
                    url: '/instant-games/spribe/aviator',
                    image: 'aviator-instant-cashsite-dropdown.png',
                    label: 'TITLE@AVIATOR',
                    authkey: "showInstantThumbs"
                },
                {
                    id: 'rm2',
                    url: '/instant-games/smartsoft/jetx',
                    image: 'jetx-instant-cashsite-drowpdown.png',
                    label: 'TITLE@JetX',
                    authkey: "showInstantThumbs"
                },
                {
                    id: 'rm3',
                    url: '/instant-games/aviatrix/play-aviatrix',
                    image: 'AviatriXdropdown.png',
                    label: 'GAME@AVIATRIX',
                    authkey: "showInstantThumbs"
                }
            ]
        },
        hotgames: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/live-casino/evolution/monopoly-live',
                        icon: '',
                        label: 'TITLE@MonopolyLive',
                        authkey: 'showTeenpatti'
                    },
                    {
                        id: '2',
                        url: '/live-casino/evolution/funky-time',
                        icon: '',
                        label: 'TITLE@FunkyTimes',
                        authkey: 'showTeenpatti2020'
                    },
                    {
                        id: '3',
                        url: '/live-casino/evolution/lightning-dice',
                        icon: '',
                        label: 'TITLE@LightningDice',
                        authkey: 'showTeenpatti2020'
                    },
                    {
                        id: '4',
                        url: '/live-casino/dragon-tiger',
                        icon: '',
                        label: 'TITLE@DragonTiger',
                        authkey: 'showTeenpatti2020'
                    },
                    {
                        id: '5',
                        url: '/instant-games/smartsoft/cricketx',
                        icon: '',
                        label: 'TITLE@CricketX',
                        authkey: 'showTeenpatti2020'
                    },
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@PLAYANDNEVER'
                    },
                ]
            },
            rightMenu: [
                
                {
                    id: 'rm1',
                    url:'/instant-games/spribe/mines',
                    image: 'spribe-minesdropdown.png',
                    label: 'TITLE@Mines',
                    authkey: 'showTeenpattiLink'
                },
                {
                    id: 'rm2',
                    url:'/live-casino/evolution/crazy-time',
                    image: 'DROPDOWN_CRAZY_TIME.png',
                    label: "TITLE@crazytime",
                    authkey: 'showTeenpattiLink'
                },
                {
                    id: 'rm3',
                    url:'/live-casino/evolution/lightning-roulette',
                    image: 'DROPDOWN_LIGHTNING_ROULETTE.png',
                    label: 'TITLE@LIGHTINGROULETTE',
                    authkey: 'showTeenpattiLink'
                }
               
            ]
        },
        sports: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/betting-exchange/cricket',
                        icon: '',
                        label: 'SPORT@CRICKET',
                        authkey: 'showSportCricket'
                    },
                    {
                        id: '2',
                        url: '/betting-exchange/football',
                        icon: '',
                        label: 'SPORT@FOOTBALL',
                        authkey: 'showSportFootball'
                    },
                    {
                        id: '3',
                        url: '/betting-exchange/tennis',
                        icon: '',
                        label: 'SPORT@TENNIS',
                        authkey: 'showSportTennis'
                    },
                    // {
                    //     id: '4',
                    //     url: '/betting-exchange/volleyball',
                    //     icon: '',
                    //     label: 'SPORT@VolleyBall',
                    //     authkey: 'showSportVolleyball'
                    // },
                    // {
                    //     id: '5',
                    //     url: '/virtualSports/vci',
                    //     icon: '',
                    //     label: 'TITLE@VIRTUALSPORTS',
                    //     authkey: 'showVirtualSportsvfec'
                    // },
                    // {
                    //     id: '6',
                    //     url: '/saba-sports',
                    //     icon: '',
                    //     label: 'TITLE@SabaSports',
                    //     authkey: 'showSabaSportsStatement'
                    // }
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@GOONTURN'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm1',
                    url:'/betting-exchange',
                    image: 'ExchangeDropdownBA.png',
                    label: 'TITLE@EXCHANGE',
                    authkey: 'showExchangeLink',
                    itemsCount: '5'
                },
                // {
                //     id: 'rm5',
                //     url:'/premium-sportsbook/kabaddi-betting',
                //     image: 'kabbadiIw247.png',
                //     label: 'MENU@Kabbadi',
                //     authkey: 'showProKabbadi',
                //     itemsCount: '5'
                // },
                {
                    id: 'rm2',
                    url:'/premium-sportsbook',
                    image: 'premiumSportsbookDropdownBetdaily.png',
                    label: 'TITLE@PREMIUM_SPORTSBOOK',
                    authkey: 'showPremiumSportsLink',
                    itemsCount: '5'
                },
                {
                    id: 'rm3',
                    url:'/sportsbook',
                    image: 'DROPDOWN_SPORTSBOOK_NEW.png',
                    label: 'MENU@SPORTBOOK',
                    authkey: 'showSportBookLink',
                    itemsCount: '5'
                },
                {
                    id: 'rm4',
                    url:'/saba-sports',
                    image: 'BaaziSabaDesk.png',
                    label: 'TITLE@SabaSports',
                    authkey: 'showSabaSportsStatement',
                    itemsCount: '5'
                },
                // {
                //     id: 'rm4',
                //     url:'/virtualSports/vci',
                //     image: 'virtualSportsDesktopDropdown.png',
                //     label: 'GAME@VIRTUALSPORTS',
                //     authkey: 'showVirtualSportsvfel'
                // },
            ]
        },
        promotions: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/promotions/welcome-bonus',
                        icon: '',
                        label: "PROMOTIONSTITLE@WELCOME"
                    },
                    {
                        id: '2',
                        url: '/promotions/refill-bonus',
                        icon: '',
                        label: 'PROMOTIONSTITLE@REFILL',
                        authkey: "showRefillBonus"
                    },
                    {
                        id: '3',
                        url: '/promotions/cashback-bonus',
                        icon: '',
                        label: 'PROMOTIONSTITLE@CASHBACK',
                        authkey: "showCashbackBonus"
                    },
                    {
                        id: '4',
                        url: '/promotions/referral-bonus',
                        icon: '',
                        authkey:"showReferralBonus",
                        label: "ProBonus@Referral"
                    },   
                    {
                        id: '5',
                        url: '/promotions/big-bash',
                        icon: '',
                        authkey:"showBBLBonus",
                        label: "PROMOTIONS@BBLBonus"
                    },
                    {
                        id: '6',
                        url: '/promotions/arjith_promo',
                        icon: '',
                        authkey:"showSingWithYolo",
                        label: "PROMOTIONS@singYolo"
                    },
                    {
                        id: '7',
                        url: '/promotions/jetx-tournament',
                        icon: '',
                        authkey:"jetxpromo",                                 
                        label:"jetx"
                    },
                    {
                        id: '8',
                        url: '/promotions/crazyCrash',
                        icon: '',
                        authkey:"showCrazyCrashPromo",
                        label:"PROMOTIONS@crazyCrashPromo"
                    },
                    {   id: '9',
                        url: '/promotions/aviator-bonus',
                        icon: '',
                        authkey:"showAviatorBonus",
                        label:"PROMOTIONS@AviatorBonus"
                    },   
                    {
                        id: '10',
                        url: '/promotions/evolution-first-bet',
                        icon: '',
                        authkey:"showEvolutionpromo",
                        label: "PROMOTIONS@firstperson"
                    },
                    {
                        id: '11',
                        url: '/promotions/funkytime',
                        icon: '',
                        authkey:"showFunkytimePromo",
                        label: "PROMOTIONS@funkytime"
                    },
                    {
                        id: '12',
                        url: '/promotions/evo-baccarat',
                        icon: '',
                        authkey:"showEvoCasinoCupPromo",
                        label: "PROMOTIONS@EvoCasinoCupPromo",
                    },
                    {
                        id: '13',
                        url: '/promotions/worldcup-cashback-bonanza',
                        icon: '',
                        authkey:"showWCBonusPromo",
                        label: "PROMOTIONS@WCCBONAZA"
                    },
                    {
                        id: '14',
                        url: '/promotions/platinum-rush',
                        icon: '',
                        authkey:"showPlatinumRush",
                        label: "PROMOTIONS@Platinumrush"
                    },
                    {
                        id: '15',
                        url: '/promotions/worldcup-betboost',
                        icon: '',
                        authkey:"showWCBonusPromo",
                        label: "TITLE@wcbetboost"
                    },
                    // {
                    //     id: '15',
                    //     url: '/promotions/evolution-crazy-pachinko',
                    //     icon: '',
                    //     authkey:"showCrazyPachinkoPromo",
                    //     label: "TITLE@EvoCrazyPachinko"
                    // },
                    {
                        id: '16',
                        url: '/promotions/jetx-celestial-rush',
                        icon: '',
                        authkey:"showJetXCelestialRush",
                        label: "PROMOTIONS@JetxCelestial"
                    },
                    {
                        id: '17',
                        url: '/promotions/aviatrix-double-dhamaka',
                        icon: '',
                        authkey:"showAviatrixPromo",
                        label: "PROMOTIONS@AviatrixDoubleDhamaka"
                    },
                    {
                        id: '18',
                        url: '/promotions/cricket-cashback-marathon',
                        icon: '',
                        authkey:"showcircketCashbackMarathon",
                        label: "PROMOTIONS@CricketCashbackMarathon"
                    },
                    {
                        id: '19',
                        url: '/promotions/crazytime-epic-bonanza',
                        icon: '',
                        authkey:"showCrazyTimePromo",
                        label: "PROMOTIONS@CrazyTimeEpicBonanza"
                    },
                    {
                        id: '20',
                        url: '/promotions/aviator-high-flyer',
                        icon: '',
                        authkey:"showAviatorHighFlyerPromo",
                        label: "PROMOTIONS@AviatorHighFlyer"
                    },
                    {
                        id: '22',
                        url: '/promotions/smartsoft-spin-and-win',
                        icon: '',
                        authkey:"showSmartsoft",
                        label: "PROMOTIONS@Smartsoft"
                    },

                    {
                        id: '23',
                        url: '/promotions/evolution-casino-cup',
                        icon: '',
                        authkey:"showEvolutionCasionCup",
                        label: "PROMOTIONS@EvolutionCasionCup"
                    },




                    {
                        id: '24',
                        url: '/promotions/IPL-Betting-dhamaka-Power-Play-Bonus',
                        icon: '',
                        authkey:"shoeIPLpowerPlay",
                        label: "PROMOTIONS@IPLPOWERPLAY1"
                    },



                    {
                        id: '25',
                        url: '/promotions/indian-galaxsys-league',
                        icon: '',
                        authkey:"showIndianGalaxysLeague",
                        label: "PROMOTIONS@IndianGalaxsysLeague"
                    },
                   
                    



                        {
                        id: '26',
                        url: '/promotions/ipl-betting-dhamaka',
                        icon: '',
                        authkey:"showIplPromo",
                        label: "PROMOTIONS@iplmatka"},



                        {
                            id: '27',
                            url: '/promotions/double-cashback',
                            icon: '',
                            authkey:"showDoubleCashBack",
                            label: "PROMOTIONS@DoubleCashback"
                        },


                        {
                        id: '28',
                        url: '/promotions/aviatrix-free-bets-extravaganza',
                        icon: '',
                        authkey:"showAviatrixFBEPromo",
                        label: "PROMOTIONS@AviatrixFBE"
                    },
                    {
                        id: '30',
                        url: '/promotions/evolution-casino-tourney',
                        icon: '',
                        authkey:"showEvolutionCasinoTourneyBazzi",
                        label: "PROMOTIONS@EvolutionCasinoTourneyBazzi"
                    },
                    {
                        id: '31',
                        url: '/promotions/daily-rewards',
                        icon: '',
                        authkey:"showDailyRewardsBazzi",
                        label: "PROMOTIONS@DailyRewardsBazzi"
                    },
                    {
                        id: '34',
                        url: '/promotions/smartsoft-spin-and-win',
                        icon: '',
                        authkey:"showSmartSoftJetxCelestial",
                        label: "PROMOTIONS@SmartSoftJetxCelestial"
                    },
                    {
                        id: '35',
                        url: '/promotions/caribbean-premier-league',
                        icon: '',
                        authkey:"showCaribbeanLeagueBonusPromo",
                        label: "PROMOTIONS@CaribbeanLeagueBonus"
                    },
                    {
                        id: '38',
                        url: '/promotions/aviatrix-fly-and-play',
                        icon: '',
                        authkey:"showAviatrixFlyAndPlayPromo",
                        label: "PROMOTIONS@AviatrixFlyAndPlay"
                    },
                    {
                        id: '39',
                        url: '/promotions/aviatrix-jet-to-cash',
                        icon: '',
                        authkey:"showAviatrixJetToCrash",
                        label: "PROMOTIONS@AviatrixJetToCrash"
                    },
                    {
                        id: '40',
                        url: '/promotions/jet-set-with-jetx',
                        icon: '',
                        authkey:"showJetSetWithJetXPromo",
                        label: "PROMOTIONS@JetSetWithJetX"
                    },
                    {
                        id: '41',
                        url: '/promotions/womens-world-cup',
                        icon: '',
                        authkey:"showWomensWorldCupPromo",
                        label: "PROMOTIONS@WomensWorldCup"
                    },
                    {
                        id: '42',
                        url: '/promotions/big-bash-big-cash',
                        icon: '',
                        authkey:"showBigBashBigCashPromo",
                        label: "PROMOTIONS@BigBashBigCash"
                    },
                    {
                        id: '43',
                        url: '/promotions/the-live-jackpot',
                        icon: '',
                        authkey:"showLiveJackPot2025Promo",
                        label: "PROMOTIONS@LiveJackPot2025"
                    },
                    {
                        id: '44',
                        url: '/promotions/instant-challenge-2025',
                        icon: '',
                        authkey:"showInstantChallengePromo",
                        label: "PROMOTIONS@InstantChallengePromo"
                    },
                    {
                        id: '46',
                        url: '/promotions/daily-leaderboard',
                        icon: '',
                        authkey:"showDailyLeaderboard",
                        label: "PROMOTIONS@DailyLeaderBoard"
                    },
                    {
                        id: '47',
                        url: '/promotions/aviatrix-sky-high-challenge',
                        icon: '',
                        authkey:"showAviatrixSkyHighChallengePromo",
                        label: "PROMOTIONS@AviatrixSKYHighChallenge"
                    },
                    {
                        id: '48',
                        url: '/promotions/lightning-cashback',
                        icon: '',
                        authkey:"showLightningCashback2k25",
                        label: "PROMOTIONS@LightningCashback2k25"
                    },
                    {
                        id: '49',
                        url: '/promotions/galaxsys-tournament',
                        icon: '',
                        authkey:"showGalaxsysTournament",
                        label: "PROMOTIONS@GalaxsysTournamentPromo"
                    },
                    {
                        id: '50',
                        url: '/promotions/smartsoft-price-drop',
                        icon: '',
                        authkey:"showSmartSoftPriceDrop",
                        label: "PROMOTIONS@SmartSoftPriceDropTitle"
                    },
                    {
                        id: '51',
                        url: '/promotions/jili-jackpot-league',
                        icon: '',
                        authkey:"ShowJiliSpinWinLeaguePromo",
                        label: "PROMOTIONS@JiliSpinWinLeague"
                    },
                    {
                        id: '52',
                        url: '/promotions/100-lossback-bonus',
                        icon: '',
                        authkey:"show100LossBackPromo25",
                        label: "PROMOTIONS@HundredLossbackPromo"
                    },
                    {
                        id: '53',
                        url: '/promotions/crazy-prize-drop',
                        icon: '',
                        authkey:"ShowCrazyPrizeDropPromo",
                        label: "PROMOTIONS@EvolutionCrazyPrizeDrop"
                    },
                    {
                        id: '54',
                        url: '/promotions/ipl-jackpot',
                        icon: '',
                        authkey:"showIPLJackpotPromo",
                        label: "PROMOTIONS@IPLJackpotPromo2k25"
                    },
                    {
                        id: '55',
                        url: '/promotions/turbo-treasure',
                        icon: '',
                        authkey:"showTurboTreasure2k25",
                        label: "PROMOTIONS@TurboTreasure2k25Promo"
                    },
                    {
                        id: '56',
                        url: '/promotions/jili-bonus-spin',
                        icon: '',
                        authkey:"showJiliPlayPatrioticPromo",
                        label: "PROMOTIONS@JiliPlayPatrioticPromo"
                    },
                    {
                        id: '57',
                        url: '/promotions/twenty-free-spins',
                        icon: '',
                        authkey:"showFreeSpinsPromo",
                        label: "PROMOTIONS@TwentyFreeSpins"
                    },
                    {
                        id: '58',
                        url: '/promotions/turbo-stars-bet-exchange',
                        icon: '',
                        authkey:"ShowAviatorBetToWinBoostPromo",
                        label: "PROMOTIONS@AviatorBetToWinBoost"
                    },
                    {
                        id: '59',
                        url: '/promotions/asiacup-cashback',
                        icon: '',
                        authkey:"showYoloCashbackSixer",
                        label: "PROMOTIONS@YoloCashbackSixer"
                    },
                    {
                        id: '60',
                        url: '/promotions/weekly-leaderboard',
                        icon: '',
                        authkey:"showWeeklyLeaderboard",
                        label: "PROMOTIONS@WeeklyLeaderBoard"
                    },
                    {
                        id: '61',
                        url: '/promotions/super-chicken-rush',
                        icon: '',
                        authkey:"showSuperChickenRushPromo",
                        label: "PROMOTIONS@superChickenRushPromo"
                    },
                    {
                        id: '63',
                        url: '/promotions/surprise-evolution',
                        icon: '',
                        authkey:"showSurpriseDhamakaPromo",
                        label: "PROMOTIONS@SurpriseDhamaka"
                    },
                    {
                        id: '68',
                        url: '/promotions/international-league-t20',
                        icon: '',
                        authkey:"showILT20Promo",
                        label: "PROMOTIONS@ILT20Promo"
                    },
                    {
                        id: '71',
                        url: '/promotions/exchange-safety-net',
                        icon: '',
                        authkey:"showHundredSafetyPromo",
                        label: "PROMOTIONS@ExchangeSafetyPromo"
                    },
                    {
                        id: '72',
                        url: '/promotions/aviator-26-free-bets-bonanza',
                        icon: '',
                        authkey:"ShowAviator26FBBPromo",
                        label: "PROMOTIONS@Aviator26FBBPromo"
                    },
                    {
                        id: '73',
                        url: '/promotions/deposit-with-6-win-26x-bonus',
                        icon: '',
                        authkey:"showDeposit6x26xBonusPromo",
                        label: "PROMOTIONS@Deposit6x26xBonusPromo"
                    },
                    {
                        id: '74',
                        url: '/promotions/monday-happy-hours',
                        icon: '',
                        authkey:"showMondayHappyHourPromo",
                        label: "PROMOTIONS@MondayHappyHourPromo"
                    },
                    {
                        id: '75',
                        url: '/promotions/chicken-road',
                        icon: '',
                        authkey:"showChickenRoadPromo",
                        label: "PROMOTIONS@chickenRoadPromo"
                    },
                    {
                        id: '76',
                        url: '/promotions/evolution-live-rewards',
                        icon: '',
                        authkey:"showEvoLiveRewrds2k26Promo",
                        label: "PROMOTIONS@EvoLiveRewrdsPromo"
                    },
                    {
                        id: '77',
                        url: '/promotions/welcome-free-spins',
                        icon: '',
                        authkey:"showWelcomeFreeSpins",
                        label: "PROMOTIONS@WelcomeFreeSpinsPromo"
                    },
                    {
                        id: '78',
                        url: '/promotions/aviator-free-bets-with-ipl-bets',
                        icon: '',
                        authkey:"showAviatorFreeBetsWthIPLBetsPromo",
                        label: "PROMOTIONS@AviatorFreeBetsWthIPLBetsPromo"
                    },
                    {
                        id: '79',
                        url: '/promotions/wc-double-Cashback',
                        icon: '',
                        authkey:"showWorldCupDoubleCashBackBazzi",
                        label: "PROMOTIONS@WorldCupDoubleCashbackBonusBazzi"
                    },
                    {
                        id: '80',
                        url: '/promotions/leaderboard-2026',
                        icon: '',
                        authkey:"showLeaderboard2k26Promo",
                        label: "PROMOTIONS@LeaderboardPromoTitle"
                    },
                    {
                        id: '81',
                        url: '/promotions/free-spins-jili',
                        icon: '',
                        authkey:"showJiliFreeSpinsPromo",
                        label: "PROMOTIONS@jiliFreeSpinsPromo"
                    },
                    {
                        id: '82',
                        url: '/promotions/weekly-deposits',
                        icon: '',
                        authkey:"showWeeklyDesposit",
                        label: "PROMOTIONS@WeeklyDespositPromo"
                    },
                    {
                        id: '83',
                        url: '/promotions/evolution-powerplay-strike',
                        icon: '',
                        authkey:"showEvolutionpPowerPlayPromo",
                        label: "PROMOTIONS@EvoPowerplayStrikePromo"
                    },
                    {
                        id: '84',
                        url: '/promotions/daily-betback',
                        icon: '',
                        authkey:"showDailyBetBackPromo",
                        label: "PROMOTIONS@DailyBetBackPromo"
                    },
                    {
                        id: '85',
                        url: '/promotions/playtech-new-launch-win-big',
                        icon: '',
                        authkey:"showPlaytechNewLaunch",
                        label: "PROMOTIONS@PlaytechNewLaunchPromo"
                    },
                    {
                        id: '86',
                        url: '/promotions/tower-rush-jackpot',
                        icon: '',
                        authkey:"showTowerRushJackpotPromo",
                        label: "PROMOTIONS@ToweRushJackpot"
                    },
                    {
                        id: '87',
                        url: '/promotions/place-9-bets-win-up-to-99x',
                        icon: '',
                        authkey:"showPlace9BetsWinUpTo99X",
                        label: "PROMOTIONS@Place9BetsWinUpTo99XPromo"
                    },
                    {
                        id: '86',
                        url: '/promotions/up-to-100-free-spins-on-ganesh-gold',
                        icon: '',
                        authkey:"show100FreeSpinOnGaneshGold",
                        label: "PROMOTIONS@100FreeSpinOnGaneshGold"
                    }
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@ExploreALL'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm1',
                    url: '/promotions/welcome-bonus',
                    image: 'DROPDOWN_WELCOME_BONUS_NEW.png',
                    label: 'PROMOTIONSTITLE@WELCOME',
                    authkey: "showWelcomeBonus"
                },
                {
                    id: 'rm2',
                    url: '/promotions/refill-bonus',
                    image: 'DROPDOWN_REFILLBONUS_NEW.png',
                    label: 'PROMOTIONSTITLE@REFILL',
                    authkey: "showRefillBonus"
                },
                {
                    id: 'rm3',
                    url: '/promotions/cashback-bonus',
                    image: 'DROPDOWN_CASHBACKBONUS_NEW.png',
                    label: 'PROMOTIONSTITLE@CASHBACK',
                    authkey: "showCashbackBonus"
                }
            ]
        },
    },
    34:{
        casino: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/live-casino/roulette',
                        icon: '',
                        label: 'TITLE@ROULETTESIDEBAR',
                        authkey: 'showRoulette'
                    },
                    {
                        id: '2',
                        url: '/live-casino/blackjack',
                        icon: '',
                        label: 'TITLE@BLACKJACKSIDEBAR',
                        authkey: 'showBlackjack'
                    },
                    {
                        id: '3',
                        url: '/live-casino/baccarat',
                        icon: '',
                        label: 'TITLE@BACCARAT',
                        authkey: 'showBaccarat'
                    },
                    {
                        id: '4',
                        url: '/live-casino/dragon-tiger',
                        icon: '',
                        label: 'TITLE@DRAGON_TIGER',
                        authkey: 'showDragontiger'
                    }
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@ENJOY'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm3',
                    url:'/popular-games',
                    image: 'DROPDOWN_POPULAR.png',
                    label: 'TITLE@populargames'
                },
                {
                    id: 'rm1',
                    url:'/live-casino',
                    image: 'DROPDOWN_CASINO_LIVE_CASINO.png',
                    label: 'TITLE@LIVECASINO',
                    authkey: 'showOnlineCasinoGamesLink'
                },
                {
                    id: 'rm2',
                    url:'/slots',
                    image: 'DROPDOWN_SLOT_BINGO.png',
                    label: 'TITLE@SLOTBINGO'
                }
            
            ]
        },
        instant_games: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/instant-games/smartsoft/plinkox',
                        icon: '',
                        label: "TITLE@Plinko",
                        authkey: "showInstantThumbs"
                    },
                    // {
                    //     id: '2',
                    //     url: '/instant-games/smartsoft/footballx',
                    //     icon: '',
                    //     label: 'TITLE@Footballx',
                    //     authkey: "showInstantThumbs"
                    // },
                    // {
                    //     id: '3',
                    //     url: '/instant-games/smartsoft/balloon',
                    //     icon: '',
                    //     label: 'TITLE@Baloon',
                    //     authkey: "showInstantThumbs"
                    // },
                    {
                        id: '4',
                        url: '/instant-games/inout/chicken-road-2',
                        icon: '',
                        authkey:"showInstantThumbs",
                        label: "TITLE@ChickenRoad2"
                    },
                    {
                        id: '5',
                        url: '/instant-games/galaxsys/ninja-crash',
                        icon: '',
                        authkey:"showInstantThumbs",
                        label: "TITLE@ninjacrush"
                    },
                   
                    {
                        id: '7',
                        url: '/instant-games',
                        icon: '',
                        authkey:"showInstantThumbs",
                        label: "HEADER@VIEWALL"
                    },
                
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@ExploreALL'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm1',
                    url: '/instant-games/spribe/aviator',
                    image: 'aviator-instant-cashsite-dropdown.png',
                    label: 'TITLE@AVIATOR',
                    authkey: "showInstantThumbs"
                },
                {
                    id: 'rm2',
                    url: '/instant-games/smartsoft/jetx',
                    image: 'jetx-instant-cashsite-drowpdown.png',
                    label: 'TITLE@JetX',
                    authkey: "showInstantThumbs"
                },
                {
                    id: 'rm3',
                    url: '/instant-games/aviatrix/play-aviatrix',
                    image: 'AviatriXdropdown.png',
                    label: 'GAME@AVIATRIX',
                    authkey: "showInstantThumbs"
                }
            ]
        },
        hotgames: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/live-casino/evolution/monopoly-live',
                        icon: '',
                        label: 'TITLE@MonopolyLive',
                        authkey: 'showTeenpatti'
                    },
                    {
                        id: '2',
                        url: '/live-casino/evolution/funky-time',
                        icon: '',
                        label: 'TITLE@FunkyTimes',
                        authkey: 'showTeenpatti2020'
                    },
                    {
                        id: '3',
                        url: '/live-casino/evolution/lightning-dice',
                        icon: '',
                        label: 'TITLE@LightningDice',
                        authkey: 'showTeenpatti2020'
                    },
                    {
                        id: '4',
                        url: '/live-casino/dragon-tiger',
                        icon: '',
                        label: 'TITLE@DragonTiger',
                        authkey: 'showTeenpatti2020'
                    },
                    {
                        id: '5',
                        url: '/instant-games/smartsoft/cricketx',
                        icon: '',
                        label: 'TITLE@CricketX',
                        authkey: 'showTeenpatti2020'
                    },
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@PLAYANDNEVER'
                    },
                ]
            },
            rightMenu: [
                
                {
                    id: 'rm1',
                    url:'/instant-games/spribe/mines',
                    image: 'spribe-minesdropdown.png',
                    label: 'TITLE@Mines',
                    authkey: 'showTeenpattiLink'
                },
                {
                    id: 'rm2',
                    url:'/live-casino/evolution/crazy-time',
                    image: 'DROPDOWN_CRAZY_TIME.png',
                    label: "TITLE@crazytime",
                    authkey: 'showTeenpattiLink'
                },
                {
                    id: 'rm3',
                    url:'/live-casino/evolution/lightning-roulette',
                    image: 'DROPDOWN_LIGHTNING_ROULETTE.png',
                    label: 'TITLE@LIGHTINGROULETTE',
                    authkey: 'showTeenpattiLink'
                }
               
            ]
        },
        sports: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/betting-exchange/cricket',
                        icon: '',
                        label: 'SPORT@CRICKET',
                        authkey: 'showSportCricket'
                    },
                    {
                        id: '2',
                        url: '/betting-exchange/football',
                        icon: '',
                        label: 'SPORT@FOOTBALL',
                        authkey: 'showSportFootball'
                    },
                    {
                        id: '3',
                        url: '/betting-exchange/tennis',
                        icon: '',
                        label: 'SPORT@TENNIS',
                        authkey: 'showSportTennis'
                    },
                    // {
                    //     id: '4',
                    //     url: '/betting-exchange/volleyball',
                    //     icon: '',
                    //     label: 'SPORT@VolleyBall',
                    //     authkey: 'showSportVolleyball'
                    // },
                    // {
                    //     id: '5',
                    //     url: '/virtualSports/vci',
                    //     icon: '',
                    //     label: 'TITLE@VIRTUALSPORTS',
                    //     authkey: 'showVirtualSportsvfec'
                    // },
                    // {
                    //     id: '6',
                    //     url: '/saba-sports',
                    //     icon: '',
                    //     label: 'TITLE@SabaSports',
                    //     authkey: 'showSabaSportsStatement'
                    // }
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@GOONTURN'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm1',
                    url:'/betting-exchange',
                    image: 'ExchangeDropdownBA.png',
                    label: 'TITLE@EXCHANGE',
                    authkey: 'showExchangeLink',
                    itemsCount: '5'
                },
                // {
                //     id: 'rm5',
                //     url:'/premium-sportsbook/kabaddi-betting',
                //     image: 'kabbadiIw247.png',
                //     label: 'MENU@Kabbadi',
                //     authkey: 'showProKabbadi',
                //     itemsCount: '5'
                // },
                {
                    id: 'rm2',
                    url:'/premium-sportsbook',
                    image: 'premiumSportsbookDropdownBetdaily.png',
                    label: 'TITLE@PREMIUM_SPORTSBOOK',
                    authkey: 'showPremiumSportsLink',
                    itemsCount: '5'
                },
                {
                    id: 'rm3',
                    url:'/sportsbook',
                    image: 'DROPDOWN_SPORTSBOOK_NEW.png',
                    label: 'MENU@SPORTBOOK',
                    authkey: 'showSportBookLink',
                     itemsCount: '5'
                },
                {
                    id: 'rm4',
                    url:'/saba-sports',
                    image: 'BaaziSabaDesk.png',
                    label: 'TITLE@SabaSports',
                    authkey: 'showSabaSportsStatement',
                    itemsCount: '5'
                },
                // {
                //     id: 'rm4',
                //     url:'/virtualSports/vci',
                //     image: 'virtualSportsDesktopDropdown.png',
                //     label: 'GAME@VIRTUALSPORTS',
                //     authkey: 'showVirtualSportsvfel'
                // },
            ]
        },
        promotions: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/promotions/welcome-bonus',
                        icon: '',
                        label: "PROMOTIONSTITLE@WELCOME"
                    },
                    {
                        id: '2',
                        url: '/promotions/refill-bonus',
                        icon: '',
                        label: 'PROMOTIONSTITLE@REFILL',
                        authkey: "showRefillBonus"
                    },
                    {
                        id: '3',
                        url: '/promotions/cashback-bonus',
                        icon: '',
                        label: 'PROMOTIONSTITLE@CASHBACK',
                        authkey: "showCashbackBonus"
                    },
                    {
                        id: '4',
                        url: '/promotions/referral-bonus',
                        icon: '',
                        authkey:"showReferralBonus",
                        label: "ProBonus@Referral"
                    },   
                    {
                        id: '5',
                        url: '/promotions/big-bash',
                        icon: '',
                        authkey:"showBBLBonus",
                        label: "PROMOTIONS@BBLBonus"
                    },
                    {
                        id: '6',
                        url: '/promotions/arjith_promo',
                        icon: '',
                        authkey:"showSingWithYolo",
                        label: "PROMOTIONS@singYolo"
                    },
                    {
                        id: '7',
                        url: '/promotions/jetx-tournament',
                        icon: '',
                        authkey:"jetxpromo",                                 
                        label:"jetx"
                    },
                    {
                        id: '8',
                        url: '/promotions/crazyCrash',
                        icon: '',
                        authkey:"showCrazyCrashPromo",
                        label:"PROMOTIONS@crazyCrashPromo"
                    },
                    {   id: '9',
                        url: '/promotions/aviator-bonus',
                        icon: '',
                        authkey:"showAviatorBonus",
                        label:"PROMOTIONS@AviatorBonus"
                    },   
                    {
                        id: '10',
                        url: '/promotions/evolution-first-bet',
                        icon: '',
                        authkey:"showEvolutionpromo",
                        label: "PROMOTIONS@firstperson"
                    },
                    {
                        id: '11',
                        url: '/promotions/funkytime',
                        icon: '',
                        authkey:"showFunkytimePromo",
                        label: "PROMOTIONS@funkytime"
                    },
                    {
                        id: '12',
                        url: '/promotions/evo-baccarat',
                        icon: '',
                        authkey:"showEvoCasinoCupPromo",
                        label: "PROMOTIONS@EvoCasinoCupPromo"
                    },
                    {
                        id: '13',
                        url: '/promotions/worldcup-cashback-bonanza',
                        icon: '',
                        authkey:"showWCBonusPromo",
                        label: "PROMOTIONS@WCCBONAZA"
                    },
                    {
                        id: '14',
                        url: '/promotions/platinum-rush',
                        icon: '',
                        authkey:"showPlatinumRush",
                        label: "PROMOTIONS@Platinumrush"
                    },
                    {
                        id: '15',
                        url: '/promotions/worldcup-betboost',
                        icon: '',
                        authkey:"showWCBonusPromo",
                        label: "TITLE@wcbetboost"
                    },
                    // {
                    //     id: '15',
                    //     url: '/promotions/evolution-crazy-pachinko',
                    //     icon: '',
                    //     authkey:"showCrazyPachinkoPromo",
                    //     label: "TITLE@EvoCrazyPachinko"
                    // },
                    {
                        id: '16',
                        url: '/promotions/jetx-celestial-rush',
                        icon: '',
                        authkey:"showJetXCelestialRush",
                        label: "PROMOTIONS@JetxCelestial"
                    },
                    {
                        id: '17',
                        url: '/promotions/aviatrix-double-dhamaka',
                        icon: '',
                        authkey:"showAviatrixPromo",
                        label: "PROMOTIONS@AviatrixDoubleDhamaka"
                    },
                    {
                        id: '18',
                        url: '/promotions/cricket-cashback-marathon',
                        icon: '',
                        authkey:"showcircketCashbackMarathon",
                        label: "PROMOTIONS@CricketCashbackMarathon"
                    },
                    {
                        id: '19',
                        url: '/promotions/crazytime-epic-bonanza',
                        icon: '',
                        authkey:"showCrazyTimePromo",
                        label: "PROMOTIONS@CrazyTimeEpicBonanza"
                    },
                    {
                        id: '20',
                        url: '/promotions/aviator-high-flyer',
                        icon: '',
                        authkey:"showAviatorHighFlyerPromo",
                        label: "PROMOTIONS@AviatorHighFlyer"
                    },
                    {
                        id: '22',
                        url: '/promotions/smartsoft-spin-and-win',
                        icon: '',
                        authkey:"showSmartsoft",
                        label: "PROMOTIONS@Smartsoft"
                    }     ,
                    
                    {
                        id: '23',
                        url: '/promotions/evolution-casino-cup',
                        icon: '',
                        authkey:"showEvolutionCasionCup",
                        label: "PROMOTIONS@EvolutionCasionCup"
                    },




                    {
                        id: '24',
                        url: '/promotions/IPL-Betting-dhamaka-Power-Play-Bonus',
                        icon: '',
                        authkey:"shoeIPLpowerPlay",
                        label: "PROMOTIONS@IPLPOWERPLAY1"
                    },



                    {
                        id: '25',
                        url: '/promotions/indian-galaxsys-league',
                        icon: '',
                        authkey:"showIndianGalaxysLeague",
                        label: "PROMOTIONS@IndianGalaxsysLeague"
                    },
                   
                    



                        {
                        id: '26',
                        url: '/promotions/ipl-betting-dhamaka',
                        icon: '',
                        authkey:"showIplPromo",
                        label: "PROMOTIONS@iplmatka"},



                        {
                            id: '27',
                            url: '/promotions/double-cashback',
                            icon: '',
                            authkey:"showDoubleCashBack",
                            label: "PROMOTIONS@DoubleCashback"
                        },


                        {
                        id: '28',
                        url: '/promotions/aviator-sky-bound-miles',
                        icon: '',
                        authkey:"showAviatorSkyBoundMiles",
                        label: "PROMOTIONS@AviatorSkyBoundMiles"
                    },
                    {
                        id: '29',
                        url: '/promotions/wc-double-Cashback',
                        icon: '',
                        authkey:"showWorldCupDoubleCashBackBazzi",
                        label: "PROMOTIONS@WorldCupDoubleCashbackBonusBazzi"
                    } ,
                    {
                        id: '30',
                        url: '/promotions/evolution-casino-tourney',
                        icon: '',
                        authkey:"showEvolutionCasinoTourneyBazzi",
                        label: "PROMOTIONS@EvolutionCasinoTourneyBazzi"
                    },
                    {
                        id: '31',
                        url: '/promotions/daily-rewards',
                        icon: '',
                        authkey:"showDailyRewardsBazzi",
                        label: "PROMOTIONS@DailyRewardsBazzi"
                    },
                    {
                        id: '34',
                        url: '/promotions/smartsoft-spin-and-win',
                        icon: '',
                        authkey:"showSmartSoftJetxCelestial",
                        label: "PROMOTIONS@SmartSoftJetxCelestial"
                    },
                    {
                        id: '35',
                        url: '/promotions/caribbean-premier-league',
                        icon: '',
                        authkey:"showCaribbeanLeagueBonusPromo",
                        label: "PROMOTIONS@CaribbeanLeagueBonus"
                    },
                    {
                        id: '38',
                        url: '/promotions/aviatrix-fly-and-play',
                        icon: '',
                        authkey:"showAviatrixFlyAndPlayPromo",
                        label: "PROMOTIONS@AviatrixFlyAndPlay"
                    },
                    {
                        id: '39',
                        url: '/promotions/aviatrix-jet-to-cash',
                        icon: '',
                        authkey:"showAviatrixJetToCrash",
                        label: "PROMOTIONS@AviatrixJetToCrash"
                    },
                    {
                        id: '40',
                        url: '/promotions/jet-set-with-jetx',
                        icon: '',
                        authkey:"showJetSetWithJetXPromo",
                        label: "PROMOTIONS@JetSetWithJetX"
                    },
                    {
                        id: '41',
                        url: '/promotions/womens-world-cup',
                        icon: '',
                        authkey:"showWomensWorldCupPromo",
                        label: "PROMOTIONS@WomensWorldCup"
                    },
                    {
                        id: '43',
                        url: '/promotions/big-bash-big-cash',
                        icon: '',
                        authkey:"showBigBashBigCashPromo",
                        label: "PROMOTIONS@BigBashBigCash"
                    },
                    {
                        id: '44',
                        url: '/promotions/the-live-jackpot',
                        icon: '',
                        authkey:"showLiveJackPot2025Promo",
                        label: "PROMOTIONS@LiveJackPot2025"
                    },
                    {
                        id: '45',
                        url: '/promotions/instant-challenge-2025',
                        icon: '',
                        authkey:"showInstantChallengePromo",
                        label: "PROMOTIONS@InstantChallengePromo"
                    },
                    {
                        id: '49',
                        url: '/promotions/daily-leaderboard',
                        icon: '',
                        authkey:"showDailyLeaderboard",
                        label: "PROMOTIONS@DailyLeaderBoard"
                    },
                    {
                        id: '46',
                        url: '/promotions/aviatrix-sky-high-challenge',
                        icon: '',
                        authkey:"showAviatrixSkyHighChallengePromo",
                        label: "PROMOTIONS@AviatrixSKYHighChallenge"
                    },
                    {
                        id: '49',
                        url: '/promotions/lightning-cashback',
                        icon: '',
                        authkey:"showLightningCashback2k25",
                        label: "PROMOTIONS@LightningCashback2k25"
                    },
                    {
                        id: '47',
                        url: '/promotions/galaxsys-tournament',
                        icon: '',
                        authkey:"showGalaxsysTournament",
                        label: "PROMOTIONS@GalaxsysTournamentPromo"
                    },
                    {
                        id: '48',
                        url: '/promotions/smartsoft-price-drop',
                        icon: '',
                        authkey:"showSmartSoftPriceDrop",
                        label: "PROMOTIONS@SmartSoftPriceDropTitle"
                    },
                    {
                        id: '49',
                        url: '/promotions/jili-jackpot-league',
                        icon: '',
                        authkey:"ShowJiliSpinWinLeaguePromo",
                        label: "PROMOTIONS@JiliSpinWinLeague"
                    },
                    {
                        id: '50',
                        url: '/promotions/100-lossback-bonus',
                        icon: '',
                        authkey:"show100LossBackPromo25",
                        label: "PROMOTIONS@HundredLossbackPromo"
                    },
                    {
                        id: '51',
                        url: '/promotions/crazy-prize-drop',
                        icon: '',
                        authkey:"ShowCrazyPrizeDropPromo",
                        label: "PROMOTIONS@EvolutionCrazyPrizeDrop"
                    },
                    {
                        id: '60',
                        url: '/promotions/turbo-stars-bet-exchange',
                        icon: '',
                        authkey:"ShowAviatorBetToWinBoostPromo",
                        label: "PROMOTIONS@AviatorBetToWinBoost"
                    },
                    {
                        id: '62',
                        url: '/promotions/weekly-leaderboard',
                        icon: '',
                        authkey:"showWeeklyLeaderboard",
                        label: "PROMOTIONS@WeeklyLeaderBoard"
                    },
                    {
                        id: '53',
                        url: '/promotions/super-chicken-rush',
                        icon: '',
                        authkey:"showSuperChickenRushPromo",
                        label: "PROMOTIONS@superChickenRushPromo"
                    },
                    {
                        id: '66',
                        url: '/promotions/surprise-evolution',
                        icon: '',
                        authkey:"showSurpriseDhamakaPromo",
                        label: "PROMOTIONS@SurpriseDhamaka"
                    },
                    {
                        id: '65',
                        url: '/promotions/chicken-road',
                        icon: '',
                        authkey:"showChickenRoadPromo",
                        label: "PROMOTIONS@chickenRoadPromo"
                    },
                    {
                        id: '74',
                        url: '/promotions/evolution-live-rewards',
                        icon: '',
                        authkey:"showEvoLiveRewrds2k26Promo",
                        label: "PROMOTIONS@EvoLiveRewrdsPromo"
                    },
                    {
                        id: '78',
                        url: '/promotions/daily-betback',
                        icon: '',
                        authkey:"showDailyBetBackPromo",
                        label: "PROMOTIONS@DailyBetBackPromo"
                    },
                    {
                        id: '77',
                        url: '/promotions/evolution-powerplay-strike',
                        icon: '',
                        authkey:"showEvolutionpPowerPlayPromo",
                        label: "PROMOTIONS@EvoPowerplayStrikePromo"
                    },
                    {
                        id: '78',
                        url: '/promotions/welcome-free-spins',
                        icon: '',
                        authkey:"showWelcomeFreeSpins",
                        label: "PROMOTIONS@WelcomeFreeSpinsPromo"
                    }
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@ExploreALL'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm1',
                    url: '/promotions/welcome-bonus',
                    image: 'DROPDOWN_WELCOME_BONUS_NEW.png',
                    label: 'PROMOTIONSTITLE@WELCOME',
                    authkey: "showWelcomeBonus"
                },
                {
                    id: 'rm2',
                    url: '/promotions/refill-bonus',
                    image: 'DROPDOWN_REFILLBONUS_NEW.png',
                    label: 'PROMOTIONSTITLE@REFILL',
                    authkey: "showRefillBonus"
                },
                {
                    id: 'rm3',
                    url: '/promotions/cashback-bonus',
                    image: 'DROPDOWN_CASHBACKBONUS_NEW.png',
                    label: 'PROMOTIONSTITLE@CASHBACK',
                    authkey: "showCashbackBonus"
                }
            ]
        },
    },
    39:{
        casino: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/live-casino/roulette',
                        icon: '',
                        label: 'TITLE@ROULETTESIDEBAR',
                        authkey: 'showRoulette'
                    },
                    {
                        id: '2',
                        url: '/live-casino/blackjack',
                        icon: '',
                        label: 'TITLE@BLACKJACKSIDEBAR',
                        authkey: 'showBlackjack'
                    },
                    {
                        id: '3',
                        url: '/live-casino/baccarat',
                        icon: '',
                        label: 'TITLE@BACCARAT',
                        authkey: 'showBaccarat'
                    },
                    {
                        id: '4',
                        url: '/live-casino/dragon-tiger',
                        icon: '',
                        label: 'TITLE@DRAGON_TIGER',
                        authkey: 'showDragontiger'
                    }
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@ENJOY'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm3',
                    url:'/popular-games',
                    image: 'DROPDOWN_POPULAR.png',
                    label: 'TITLE@populargames'
                },
                {

                    id: 'rm1',
                    url:'/live-casino',
                    image: 'DROPDOWN_CASINO_LIVE_CASINO.png',
                    label: 'TITLE@LIVECASINO',
                    authkey: 'showOnlineCasinoGamesLink'
                },
                {
                    id: 'rm2',
                    url:'/slots',
                    image: 'DROPDOWN_SLOT_BINGO.png',
                    label: 'TITLE@SLOTBINGO'
                }
            
             
                    ]
        },
        instant_games: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/instant-games/smartsoft/plinkox',
                        icon: '',
                        label: "TITLE@Plinko",
                        authkey: "showInstantThumbs"
                    },
                    // {
                    //     id: '2',
                    //     url: '/instant-games/smartsoft/footballx',
                    //     icon: '',
                    //     label: 'TITLE@Footballx',
                    //     authkey: "showInstantThumbs"
                    // },
                    // {
                    //     id: '3',
                    //     url: '/instant-games/smartsoft/balloon',
                    //     icon: '',
                    //     label: 'TITLE@Baloon',
                    //     authkey: "showInstantThumbs"
                    // },
                    {
                        id: '4',
                        url: '/instant-games/inout/chicken-road-2',
                        icon: '',
                        authkey:"showInstantThumbs",
                        label: "TITLE@ChickenRoad2"
                    },
                    {
                        id: '5',
                        url: '/instant-games/galaxsys/ninja-crash',
                        icon: '',
                        authkey:"showInstantThumbs",
                        label: "TITLE@ninjacrush"
                    },
                  
                    {
                        id: '7',
                        url: '/instant-games',
                        icon: '',
                        authkey:"showInstantThumbs",
                        label: "HEADER@VIEWALL"
                    }
                
                
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@ExploreALL'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm1',
                    url: '/instant-games/spribe/aviator',
                    image: 'aviator-instant-cashsite-dropdown.png',
                    label: 'TITLE@AVIATOR',
                    authkey: "showInstantThumbs"
                },
                {
                    id: 'rm2',
                    url: '/instant-games/smartsoft/jetx',
                    image: 'jetx-instant-cashsite-drowpdown.png',
                    label: 'TITLE@JetX',
                    authkey: "showInstantThumbs"
                },
                {
                    id: 'rm3',
                    url: '/instant-games/aviatrix/play-aviatrix',
                    image: 'AviatriXdropdown.png',
                    label: 'GAME@AVIATRIX',
                    authkey: "showInstantThumbs"
                }
            ]
        },
        hotgames: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/live-casino/evolution/monopoly-live',
                        icon: '',
                        label: 'TITLE@MonopolyLive',
                        authkey: 'showTeenpatti'
                    },
                    {
                        id: '2',
                        url: '/live-casino/evolution/funky-time',
                        icon: '',
                        label: 'TITLE@FunkyTimes',
                        authkey: 'showTeenpatti2020'
                    },
                    {
                        id: '3',
                        url: '/live-casino/evolution/lightning-dice',
                        icon: '',
                        label: 'TITLE@LightningDice',
                        authkey: 'showTeenpatti2020'
                    },
                    {
                        id: '4',
                        url: '/live-casino/dragon-tiger',
                        icon: '',
                        label: 'TITLE@DragonTiger',
                        authkey: 'showTeenpatti2020'
                    },
                    {
                        id: '5',
                        url: '/instant-games/smartsoft/cricketx',
                        icon: '',
                        label: 'TITLE@CricketX',
                        authkey: 'showTeenpatti2020'
                    },
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@PLAYANDNEVER'
                    },
                ]
            },
            rightMenu: [
               
                {
                    id: 'rm1',
                    url:'/instant-games/spribe/mines',
                    image: 'spribe-minesdropdown.png',
                    label: 'TITLE@Mines',
                    authkey: 'showTeenpattiLink'
                },
                {
                    id: 'rm2',
                    url:'/live-casino/evolution/crazy-time',
                    image: 'DROPDOWN_CRAZY_TIME.png',
                    label: "TITLE@crazytime",
                    authkey: 'showTeenpattiLink'
                },
                {
                    id: 'rm3',
                    url:'/live-casino/evolution/lightning-roulette',
                    image: 'DROPDOWN_LIGHTNING_ROULETTE.png',
                    label: 'TITLE@LIGHTINGROULETTE',
                    authkey: 'showTeenpattiLink'
                }
               
            ]
        },
        sports: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/betting-exchange/cricket',
                        icon: '',
                        label: 'SPORT@CRICKET',
                        authkey: 'showSportCricket'
                    },
                    {
                        id: '2',
                        url: '/betting-exchange/football',
                        icon: '',
                        label: 'SPORT@FOOTBALL',
                        authkey: 'showSportFootball'
                    },
                    {
                        id: '3',
                        url: '/betting-exchange/tennis',
                        icon: '',
                        label: 'SPORT@TENNIS',
                        authkey: 'showSportTennis'
                    },
                    // {
                    //     id: '4',
                    //     url: '/betting-exchange/volleyball',
                    //     icon: '',
                    //     label: 'SPORT@VolleyBall',
                    //     authkey: 'showSportVolleyball'
                    // },
                    // {
                    //     id: '5',
                    //     url: '/virtualSports/vci',
                    //     icon: '',
                    //     label: 'TITLE@VIRTUALSPORTS',
                    //     authkey: 'showVirtualSportsvfec'
                    // },
                    {
                        id: '6',
                        url: '/sports/tournaments/',
                        icon: '',
                        label: 'TITLE@Tournaments',
                        authkey: 'showTournaments'
                    },
                    // {
                    //     id: '7',
                    //     url: '/saba-sports',
                    //     icon: '',
                    //     label: 'TITLE@SabaSports',
                    //     authkey: 'showSabaSportsStatement'
                    // }
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@GOONTURN'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm1',
                    url:'/betting-exchange',
                    image: 'DROPDOWN_EXCHANGE_FOMO.png',
                    label: 'TITLE@EXCHANGE',
                    authkey: 'showExchangeLink',
                    itemsCount: '5'
                },
                // {
                //     id: 'rm5',
                //     url:'/premium-sportsbook/kabaddi-betting',
                //     image: 'kabbadiFomo.png',
                //     label: 'MENU@Kabbadi',
                //     authkey: 'showProKabbadi',
                //     itemsCount: '5'
                // },
                {
                    id: 'rm2',
                    url:'/premium-sportsbook',
                    image: 'premiumSportsbookDropdownFomo.png',
                    label: 'TITLE@PREMIUM_SPORTSBOOK',
                    authkey: 'showPremiumSportsLink',
                    itemsCount: '5'
                },
                {
                    id: 'rm3',
                    url:'/sportsbook',
                    image: 'DROPDOWN_SPORTSBOOK_NEW.png',
                    label: 'MENU@SPORTBOOK',
                    authkey: 'showSportBookLink',
                    itemsCount: '5'
                },
                {
                    id: 'rm4',
                    url:'/saba-sports',
                    image: 'FomoSabaDesk.png',
                    label: 'TITLE@SabaSports',
                    authkey: 'showSabaSportsStatement',
                    itemsCount: '5'
                },
                // {
                //     id: 'rm4',
                //     url:'/virtualSports/vci',
                //     image: 'virtualSportsDesktopDropdown.png',
                //     label: 'GAME@VIRTUALSPORTS',
                //     authkey: 'showVirtualSportsvfel'
                // },
            ]
        },
        promotions: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/promotions/welcome-bonus',
                        icon: '',
                        label: "PROMOTIONSTITLE@WELCOME"
                    },
                    {
                        id: '2',
                        url: '/promotions/refill-bonus',
                        icon: '',
                        label: 'PROMOTIONS@REFILLBONUS',
                        authkey: "showRefillBonus"
                    },
                    {
                        id: '3',
                        url: '/promotions/cashback-bonus',
                        icon: '',
                        label: 'PROMOTIONSTITLE@CASHBACK',
                        authkey: "showCashbackBonus"
                    },
                    {
                        id: '4',
                        url: '/promotions/referral-bonus',
                        icon: '',
                        authkey:"showReferralBonus",
                        label: "ProBonus@Referral"
                    },   
                    {
                        id: '5',
                        url: '/promotions/big-bash',
                        icon: '',
                        authkey:"showBBLBonus",
                        label: "PROMOTIONS@BBLBonus"
                    },
                    {
                        id: '6',
                        url: '/promotions/arjith_promo',
                        icon: '',
                        authkey:"showSingWithYolo",
                        label: "PROMOTIONS@singYolo"
                    },
                    {
                        id: '7',
                        url: '/promotions/jetx-tournament',
                        icon: '',
                        authkey:"jetxpromo",                                 
                        label:"jetx"
                    },
                    {
                        id: '8',
                        url: '/promotions/crazyCrash',
                        icon: '',
                        authkey:"showCrazyCrashPromo",
                        label:"PROMOTIONS@crazyCrashPromo"
                    },
                    {   id: '9',
                        url: '/promotions/aviator-bonus',
                        icon: '',
                        authkey:"showAviatorBonus",
                        label:"PROMOTIONS@AviatorBonus"
                    },   
                    {
                        id: '10',
                        url: '/promotions/evolution-first-bet',
                        icon: '',
                        authkey:"showEvolutionpromo",
                        label: "PROMOTIONS@firstperson"
                    },
                    {
                        id: '11',
                        url: '/promotions/funkytime',
                        icon: '',
                        authkey:"showFunkytimePromo",
                        label: "PROMOTIONS@funkytime"
                    },
                    {
                        id: '15',
                        url: '/promotions/evo-baccarat',
                        icon: '',
                        authkey:"showEvoCasinoCupPromo",
                        label: "PROMOTIONS@EvoCasinoCupPromo"
                    },
                    {
                        id: '12',
                        url: '/promotions/worldcup-cashback-bonanza',
                        icon: '',
                        authkey:"showWCBonusPromo",
                        label: "PROMOTIONS@WCCBONAZA"
                    },
                    {
                        id: '13',
                        url: '/promotions/platinum-rush',
                        icon: '',
                        authkey:"showPlatinumRush",
                        label: "PROMOTIONS@Platinumrush"
                    },
                    {
                        id: '14',
                        url: '/promotions/worldcup-betboost',
                        icon: '',
                        authkey:"showWCBonusPromo",
                        label: "TITLE@wcbetboost"
                    },
                    {
                        id: '15',
                        url: '/promotions/catch99-s2',
                        icon: '',
                        authkey:"showCatch99Bonus",
                        label: "PROMOTIONS@CATCH99"
                    },
                    // {
                    //     id: '16',
                    //     url: '/promotions/evolution-crazy-pachinko',
                    //     icon: '',
                    //     authkey:"showCrazyPachinkoPromo",
                    //     label: "TITLE@EvoCrazyPachinko"
                    // },
                    {
                        id: '17',
                        url: '/promotions/jetx-celestial-rush',
                        icon: '',
                        authkey:"showJetXCelestialRush",
                        label: "PROMOTIONS@JetxCelestial"
                    },
                    {
                        id: '18',
                        url: '/promotions/aviatrix-double-dhamaka',
                        icon: '',
                        authkey:"showAviatrixPromo",
                        label: "PROMOTIONS@AviatrixDoubleDhamaka"
                    },
                    {
                        id: '19',
                        url: '/promotions/cricket-cashback-marathon',
                        icon: '',
                        authkey:"showcircketCashbackMarathon",
                        label: "PROMOTIONS@CricketCashbackMarathon"
                    },
                    {
                        id: '20',
                        url: '/promotions/crazytime-epic-bonanza',
                        icon: '',
                        authkey:"showCrazyTimePromo",
                        label: "PROMOTIONS@CrazyTimeEpicBonanza"
                    },
                    {
                        id: '21',
                        url: '/promotions/aviator-high-flyer',
                        icon: '',
                        authkey:"showAviatorHighFlyerPromo",
                        label: "PROMOTIONS@AviatorHighFlyer"
                    }, 
                    {
                        id: '22',
                        url: '/promotions/smartsoft-spin-and-win',
                        icon: '',
                        authkey:"showSmartsoft",
                        label: "PROMOTIONS@Smartsoft"
                    },


                    {
                        id: '23',
                        url: '/promotions/evolution-casino-cup',
                        icon: '',
                        authkey:"showEvolutionCasionCup",
                        label: "PROMOTIONS@EvolutionCasionCup"
                    },
                    {
                        id: '24',
                        url: '/promotions/IPL-Betting-dhamaka-Power-Play-Bonus',
                        icon: '',
                        authkey:"shoeIPLpowerPlay",
                        label: "PROMOTIONS@IPLPOWERPLAY1"
                    },
                    {
                        id: '25',
                        url: '/promotions/indian-galaxsys-league',
                        icon: '',
                        authkey:"showIndianGalaxysLeague",
                        label: "PROMOTIONS@IndianGalaxsysLeague"
                    },
                    {
                        id: '26',
                        url: '/promotions/ipl-betting-dhamaka',
                        icon: '',
                        authkey:"showIplPromo",
                        label: "PROMOTIONS@iplmatka"
                    },
                    {
                        id: '27',
                        url: '/promotions/double-cashback',
                        icon: '',
                        authkey:"showDoubleCashBack",
                        label: "PROMOTIONS@DoubleCashback"
                    },
                    {
                        id: '28',
                        url: '/promotions/aviator-sky-bound-miles',
                        icon: '',
                        authkey:"showAviatorSkyBoundMiles",
                        label: "PROMOTIONS@AviatorSkyBoundMiles"
                    },
                    {
                        id: '29',
                        url: '/promotions/wc-LossBack-Exchange',
                        icon: '',
                        authkey:"showFomoWcLossBackExchPromo",
                        label: "PROMOTIONS@FomoWorldCupLossBackExch"
                    },
                    {
                        id: '30',
                        url: '/promotions/wc-goIndia-goJackpot',
                        icon: '',
                        authkey:"showFomoGoIndiaGoJackpotPromo",
                        label: "PROMOTIONS@FomoWorldCupGoIndiaGoJackpot"
                    },
                    {
                        id: '30',
                        url: '/promotions/aviator-wingsOfAdventure',
                        icon: '',
                        authkey:"showFomoAviatorWingsofAdventurePromo",
                        label: "PROMOTIONS@FomoAviatorWingsOfAdventure"
                    },
                    {
                        id: '31',
                        url: '/promotions/evolution-casino-challenge',
                        icon: '',
                        authkey:"showFomoEvolutionCasinoChallengePromo",
                        label: "PROMOTIONS@FomoEvolutionCasinoChallenge"
                    },
                    {
                        id: '32',
                        url: '/promotions/aviatrix-fiyHigh',
                        icon: '',
                        authkey:"showFomoAviatrixFlyHighPromo",
                        label: "PROMOTIONS@FomoAviatrixFlyHigh"
                    },
                    {
                        id: '33',
                        url: '/promotions/wc-dailyDeposit-bonus',
                        icon: '',
                        authkey:"showWcDailyDepositBonusPromo",
                        label: "PROMOTIONS@FomoWorldCupDailyDesposit"
                    },
                    {
                        id: '34',
                        url: '/promotions/smartsoft-spin-and-win',
                        icon: '',
                        authkey:"showSmartSoftJetxCelestial",
                        label: "PROMOTIONS@SmartSoftJetxCelestial"
                    },
                    {
                        id: '35',
                        url: '/promotions/mines-legend-trophy',
                        icon: '',
                        authkey:"showMinesLegendTrophyPromo",
                        label: "PROMOTIONS@MinesLegendTrophy"
                    },
                    {
                        id: '36',
                        url: '/promotions/caribbean-premier-league',
                        icon: '',
                        authkey:"showCaribbeanLeagueBonusPromo",
                        label: "PROMOTIONS@CaribbeanLeagueBonus"
                    },
                    {
                        id: '37',
                        url: '/promotions/evolution-roulette-cup',
                        icon: '',
                        authkey:"showEvolutionRouletteCupPromo",
                        label: "PROMOTIONS@EvolutionRouletteCup"
                    },
                    {
                        id: '38',
                        url: '/promotions/aviatrix-fly-and-play',
                        icon: '',
                        authkey:"showAviatrixFlyAndPlayPromo",
                        label: "PROMOTIONS@AviatrixFlyAndPlay"
                    },
                    {
                        id: '39',
                        url: '/promotions/aviatrix-jet-to-cash',
                        icon: '',
                        authkey:"showAviatrixJetToCrash",
                        label: "PROMOTIONS@AviatrixJetToCrash"
                    },
                    {
                        id: '40',
                        url: '/promotions/aviator-rain',
                        icon: '',
                        authkey:"showAviatorRainPromo",
                        label: "PROMOTIONS@AviatorRainPromo"
                    },
                    {
                        id: '41',
                        url: '/promotions/jet-set-with-jetx',
                        icon: '',
                        authkey:"showJetSetWithJetXPromo",
                        label: "PROMOTIONS@JetSetWithJetX"
                    },
                    {
                        id: '42',
                        url: '/promotions/womens-world-cup',
                        icon: '',
                        authkey:"showWomensWorldCupPromo",
                        label: "PROMOTIONS@WomensWorldCup"
                    },
                    {
                        id: '43',
                        url: '/promotions/big-bash-big-cash',
                        icon: '',
                        authkey:"showBigBashBigCashPromo",
                        label: "PROMOTIONS@BigBashBigCash"
                    },
                    {
                        id: '44',
                        url: '/promotions/the-live-jackpot',
                        icon: '',
                        authkey:"showLiveJackPot2025Promo",
                        label: "PROMOTIONS@LiveJackPot2025"
                    },
                    {
                        id: '45',
                        url: '/promotions/instant-challenge-2025',
                        icon: '',
                        authkey:"showInstantChallengePromo",
                        label: "PROMOTIONS@InstantChallengePromo"
                    },
                    {
                        id: '46',
                        url: '/promotions/super-slots-challenge',
                        icon: '',
                        authkey:"showSuperSlotsChallengePromo",
                        label: "PROMOTIONS@SuperSlotsChallenge"
                    },
                    {
                        id: '47',
                        url: '/promotions/icc-champions-trophy',
                        icon: '',
                        authkey:"showChampionsTrophyPromo",
                        label: "PROMOTIONS@ChampionsTrophy"
                    },
                    {
                        id: '49',
                        url: '/promotions/daily-leaderboard',
                        icon: '',
                        authkey:"showDailyLeaderboard",
                        label: "PROMOTIONS@DailyLeaderBoard"
                    },
                    {
                        id: '50',
                        url: '/promotions/aviatrix-sky-high-challenge',
                        icon: '',
                        authkey:"showAviatrixSkyHighChallengePromo",
                        label: "PROMOTIONS@AviatrixSKYHighChallenge"
                    },
                    {
                        id: '51',
                        url: '/promotions/lightning-cashback',
                        icon: '',
                        authkey:"showLightningCashback2k25",
                        label: "PROMOTIONS@LightningCashback2k25"
                    },
                    {
                        id: '52',
                        url: '/promotions/galaxsys-tournament',
                        icon: '',
                        authkey:"showGalaxsysTournament",
                        label: "PROMOTIONS@GalaxsysTournamentPromo"
                    },
                    {
                        id: '53',
                        url: '/promotions/smartsoft-price-drop',
                        icon: '',
                        authkey:"showSmartSoftPriceDrop",
                        label: "PROMOTIONS@SmartSoftPriceDropTitle"
                    },
                    {
                        id: '54',
                        url: '/promotions/jili-jackpot-league',
                        icon: '',
                        authkey:"ShowJiliSpinWinLeaguePromo",
                        label: "PROMOTIONS@JiliSpinWinLeague"
                    },
                    {
                        id: '55',
                        url: '/promotions/crazy-prize-drop',
                        icon: '',
                        authkey:"ShowCrazyPrizeDropPromo",
                        label: "PROMOTIONS@EvolutionCrazyPrizeDrop"
                    },
                    {
                        id: '56',
                        url: '/promotions/ipl-jackpot',
                        icon: '',
                        authkey:"showIPLJackpotPromo",
                        label: "PROMOTIONS@IPLJackpotPromo2k25"
                    },
                    {
                        id: '57',
                        url: '/promotions/100-lossback-bonus',
                        icon: '',
                        authkey:"show100LossBackPromo25",
                        label: "PROMOTIONS@HundredLossbackPromo"
                    },
                    {
                        id: '58',
                        url: '/promotions/spin-and-rule-jili-slots',
                        icon: '',
                        authkey:"showSpinAndRuleJiliSlotsPromo",
                        label: "PROMOTIONS@SpinAndRuleJiliSlotsPromo"
                    },
                    {
                        id: '59',
                        url: '/promotions/jili-bonus-spin',
                        icon: '',
                        authkey:"showJiliPlayPatrioticPromo",
                        label: "PROMOTIONS@JiliPlayPatrioticPromo"
                    },
                    {
                        id: '6603',
                        url: '/promotions/twenty-free-spins',
                        icon: '',
                        authkey:"showFreeSpinsPromo",
                        label: "PROMOTIONS@TwentyFreeSpins"
                    },
                    {
                        id: '61',
                        url: '/promotions/jili-slots-bet-converter',
                        icon: '',
                        authkey:"ShowAviatorBetToWinBoostPromo",
                        label: "PROMOTIONS@AviatorBetToWinBoost"
                    },
                    {
                        id: '62',
                        url: '/promotions/asiacup-cashback',
                        icon: '',
                        authkey:"showYoloCashbackSixer",
                        label: "PROMOTIONS@YoloCashbackSixer"
                    },
                    {
                        id: '63',
                        url: '/promotions/weekly-leaderboard',
                        icon: '',
                        authkey:"showWeeklyLeaderboard",
                        label: "PROMOTIONS@WeeklyLeaderBoard"
                    },
                    {
                        id: '64',
                        url: '/promotions/super-chicken-rush',
                        icon: '',
                        authkey:"showSuperChickenRushPromo",
                        label: "PROMOTIONS@superChickenRushPromo"
                    },
                    {
                        id: '66',
                        url: '/promotions/surprise-evolution',
                        icon: '',
                        authkey:"showSurpriseDhamakaPromo",
                        label: "PROMOTIONS@SurpriseDhamaka"
                    },
                    {
                        id: '67',
                        url: '/promotions/international-league-t20',
                        icon: '',
                        authkey:"showILT20Promo",
                        label: "PROMOTIONS@ILT20Promo"
                    },
                    {
                        id: '70',
                        url: '/promotions/exchange-safety-net',
                        icon: '',
                        authkey:"showHundredSafetyPromo",
                        label: "PROMOTIONS@ExchangeSafetyPromo"
                    },
                    {
                        id: '71',
                        url: '/promotions/aviator-26-free-bets-bonanza',
                        icon: '',
                        authkey:"ShowAviator26FBBPromo",
                        label: "PROMOTIONS@Aviator26FBBPromo"
                    },
                    {
                        id: '72',
                        url: '/promotions/deposit-with-6-win-26x-bonus',
                        icon: '',
                        authkey:"showDeposit6x26xBonusPromo",
                        label: "PROMOTIONS@Deposit6x26xBonusPromo"
                    },
                    {
                        id: '73',
                        url: '/promotions/monday-happy-hours',
                        icon: '',
                        authkey:"showMondayHappyHourPromo",
                        label: "PROMOTIONS@MondayHappyHourPromo"
                    },
                    {
                        id: '74',
                        url: '/promotions/chicken-road',
                        icon: '',
                        authkey:"showChickenRoadPromo",
                        label: "PROMOTIONS@chickenRoadPromo"
                    },
                    {
                        id: '75',
                        url: '/promotions/evolution-live-rewards',
                        icon: '',
                        authkey:"showEvoLiveRewrds2k26Promo",
                        label: "PROMOTIONS@EvoLiveRewrdsPromo"
                    },
                    {
                        id: '76',
                        url: '/promotions/welcome-free-spins',
                        icon: '',
                        authkey:"showWelcomeFreeSpins",
                        label: "PROMOTIONS@WelcomeFreeSpinsPromo"
                    },
                    {
                        id: '77',
                        url: '/promotions/aviator-free-bets-with-ipl-bets',
                        icon: '',
                        authkey:"showAviatorFreeBetsWthIPLBetsPromo",
                        label: "PROMOTIONS@AviatorFreeBetsWthIPLBetsPromo"
                    },
                    {
                        id: '78',
                        url: '/promotions/leaderboard-2026',
                        icon: '',
                        authkey:"showLeaderboard2k26Promo",
                        label: "PROMOTIONS@LeaderboardPromoTitle"
                    },
                    {
                        id: '79',
                        url: '/promotions/free-spins-jili',
                        icon: '',
                        authkey:"showJiliFreeSpinsPromo",
                        label: "PROMOTIONS@jiliFreeSpinsPromo"
                    },
                    {
                        id: '80',
                        url: '/promotions/weekly-deposits',
                        icon: '',
                        authkey:"showWeeklyDesposit",
                        label: "PROMOTIONS@WeeklyDespositPromo"
                    },
                    {
                        id: '81',
                        url: '/promotions/evolution-powerplay-strike',
                        icon: '',
                        authkey:"showEvolutionpPowerPlayPromo",
                        label: "PROMOTIONS@EvoPowerplayStrikePromo"
                    },
                    {
                        id: '82',
                        url: '/promotions/daily-betback',
                        icon: '',
                        authkey:"showDailyBetBackPromo",
                        label: "PROMOTIONS@DailyBetBackPromo"
                    },
                    {
                        id: '83',
                        url: '/promotions/playtech-new-launch-win-big',
                        icon: '',
                        authkey:"showPlaytechNewLaunch",
                        label: "PROMOTIONS@PlaytechNewLaunchPromo"
                    },
                    {
                        id: '84',
                        url: '/promotions/tower-rush-jackpot',
                        icon: '',
                        authkey:"showTowerRushJackpotPromo",
                        label: "PROMOTIONS@ToweRushJackpot"
                    },
                    {
                        id: '85',
                        url: '/promotions/place-9-bets-win-up-to-99x',
                        icon: '',
                        authkey:"showPlace9BetsWinUpTo99X",
                        label: "PROMOTIONS@Place9BetsWinUpTo99XPromo"
                    },
                    {
                        id: '86',
                        url: '/promotions/up-to-100-free-spins-on-ganesh-gold',
                        icon: '',
                        authkey:"show100FreeSpinOnGaneshGold",
                        label: "PROMOTIONS@100FreeSpinOnGaneshGold"
                    }
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@ExploreALL'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm1',
                    url: '/promotions/welcome-bonus',
                    image: 'DROPDOWN_WELCOME_BONUS_NEW.png',
                    label: 'PROMOTIONSTITLE@WELCOME',
                    authkey: "showWelcomeBonus"
                },
                {
                    id: 'rm2',
                    url: '/promotions/refill-bonus',
                    image: 'DROPDOWN_REFILLBONUS_NEW.png',
                    label: 'PROMOTIONS@REFILLBONUS',
                    authkey: "showRefillBonus"
                },
                {
                    id: 'rm3',
                    url: '/promotions/cashback-bonus',
                    image: 'DROPDOWN_CASHBACKBONUS_NEW.png',
                    label: 'PROMOTIONS@FomoLossBackBonus',
                    authkey: "showFomoLossBackBonus"
                }
            ]
        },
    },
    40:{
        casino: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/live-casino/roulette',
                        icon: '',
                        label: 'TITLE@ROULETTESIDEBAR',
                        authkey: 'showRoulette'
                    },
                    {
                        id: '2',
                        url: '/live-casino/blackjack',
                        icon: '',
                        label: 'TITLE@BLACKJACKSIDEBAR',
                        authkey: 'showBlackjack'
                    },
                    {
                        id: '3',
                        url: '/live-casino/baccarat',
                        icon: '',
                        label: 'TITLE@BACCARAT',
                        authkey: 'showBaccarat'
                    },
                    {
                        id: '4',
                        url: '/live-casino/dragon-tiger',
                        icon: '',
                        label: 'TITLE@DRAGON_TIGER',
                        authkey: 'showDragontiger'
                    }
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@ENJOY'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm3',
                    url:'/popular-games',
                    image: 'DROPDOWN_POPULAR.png',
                    label: 'TITLE@populargames'
                },
                {

                    id: 'rm1',
                    url:'/live-casino',
                    image: 'DROPDOWN_CASINO_LIVE_CASINO.png',
                    label: 'TITLE@LIVECASINO',
                    authkey: 'showOnlineCasinoGamesLink'
                },
                {
                    id: 'rm2',
                    url:'/slots',
                    image: 'DROPDOWN_SLOT_BINGO.png',
                    label: 'TITLE@SLOTBINGO'
                }
            
             
                    ]
        },
        instant_games: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/instant-games/smartsoft/plinkox',
                        icon: '',
                        label: "TITLE@Plinko",
                        authkey: "showInstantThumbs"
                    },
                    // {
                    //     id: '2',
                    //     url: '/instant-games/smartsoft/footballx',
                    //     icon: '',
                    //     label: 'TITLE@Footballx',
                    //     authkey: "showInstantThumbs"
                    // },
                    // {
                    //     id: '3',
                    //     url: '/instant-games/smartsoft/balloon',
                    //     icon: '',
                    //     label: 'TITLE@Baloon',
                    //     authkey: "showInstantThumbs"
                    // },
                    {
                        id: '4',
                        url: '/instant-games/inout/chicken-road-2',
                        icon: '',
                        authkey:"showInstantThumbs",
                        label: "TITLE@ChickenRoad2"
                    },
                    {
                        id: '5',
                        url: '/instant-games/galaxsys/ninja-crash',
                        icon: '',
                        authkey:"showInstantThumbs",
                        label: "TITLE@ninjacrush"
                    },
                    {
                        id: '6',
                        url: '/instant-games/aviatrix/play-aviatrix',
                        icon: '',
                        authkey:"showInstantThumbs",
                        label: "GAME@AVIATRIX"
                    },
                    {
                        id: '7',
                        url: '/instant-games',
                        icon: '',
                        authkey:"showInstantThumbs",
                        label: "HEADER@VIEWALL"
                    }
                
                
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@ExploreALL'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm1',
                    url: '/instant-games/spribe/aviator',
                    image: 'aviator-instant-cashsite-dropdown.png',
                    label: 'TITLE@AVIATOR',
                    authkey: "showInstantThumbs"
                },
                {
                    id: 'rm2',
                    url: '/instant-games/galaxsys/rocketon',
                    image: 'DROPDOWN_ROKETON_INSTANT.png',
                    label: 'TITLE@roketon',
                    authkey: "showInstantThumbs"
                },
                {
                    id: 'rm3',
                    url: '/instant-games/smartsoft/jetx',
                    image: 'jetx-instant-cashsite-drowpdown.png',
                    label: 'TITLE@JetX',
                    authkey: "showInstantThumbs"
                }
            ]
        },
        hotgames: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/live-casino/evolution/monopoly-live',
                        icon: '',
                        label: 'TITLE@MonopolyLive',
                        authkey: 'showTeenpatti'
                    },
                    {
                        id: '2',
                        url: '/live-casino/evolution/funky-time',
                        icon: '',
                        label: 'TITLE@FunkyTimes',
                        authkey: 'showTeenpatti2020'
                    },
                    {
                        id: '3',
                        url: '/live-casino/evolution/lightning-dice',
                        icon: '',
                        label: 'TITLE@LightningDice',
                        authkey: 'showTeenpatti2020'
                    },
                    {
                        id: '4',
                        url: '/live-casino/dragon-tiger',
                        icon: '',
                        label: 'TITLE@DragonTiger',
                        authkey: 'showTeenpatti2020'
                    },
                    {
                        id: '5',
                        url: '/instant-games/smartsoft/cricketx',
                        icon: '',
                        label: 'TITLE@CricketX',
                        authkey: 'showTeenpatti2020'
                    },
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@PLAYANDNEVER'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm1',
                    url:'/live-casino/evolution/crazy-time',
                    image: 'DROPDOWN_CRAZY_TIME.png',
                    label: "TITLE@crazytime",
                    authkey: 'showTeenpattiLink'
                },
                {
                    id: 'rm2',
                    url:'/live-casino/evolution/lightning-roulette',
                    image: 'DROPDOWN_LIGHTNING_ROULETTE.png',
                    label: 'TITLE@LIGHTINGROULETTE',
                    authkey: 'showTeenpattiLink'
                },
                {
                    id: 'rm3',
                    url:'/live-casino/dragon-tiger',
                    image: 'DROPDOWN_evodragontiger.png',
                    label: 'TITLE@DragonTiger',
                    authkey: 'showTeenpattiLink'
                }
            ]
        },
        sports: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/betting-exchange/cricket',
                        icon: '',
                        label: 'SPORT@CRICKET',
                        authkey: 'showSportCricket'
                    },
                    {
                        id: '2',
                        url: '/betting-exchange/football',
                        icon: '',
                        label: 'SPORT@FOOTBALL',
                        authkey: 'showSportFootball'
                    },
                    {
                        id: '3',
                        url: '/betting-exchange/tennis',
                        icon: '',
                        label: 'SPORT@TENNIS',
                        authkey: 'showSportTennis'
                    },
                    // {
                    //     id: '4',
                    //     url: '/betting-exchange/volleyball',
                    //     icon: '',
                    //     label: 'SPORT@VolleyBall',
                    //     authkey: 'showSportVolleyball'
                    // },
                    // {
                    //     id: '5',
                    //     url: '/virtualSports/vci',
                    //     icon: '',
                    //     label: 'TITLE@VIRTUALSPORTS',
                    //     authkey: 'showVirtualSportsvfec'
                    // },
                    {
                        id: '6',
                        url: '/sports/tournaments/',
                        icon: '',
                        label: 'TITLE@Tournaments',
                        authkey: 'showTournaments'
                    },
                    // {
                    //     id: '7',
                    //     url: '/saba-sports',
                    //     icon: '',
                    //     label: 'TITLE@SabaSports',
                    //     authkey: 'showSabaSportsStatement'
                    // }
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@GOONTURN'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm1',
                    url:'/betting-exchange',
                    image: 'DROPDOWN_EXCHANGE_FOMO.png',
                    label: 'TITLE@EXCHANGE',
                    authkey: 'showExchangeLink',
                    itemsCount: '5'
                },
                // {
                //     id: 'rm5',
                //     url:'/premium-sportsbook/kabaddi-betting',
                //     image: 'kabbadiFomo.png',
                //     label: 'MENU@Kabbadi',
                //     authkey: 'showProKabbadi',
                //     itemsCount: '5'
                // },
                {
                    id: 'rm2',
                    url:'/premium-sportsbook',
                    image: 'premiumSportsbookDropdownFomo.png',
                    label: 'TITLE@PREMIUM_SPORTSBOOK',
                    authkey: 'showPremiumSportsLink',
                    itemsCount: '5'
                },
                {
                    id: 'rm3',
                    url:'/sportsbook',
                    image: 'DROPDOWN_SPORTSBOOK_NEW.png',
                    label: 'MENU@SPORTBOOK',
                    authkey: 'showSportBookLink',
                    itemsCount: '5'
                },
                {
                    id: 'rm4',
                    url:'/saba-sports',
                    image: 'FomoSabaDesk.png',
                    label: 'TITLE@SabaSports',
                    authkey: 'showSabaSportsStatement',
                    itemsCount: '5'
                },
                // {
                //     id: 'rm4',
                //     url:'/virtualSports/vci',
                //     image: 'virtualSportsDesktopDropdown.png',
                //     label: 'GAME@VIRTUALSPORTS',
                //     authkey: 'showVirtualSportsvfel'
                // },
            ]
        },
        promotions: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/promotions/welcome-bonus',
                        icon: '',
                        label: "PROMOTIONSTITLE@WELCOME"
                    },
                    {
                        id: '2',
                        url: '/promotions/refill-bonus',
                        icon: '',
                        label: 'PROMOTIONS@REFILLBONUS',
                        authkey: "showRefillBonus"
                    },
                    {
                        id: '3',
                        url: '/promotions/cashback-bonus',
                        icon: '',
                        label: 'PROMOTIONSTITLE@CASHBACK',
                        authkey: "showCashbackBonus"
                    },
                    {
                        id: '4',
                        url: '/promotions/referral-bonus',
                        icon: '',
                        authkey:"showReferralBonus",
                        label: "ProBonus@Referral"
                    },   
                    {
                        id: '5',
                        url: '/promotions/big-bash',
                        icon: '',
                        authkey:"showBBLBonus",
                        label: "PROMOTIONS@BBLBonus"
                    },
                    {
                        id: '6',
                        url: '/promotions/arjith_promo',
                        icon: '',
                        authkey:"showSingWithYolo",
                        label: "PROMOTIONS@singYolo"
                    },
                    {
                        id: '7',
                        url: '/promotions/jetx-tournament',
                        icon: '',
                        authkey:"jetxpromo",                                 
                        label:"jetx"
                    },
                    {
                        id: '8',
                        url: '/promotions/crazyCrash',
                        icon: '',
                        authkey:"showCrazyCrashPromo",
                        label:"PROMOTIONS@crazyCrashPromo"
                    },
                    {   id: '9',
                        url: '/promotions/aviator-bonus',
                        icon: '',
                        authkey:"showAviatorBonus",
                        label:"PROMOTIONS@AviatorBonus"
                    },   
                    {
                        id: '10',
                        url: '/promotions/evolution-first-bet',
                        icon: '',
                        authkey:"showEvolutionpromo",
                        label: "PROMOTIONS@firstperson"
                    },
                    {
                        id: '11',
                        url: '/promotions/funkytime',
                        icon: '',
                        authkey:"showFunkytimePromo",
                        label: "PROMOTIONS@funkytime"
                    },
                    {
                        id: '15',
                        url: '/promotions/evo-baccarat',
                        icon: '',
                        authkey:"showEvoCasinoCupPromo",
                        label: "PROMOTIONS@EvoCasinoCupPromo"
                    },
                    {
                        id: '12',
                        url: '/promotions/worldcup-cashback-bonanza',
                        icon: '',
                        authkey:"showWCBonusPromo",
                        label: "PROMOTIONS@WCCBONAZA"
                    },
                    {
                        id: '13',
                        url: '/promotions/platinum-rush',
                        icon: '',
                        authkey:"showPlatinumRush",
                        label: "PROMOTIONS@Platinumrush"
                    },
                    {
                        id: '14',
                        url: '/promotions/worldcup-betboost',
                        icon: '',
                        authkey:"showWCBonusPromo",
                        label: "TITLE@wcbetboost"
                    },
                    {
                        id: '15',
                        url: '/promotions/catch99-s2',
                        icon: '',
                        authkey:"showCatch99Bonus",
                        label: "PROMOTIONS@CATCH99"
                    },
                    // {
                    //     id: '16',
                    //     url: '/promotions/evolution-crazy-pachinko',
                    //     icon: '',
                    //     authkey:"showCrazyPachinkoPromo",
                    //     label: "TITLE@EvoCrazyPachinko"
                    // },
                    {
                        id: '17',
                        url: '/promotions/jetx-celestial-rush',
                        icon: '',
                        authkey:"showJetXCelestialRush",
                        label: "PROMOTIONS@JetxCelestial"
                    },
                    {
                        id: '18',
                        url: '/promotions/aviatrix-double-dhamaka',
                        icon: '',
                        authkey:"showAviatrixPromo",
                        label: "PROMOTIONS@AviatrixDoubleDhamaka"
                    },
                    {
                        id: '19',
                        url: '/promotions/cricket-cashback-marathon',
                        icon: '',
                        authkey:"showcircketCashbackMarathon",
                        label: "PROMOTIONS@CricketCashbackMarathon"
                    },
                    {
                        id: '20',
                        url: '/promotions/crazytime-epic-bonanza',
                        icon: '',
                        authkey:"showCrazyTimePromo",
                        label: "PROMOTIONS@CrazyTimeEpicBonanza"
                    },
                    {
                        id: '21',
                        url: '/promotions/aviator-high-flyer',
                        icon: '',
                        authkey:"showAviatorHighFlyerPromo",
                        label: "PROMOTIONS@AviatorHighFlyer"
                    }, 
                    {
                        id: '22',
                        url: '/promotions/smartsoft-spin-and-win',
                        icon: '',
                        authkey:"showSmartsoft",
                        label: "PROMOTIONS@Smartsoft"
                    },


                    {
                        id: '23',
                        url: '/promotions/evolution-casino-cup',
                        icon: '',
                        authkey:"showEvolutionCasionCup",
                        label: "PROMOTIONS@EvolutionCasionCup"
                    },
                    {
                        id: '24',
                        url: '/promotions/IPL-Betting-dhamaka-Power-Play-Bonus',
                        icon: '',
                        authkey:"shoeIPLpowerPlay",
                        label: "PROMOTIONS@IPLPOWERPLAY1"
                    },
                    {
                        id: '25',
                        url: '/promotions/indian-galaxsys-league',
                        icon: '',
                        authkey:"showIndianGalaxysLeague",
                        label: "PROMOTIONS@IndianGalaxsysLeague"
                    },
                    {
                        id: '26',
                        url: '/promotions/ipl-betting-dhamaka',
                        icon: '',
                        authkey:"showIplPromo",
                        label: "PROMOTIONS@iplmatka"
                    },
                    {
                        id: '27',
                        url: '/promotions/double-cashback',
                        icon: '',
                        authkey:"showDoubleCashBack",
                        label: "PROMOTIONS@DoubleCashback"
                    },
                    {
                        id: '28',
                        url: '/promotions/aviator-sky-bound-miles',
                        icon: '',
                        authkey:"showAviatorSkyBoundMiles",
                        label: "PROMOTIONS@AviatorSkyBoundMiles"
                    },
                    {
                        id: '29',
                        url: '/promotions/wc-LossBack-Exchange',
                        icon: '',
                        authkey:"showFomoWcLossBackExchPromo",
                        label: "PROMOTIONS@FomoWorldCupLossBackExch"
                    },
                    {
                        id: '30',
                        url: '/promotions/wc-goIndia-goJackpot',
                        icon: '',
                        authkey:"showFomoGoIndiaGoJackpotPromo",
                        label: "PROMOTIONS@FomoWorldCupGoIndiaGoJackpot"
                    },
                    {
                        id: '30',
                        url: '/promotions/aviator-wingsOfAdventure',
                        icon: '',
                        authkey:"showFomoAviatorWingsofAdventurePromo",
                        label: "PROMOTIONS@FomoAviatorWingsOfAdventure"
                    },
                    {
                        id: '31',
                        url: '/promotions/evolution-casino-challenge',
                        icon: '',
                        authkey:"showFomoEvolutionCasinoChallengePromo",
                        label: "PROMOTIONS@FomoEvolutionCasinoChallenge"
                    },
                    {
                        id: '32',
                        url: '/promotions/aviatrix-fiyHigh',
                        icon: '',
                        authkey:"showFomoAviatrixFlyHighPromo",
                        label: "PROMOTIONS@FomoAviatrixFlyHigh"
                    },
                    {
                        id: '33',
                        url: '/promotions/wc-dailyDeposit-bonus',
                        icon: '',
                        authkey:"showWcDailyDepositBonusPromo",
                        label: "PROMOTIONS@FomoWorldCupDailyDesposit"
                    },
                    {
                        id: '34',
                        url: '/promotions/smartsoft-spin-and-win',
                        icon: '',
                        authkey:"showSmartSoftJetxCelestial",
                        label: "PROMOTIONS@SmartSoftJetxCelestial"
                    },
                    {
                        id: '35',
                        url: '/promotions/mines-legend-trophy',
                        icon: '',
                        authkey:"showMinesLegendTrophyPromo",
                        label: "PROMOTIONS@MinesLegendTrophy"
                    },
                    {
                        id: '36',
                        url: '/promotions/caribbean-premier-league',
                        icon: '',
                        authkey:"showCaribbeanLeagueBonusPromo",
                        label: "PROMOTIONS@CaribbeanLeagueBonus"
                    },
                    {
                        id: '37',
                        url: '/promotions/evolution-roulette-cup',
                        icon: '',
                        authkey:"showEvolutionRouletteCupPromo",
                        label: "PROMOTIONS@EvolutionRouletteCup"
                    },
                    {
                        id: '38',
                        url: '/promotions/aviatrix-fly-and-play',
                        icon: '',
                        authkey:"showAviatrixFlyAndPlayPromo",
                        label: "PROMOTIONS@AviatrixFlyAndPlay"
                    },
                    {
                        id: '39',
                        url: '/promotions/aviatrix-jet-to-cash',
                        icon: '',
                        authkey:"showAviatrixJetToCrash",
                        label: "PROMOTIONS@AviatrixJetToCrash"
                    },
                    {
                        id: '40',
                        url: '/promotions/aviator-rain',
                        icon: '',
                        authkey:"showAviatorRainPromo",
                        label: "PROMOTIONS@AviatorRainPromo"
                    },
                    {
                        id: '41',
                        url: '/promotions/jet-set-with-jetx',
                        icon: '',
                        authkey:"showJetSetWithJetXPromo",
                        label: "PROMOTIONS@JetSetWithJetX"
                    },
                    {
                        id: '42',
                        url: '/promotions/womens-world-cup',
                        icon: '',
                        authkey:"showWomensWorldCupPromo",
                        label: "PROMOTIONS@WomensWorldCup"
                    },
                    {
                        id: '43',
                        url: '/promotions/big-bash-big-cash',
                        icon: '',
                        authkey:"showBigBashBigCashPromo",
                        label: "PROMOTIONS@BigBashBigCash"
                    },
                    {
                        id: '44',
                        url: '/promotions/the-live-jackpot',
                        icon: '',
                        authkey:"showLiveJackPot2025Promo",
                        label: "PROMOTIONS@LiveJackPot2025"
                    },
                    {
                        id: '45',
                        url: '/promotions/instant-challenge-2025',
                        icon: '',
                        authkey:"showInstantChallengePromo",
                        label: "PROMOTIONS@InstantChallengePromo"
                    },
                    {
                        id: '46',
                        url: '/promotions/super-slots-challenge',
                        icon: '',
                        authkey:"showSuperSlotsChallengePromo",
                        label: "PROMOTIONS@SuperSlotsChallenge"
                    },
                    {
                        id: '47',
                        url: '/promotions/icc-champions-trophy',
                        icon: '',
                        authkey:"showChampionsTrophyPromo",
                        label: "PROMOTIONS@ChampionsTrophy"
                    },
                    {
                        id: '49',
                        url: '/promotions/daily-leaderboard',
                        icon: '',
                        authkey:"showDailyLeaderboard",
                        label: "PROMOTIONS@DailyLeaderBoard"
                    },
                    {
                        id: '50',
                        url: '/promotions/aviatrix-sky-high-challenge',
                        icon: '',
                        authkey:"showAviatrixSkyHighChallengePromo",
                        label: "PROMOTIONS@AviatrixSKYHighChallenge"
                    },
                    {
                        id: '51',
                        url: '/promotions/lightning-cashback',
                        icon: '',
                        authkey:"showLightningCashback2k25",
                        label: "PROMOTIONS@LightningCashback2k25"
                    },
                    {
                        id: '52',
                        url: '/promotions/galaxsys-tournament',
                        icon: '',
                        authkey:"showGalaxsysTournament",
                        label: "PROMOTIONS@GalaxsysTournamentPromo"
                    },
                    {
                        id: '53',
                        url: '/promotions/smartsoft-price-drop',
                        icon: '',
                        authkey:"showSmartSoftPriceDrop",
                        label: "PROMOTIONS@SmartSoftPriceDropTitle"
                    },
                    {
                        id: '54',
                        url: '/promotions/jili-jackpot-league',
                        icon: '',
                        authkey:"ShowJiliSpinWinLeaguePromo",
                        label: "PROMOTIONS@JiliSpinWinLeague"
                    },
                    {
                        id: '55',
                        url: '/promotions/crazy-prize-drop',
                        icon: '',
                        authkey:"ShowCrazyPrizeDropPromo",
                        label: "PROMOTIONS@EvolutionCrazyPrizeDrop"
                    },
                    {
                        id: '56',
                        url: '/promotions/ipl-jackpot',
                        icon: '',
                        authkey:"showIPLJackpotPromo",
                        label: "PROMOTIONS@IPLJackpotPromo2k25"
                    },
                    {
                        id: '57',
                        url: '/promotions/100-lossback-bonus',
                        icon: '',
                        authkey:"show100LossBackPromo25",
                        label: "PROMOTIONS@HundredLossbackPromo"
                    },
                    {
                        id: '58',
                        url: '/promotions/spin-and-rule-jili-slots',
                        icon: '',
                        authkey:"showSpinAndRuleJiliSlotsPromo",
                        label: "PROMOTIONS@SpinAndRuleJiliSlotsPromo"
                    },
                    {
                        id: '59',
                        url: '/promotions/jili-bonus-spin',
                        icon: '',
                        authkey:"showJiliPlayPatrioticPromo",
                        label: "PROMOTIONS@JiliPlayPatrioticPromo"
                    },
                    {
                        id: '60',
                        url: '/promotions/twenty-free-spins',
                        icon: '',
                        authkey:"showFreeSpinsPromo",
                        label: "PROMOTIONS@TwentyFreeSpins"
                    },
                    {
                        id: '61',
                        url: '/promotions/jili-slots-bet-converter',
                        icon: '',
                        authkey:"ShowAviatorBetToWinBoostPromo",
                        label: "PROMOTIONS@AviatorBetToWinBoost"
                    },
                    {
                        id: '62',
                        url: '/promotions/asiacup-cashback',
                        icon: '',
                        authkey:"showYoloCashbackSixer",
                        label: "PROMOTIONS@YoloCashbackSixer"
                    },
                    {
                        id: '63',
                        url: '/promotions/weekly-leaderboard',
                        icon: '',
                        authkey:"showWeeklyLeaderboard",
                        label: "PROMOTIONS@WeeklyLeaderBoard"
                    },
                    {
                        id: '64',
                        url: '/promotions/super-chicken-rush',
                        icon: '',
                        authkey:"showSuperChickenRushPromo",
                        label: "PROMOTIONS@superChickenRushPromo"
                    },
                    {
                        id: '66',
                        url: '/promotions/surprise-evolution',
                        icon: '',
                        authkey:"showSurpriseDhamakaPromo",
                        label: "PROMOTIONS@SurpriseDhamaka"
                    },
                    {
                        id: '67',
                        url: '/promotions/international-league-t20',
                        icon: '',
                        authkey:"showILT20Promo",
                        label: "PROMOTIONS@ILT20Promo"
                    },
                    {
                        id: '70',
                        url: '/promotions/exchange-safety-net',
                        icon: '',
                        authkey:"showHundredSafetyPromo",
                        label: "PROMOTIONS@ExchangeSafetyPromo"
                    },
                    {
                        id: '71',
                        url: '/promotions/aviator-26-free-bets-bonanza',
                        icon: '',
                        authkey:"ShowAviator26FBBPromo",
                        label: "PROMOTIONS@Aviator26FBBPromo"
                    },
                    {
                        id: '72',
                        url: '/promotions/deposit-with-6-win-26x-bonus',
                        icon: '',
                        authkey:"showDeposit6x26xBonusPromo",
                        label: "PROMOTIONS@Deposit6x26xBonusPromo"
                    },
                    {
                        id: '73',
                        url: '/promotions/monday-happy-hours',
                        icon: '',
                        authkey:"showMondayHappyHourPromo",
                        label: "PROMOTIONS@MondayHappyHourPromo"
                    },
                    {
                        id: '74',
                        url: '/promotions/chicken-road',
                        icon: '',
                        authkey:"showChickenRoadPromo",
                        label: "PROMOTIONS@chickenRoadPromo"
                    },
                    {
                        id: '75',
                        url: '/promotions/evolution-live-rewards',
                        icon: '',
                        authkey:"showEvoLiveRewrds2k26Promo",
                        label: "PROMOTIONS@EvoLiveRewrdsPromo"
                    },
                    {
                        id: '76',
                        url: '/promotions/welcome-free-spins',
                        icon: '',
                        authkey:"showWelcomeFreeSpins",
                        label: "PROMOTIONS@WelcomeFreeSpinsPromo"
                    },
                    {
                        id: '77',
                        url: '/promotions/aviator-free-bets-with-ipl-bets',
                        icon: '',
                        authkey:"showAviatorFreeBetsWthIPLBetsPromo",
                        label: "PROMOTIONS@AviatorFreeBetsWthIPLBetsPromo"
                    },
                    {
                        id: '78',
                        url: '/promotions/leaderboard-2026',
                        icon: '',
                        authkey:"showLeaderboard2k26Promo",
                        label: "PROMOTIONS@LeaderboardPromoTitle"
                    },
                    {
                        id: '79',
                        url: '/promotions/free-spins-jili',
                        icon: '',
                        authkey:"showJiliFreeSpinsPromo",
                        label: "PROMOTIONS@jiliFreeSpinsPromo"
                    },
                    {
                        id: '80',
                        url: '/promotions/weekly-deposits',
                        icon: '',
                        authkey:"showWeeklyDesposit",
                        label: "PROMOTIONS@WeeklyDespositPromo"
                    },
                    {
                        id: '81',
                        url: '/promotions/evolution-powerplay-strike',
                        icon: '',
                        authkey:"showEvolutionpPowerPlayPromo",
                        label: "PROMOTIONS@EvoPowerplayStrikePromo"
                    },
                    {
                        id: '82',
                        url: '/promotions/daily-betback',
                        icon: '',
                        authkey:"showDailyBetBackPromo",
                        label: "PROMOTIONS@DailyBetBackPromo"
                    },
                    {
                        id: '83',
                        url: '/promotions/playtech-new-launch-win-big',
                        icon: '',
                        authkey:"showPlaytechNewLaunch",
                        label: "PROMOTIONS@PlaytechNewLaunchPromo"
                    },
                    {
                        id: '84',
                        url: '/promotions/tower-rush-jackpot',
                        icon: '',
                        authkey:"showTowerRushJackpotPromo",
                        label: "PROMOTIONS@ToweRushJackpot"
                    },
                    {
                        id: '85',
                        url: '/promotions/place-9-bets-win-up-to-99x',
                        icon: '',
                        authkey:"showPlace9BetsWinUpTo99X",
                        label: "PROMOTIONS@Place9BetsWinUpTo99XPromo"
                    },
                    {
                        id: '85',
                        url: '/promotions/up-to-100-free-spins-on-ganesh-gold',
                        icon: '',
                        authkey:"show100FreeSpinOnGaneshGold",
                        label: "PROMOTIONS@100FreeSpinOnGaneshGold"
                    }
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@ExploreALL'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm1',
                    url: '/promotions/welcome-bonus',
                    image: 'DROPDOWN_WELCOME_BONUS_NEW.png',
                    label: 'PROMOTIONSTITLE@WELCOME',
                    authkey: "showWelcomeBonus"
                },
                {
                    id: 'rm2',
                    url: '/promotions/refill-bonus',
                    image: 'DROPDOWN_REFILLBONUS_NEW.png',
                    label: 'PROMOTIONS@REFILLBONUS',
                    authkey: "showRefillBonus"
                },
                {
                    id: 'rm3',
                    url: '/promotions/cashback-bonus',
                    image: 'DROPDOWN_CASHBACKBONUS_NEW.png',
                    label: 'PROMOTIONS@FomoLossBackBonus',
                    authkey: "showFomoLossBackBonus"
                }
            ]
        },
    },
    46:{
        casino: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/live-casino/roulette',
                        icon: '',
                        label: 'TITLE@ROULETTESIDEBAR',
                        authkey: 'showRoulette'
                    },
                    {
                        id: '2',
                        url: '/live-casino/blackjack',
                        icon: '',
                        label: 'TITLE@BLACKJACKSIDEBAR',
                        authkey: 'showBlackjack'
                    },
                    {
                        id: '3',
                        url: '/live-casino/baccarat',
                        icon: '',
                        label: 'TITLE@BACCARAT',
                        authkey: 'showBaccarat'
                    },
                    {
                        id: '4',
                        url: '/live-casino/dragon-tiger',
                        icon: '',
                        label: 'TITLE@DRAGON_TIGER',
                        authkey: 'showDragontiger'
                    }
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@ENJOY'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm3',
                    url:'/popular-games',
                    image: 'DROPDOWN_POPULAR.png',
                    label: 'TITLE@populargames'
                },
                {

                    id: 'rm1',
                    url:'/live-casino',
                    image: 'DROPDOWN_CASINO_LIVE_CASINO.png',
                    label: 'TITLE@LIVECASINO',
                    authkey: 'showOnlineCasinoGamesLink'
                },
                {
                    id: 'rm2',
                    url:'/slots',
                    image: 'DROPDOWN_SLOT_BINGO.png',
                    label: 'TITLE@SLOTBINGO'
                }
            
             
                    ]
        },
        instant_games: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/instant-games/smartsoft/plinkox',
                        icon: '',
                        label: "TITLE@Plinko",
                        authkey: "showInstantThumbs"
                    },
                    // {
                    //     id: '2',
                    //     url: '/instant-games/smartsoft/footballx',
                    //     icon: '',
                    //     label: 'TITLE@Footballx',
                    //     authkey: "showInstantThumbs"
                    // },
                    // {
                    //     id: '3',
                    //     url: '/instant-games/smartsoft/balloon',
                    //     icon: '',
                    //     label: 'TITLE@Baloon',
                    //     authkey: "showInstantThumbs"
                    // },
                    {
                        id: '4',
                        url: '/instant-games/inout/chicken-road-2',
                        icon: '',
                        authkey:"showInstantThumbs",
                        label: "TITLE@ChickenRoad2"
                    },
                    {
                        id: '5',
                        url: '/instant-games/galaxsys/ninja-crash',
                        icon: '',
                        authkey:"showInstantThumbs",
                        label: "TITLE@ninjacrush"
                    },
                  
                    {
                        id: '7',
                        url: '/instant-games',
                        icon: '',
                        authkey:"showInstantThumbs",
                        label: "HEADER@VIEWALL"
                    }
                
                
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@ExploreALL'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm1',
                    url: '/instant-games/spribe/aviator',
                    image: 'aviator-instant-cashsite-dropdown.png',
                    label: 'TITLE@AVIATOR',
                    authkey: "showInstantThumbs"
                },
                {
                    id: 'rm2',
                    url: '/instant-games/smartsoft/jetx',
                    image: 'jetx-instant-cashsite-drowpdown.png',
                    label: 'TITLE@JetX',
                    authkey: "showInstantThumbs"
                },
                {
                    id: 'rm3',
                    url: '/instant-games/aviatrix/play-aviatrix',
                    image: 'AviatriXdropdown.png',
                    label: 'GAME@AVIATRIX',
                    authkey: "showInstantThumbs"
                }
                
            ]
        },
        hotgames: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/live-casino/evolution/monopoly-live',
                        icon: '',
                        label: 'TITLE@MonopolyLive',
                        authkey: 'showTeenpatti'
                    },
                    {
                        id: '2',
                        url: '/live-casino/evolution/funky-time',
                        icon: '',
                        label: 'TITLE@FunkyTimes',
                        authkey: 'showTeenpatti2020'
                    },
                    {
                        id: '3',
                        url: '/live-casino/evolution/lightning-dice',
                        icon: '',
                        label: 'TITLE@LightningDice',
                        authkey: 'showTeenpatti2020'
                    },
                    {
                        id: '4',
                        url: '/live-casino/dragon-tiger',
                        icon: '',
                        label: 'TITLE@DragonTiger',
                        authkey: 'showTeenpatti2020'
                    },
                    {
                        id: '5',
                        url: '/instant-games/smartsoft/cricketx',
                        icon: '',
                        label: 'TITLE@CricketX',
                        authkey: 'showTeenpatti2020'
                    },
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@PLAYANDNEVER'
                    },
                ]
            },
            rightMenu: [

                {
                    id: 'rm1',
                    url:'/instant-games/spribe/mines',
                    image: 'spribe-minesdropdown.png',
                    label: 'TITLE@Mines',
                    authkey: 'showTeenpattiLink'
                },
                {
                    id: 'rm2',
                    url:'/live-casino/evolution/crazy-time',
                    image: 'DROPDOWN_CRAZY_TIME.png',
                    label: "TITLE@crazytime",
                    authkey: 'showTeenpattiLink'
                },
                {
                    id: 'rm3',
                    url:'/live-casino/evolution/lightning-roulette',
                    image: 'DROPDOWN_LIGHTNING_ROULETTE.png',
                    label: 'TITLE@LIGHTINGROULETTE',
                    authkey: 'showTeenpattiLink'
                }
               
            ]
        },
        sports: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/betting-exchange/cricket',
                        icon: '',
                        label: 'SPORT@CRICKET',
                        authkey: 'showSportCricket'
                    },
                    {
                        id: '2',
                        url: '/betting-exchange/football',
                        icon: '',
                        label: 'SPORT@FOOTBALL',
                        authkey: 'showSportFootball'
                    },
                    {
                        id: '3',
                        url: '/betting-exchange/tennis',
                        icon: '',
                        label: 'SPORT@TENNIS',
                        authkey: 'showSportTennis'
                    },
                    // {
                    //     id: '4',
                    //     url: '/betting-exchange/volleyball',
                    //     icon: '',
                    //     label: 'SPORT@VolleyBall',
                    //     authkey: 'showSportVolleyball'
                    // },
                    // {
                    //     id: '5',
                    //     url: '/virtualSports/vci',
                    //     icon: '',
                    //     label: 'TITLE@VIRTUALSPORTS',
                    //     authkey: 'showVirtualSportsvfec'
                    // },
                    // {
                    //     id: '6',
                    //     url: '/saba-sports',
                    //     icon: '',
                    //     label: 'TITLE@SabaSports',
                    //     authkey: 'showSabaSportsStatement'
                    // }
                   
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@GOONTURN'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm1',
                    url:'/betting-exchange',
                    image: 'DROPDOWN_EXCHANGE_Fun88.png',
                    label: 'TITLE@EXCHANGE',
                    authkey: 'showExchangeLink',
                    itemsCount: '5'
                },
                // {
                //     id: 'rm5',
                //     url:'/premium-sportsbook/kabaddi-betting',
                //     image: 'kabbadiFun.png',
                //     label: 'MENU@Kabbadi',
                //     authkey: 'showProKabbadi',
                //     itemsCount: '5'
                // },
                {
                    id: 'rm2',
                    url:'/premium-sportsbook',
                    image: 'premiumSportsbookDropdownFun88.png',
                    label: 'TITLE@PREMIUM_SPORTSBOOK',
                    authkey: 'showPremiumSportsLink',
                    itemsCount: '5'
                },
                {
                    id: 'rm3',
                    url:'/sportsbook',
                    image: 'DROPDOWN_SPORTSBOOK_NEW.png',
                    label: 'MENU@SPORTBOOK',
                    authkey: 'showSportBookLink',
                    itemsCount: '5'
                },
                {
                    id: 'rm4',
                    url:'/saba-sports',
                    image: 'FunSabaDesk.png',
                    label: 'TITLE@SabaSports',
                    authkey: 'showSabaSportsStatement',
                    itemsCount: '5'
                },
                // {
                //     id: 'rm4',
                //     url:'/virtualSports/vci',
                //     image: 'virtualSportsDesktopDropdown.png',
                //     label: 'GAME@VIRTUALSPORTS',
                //     authkey: 'showVirtualSportsvfel'
                // },
            ]
        },
        promotions: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/promotions/welcome-bonus',
                        icon: '',
                        label: "PROMOTIONSTITLE@WELCOME"
                    },
                    {
                        id: '2',
                        url: '/promotions/refill-bonus',
                        icon: '',
                        label: 'PROMOTIONSTITLE@REFILL',
                        authkey: "showRefillBonus"
                    },
                    {
                        id: '3',
                        url: '/promotions/cashback-bonus',
                        icon: '',
                        label: 'PROMOTIONSTITLE@CASHBACK',
                        authkey: "showCashbackBonus"
                    },
                    {
                        id: '4',
                        url: '/promotions/referral-bonus',
                        icon: '',
                        authkey:"showReferralBonus",
                        label: "ProBonus@Referral"
                    },   
                    {
                        id: '5',
                        url: '/promotions/big-bash',
                        icon: '',
                        authkey:"showBBLBonus",
                        label: "PROMOTIONS@BBLBonus"
                    },
                    {
                        id: '6',
                        url: '/promotions/arjith_promo',
                        icon: '',
                        authkey:"showSingWithYolo",
                        label: "PROMOTIONS@singYolo"
                    },
                    {
                        id: '7',
                        url: '/promotions/jetx-tournament',
                        icon: '',
                        authkey:"jetxpromo",                                 
                        label:"jetx"
                    },
                    {
                        id: '8',
                        url: '/promotions/crazyCrash',
                        icon: '',
                        authkey:"showCrazyCrashPromo",
                        label:"PROMOTIONS@crazyCrashPromo"
                    },
                    {   id: '9',
                        url: '/promotions/aviator-bonus',
                        icon: '',
                        authkey:"showAviatorBonus",
                        label:"PROMOTIONS@AviatorBonus"
                    },   
                    {
                        id: '10',
                        url: '/promotions/evolution-first-bet',
                        icon: '',
                        authkey:"showEvolutionpromo",
                        label: "PROMOTIONS@firstperson"
                    },
                    {
                        id: '11',
                        url: '/promotions/funkytime',
                        icon: '',
                        authkey:"showFunkytimePromo",
                        label: "PROMOTIONS@funkytime"
                    },
                    {
                        id: '15',
                        url: '/promotions/evo-baccarat',
                        icon: '',
                        authkey:"showEvoCasinoCupPromo",
                        label: "PROMOTIONS@EvoCasinoCupPromo"
                    },
                    {
                        id: '12',
                        url: '/promotions/worldcup-cashback-bonanza',
                        icon: '',
                        authkey:"showWCBonusPromo",
                        label: "PROMOTIONS@WCCBONAZA"
                    },
                    {
                        id: '13',
                        url: '/promotions/platinum-rush',
                        icon: '',
                        authkey:"showPlatinumRush",
                        label: "PROMOTIONS@Platinumrush"
                    },
                    {
                        id: '14',
                        url: '/promotions/worldcup-betboost',
                        icon: '',
                        authkey:"showWCBonusPromo",
                        label: "TITLE@wcbetboost"
                    },
                    {
                        id: '15',
                        url: '/promotions/catch99-s2',
                        icon: '',
                        authkey:"showCatch99Bonus",
                        label: "PROMOTIONS@CATCH99"
                    },
                    // {
                    //     id: '16',
                    //     url: '/promotions/evolution-crazy-pachinko',
                    //     icon: '',
                    //     authkey:"showCrazyPachinkoPromo",
                    //     label: "TITLE@EvoCrazyPachinko"
                    // },
                    {
                        id: '17',
                        url: '/promotions/jetx-celestial-rush',
                        icon: '',
                        authkey:"showJetXCelestialRush",
                        label: "PROMOTIONS@JetxCelestial"
                    },
                    {
                        id: '18',
                        url: '/promotions/aviatrix-double-dhamaka',
                        icon: '',
                        authkey:"showAviatrixPromo",
                        label: "PROMOTIONS@AviatrixDoubleDhamaka"
                    },
                    {
                        id: '19',
                        url: '/promotions/cricket-cashback-marathon',
                        icon: '',
                        authkey:"showcircketCashbackMarathon",
                        label: "PROMOTIONS@CricketCashbackMarathon"
                    },
                    {
                        id: '20',
                        url: '/promotions/crazytime-epic-bonanza',
                        icon: '',
                        authkey:"showCrazyTimePromo",
                        label: "PROMOTIONS@CrazyTimeEpicBonanza"
                    },
                    {
                        id: '21',
                        url: '/promotions/aviator-high-flyer',
                        icon: '',
                        authkey:"showAviatorHighFlyerPromo",
                        label: "PROMOTIONS@AviatorHighFlyer"
                    }, 
                    {
                        id: '22',
                        url: '/promotions/smartsoft-spin-and-win',
                        icon: '',
                        authkey:"showSmartsoft",
                        label: "PROMOTIONS@Smartsoft"
                    },


                    {
                        id: '23',
                        url: '/promotions/evolution-casino-cup',
                        icon: '',
                        authkey:"showEvolutionCasionCup",
                        label: "PROMOTIONS@EvolutionCasionCup"
                    },




                    {
                        id: '24',
                        url: '/promotions/IPL-Betting-dhamaka-Power-Play-Bonus',
                        icon: '',
                        authkey:"shoeIPLpowerPlay",
                        label: "PROMOTIONS@IPLPOWERPLAY1"
                    },



                    {
                        id: '25',
                        url: '/promotions/indian-galaxsys-league',
                        icon: '',
                        authkey:"showIndianGalaxysLeague",
                        label: "PROMOTIONS@IndianGalaxsysLeague"
                    },
                   
                    



                        {
                        id: '26',
                        url: '/promotions/ipl-betting-dhamaka',
                        icon: '',
                        authkey:"showIplPromo",
                        label: "PROMOTIONS@iplmatka"},



                        {
                            id: '27',
                            url: '/promotions/double-cashback',
                            icon: '',
                            authkey:"showDoubleCashBack",
                            label: "PROMOTIONS@DoubleCashback"
                        },


                        {
                        id: '28',
                        url: '/promotions/aviator-sky-bound-miles',
                        icon: '',
                        authkey:"showAviatorSkyBoundMiles",
                        label: "PROMOTIONS@AviatorSkyBoundMiles"
                    },
                    {
                        id: '29',
                        url: '/promotions/wc-lossback',
                        icon: '',
                        authkey:"showWorldCupLossbackYolo",
                        label: "PROMOTIONS@WorldCupLossbackBonus"
                    },
                    {
                        id: '30',
                        url: '/promotions/wc-doubleCashback',
                        icon: '',
                        authkey:"showWorldCupDoubleCashbackBonus",
                        label: "PROMOTIONS@WorldCupDailyDepositBonus"
                    },
                    {
                        id: '31',
                        url: '/promotions/wc-evolutionCasinoCup',
                        icon: '',
                        authkey:"showWorldCupEvolutionCasinoCup",
                        label: "PROMOTIONS@WorldCupEvolutionCasinoCupBonus"
                    },
                    {
                        id: '34',
                        url: '/promotions/smartsoft-spin-and-win',
                        icon: '',
                        authkey:"showSmartSoftJetxCelestial",
                        label: "PROMOTIONS@SmartSoftJetxCelestial"
                    },
                    {
                        id: '35',
                        url: '/promotions/mines-legend-trophy',
                        icon: '',
                        authkey:"showMinesLegendTrophyPromo",
                        label: "PROMOTIONS@MinesLegendTrophy"
                    },
                    {
                        id: '36',
                        url: '/promotions/caribbean-premier-league',
                        icon: '',
                        authkey:"showCaribbeanLeagueBonusPromo",
                        label: "PROMOTIONS@CaribbeanLeagueBonus"
                    },
                    {
                        id: '37',
                        url: '/promotions/evolution-roulette-cup',
                        icon: '',
                        authkey:"showEvolutionRouletteCupPromo",
                        label: "PROMOTIONS@EvolutionRouletteCup"
                    },
                    {
                        id: '38',
                        url: '/promotions/aviatrix-fly-and-play',
                        icon: '',
                        authkey:"showAviatrixFlyAndPlayPromo",
                        label: "PROMOTIONS@AviatrixFlyAndPlay"
                    },
                    {
                        id: '39',
                        url: '/promotions/aviator-rain',
                        icon: '',
                        authkey:"showAviatorRainPromo",
                        label: "PROMOTIONS@AviatorRainPromo"
                    },

                    {
                        id: '40',
                        url: '/promotions/aviatrix-jet-to-cash',
                        icon: '',
                        authkey:"showAviatrixJetToCrash",
                        label: "PROMOTIONS@AviatrixJetToCrash"
                    },

                    {
                        id: '41',
                        url: '/promotions/big-bash-big-cash',
                        icon: '',
                        authkey:"showBigBashBigCashPromo",
                        label: "PROMOTIONS@BigBashBigCash"
                    },
                    {
                        id: '42',
                        url: '/promotions/the-live-jackpot',
                        icon: '',
                        authkey:"showLiveJackPot2025Promo",
                        label: "PROMOTIONS@LiveJackPot2025"
                    },
                    {
                        id: '43',
                        url: '/promotions/instant-challenge-2025',
                        icon: '',
                        authkey:"showInstantChallengePromo",
                        label: "PROMOTIONS@InstantChallengePromo"
                    },
                    {
                        id: '44',
                        url: '/promotions/super-slots-challenge',
                        icon: '',
                        authkey:"showSuperSlotsChallengePromo",
                        label: "PROMOTIONS@SuperSlotsChallenge"
                    },
                    {
                        id: '45',
                        url: '/promotions/icc-champions-trophy',
                        icon: '',
                        authkey:"showChampionsTrophyPromo",
                        label: "PROMOTIONS@ChampionsTrophy"
                    },
                    {
                        id: '47',
                        url: '/promotions/daily-leaderboard',
                        icon: '',
                        authkey:"showDailyLeaderboard",
                        label: "PROMOTIONS@DailyLeaderBoard"
                    },
                    {
                        id: '48',
                        url: '/promotions/aviatrix-sky-high-challenge',
                        icon: '',
                        authkey:"showAviatrixSkyHighChallengePromo",
                        label: "PROMOTIONS@AviatrixSKYHighChallenge"
                    },
                    {
                        id: '49',
                        url: '/promotions/lightning-cashback',
                        icon: '',
                        authkey:"showLightningCashback2k25",
                        label: "PROMOTIONS@LightningCashback2k25"
                    },
                    {
                        id: '50',
                        url: '/promotions/galaxsys-tournament',
                        icon: '',
                        authkey:"showGalaxsysTournament",
                        label: "PROMOTIONS@GalaxsysTournamentPromo"
                    },
                    {
                        id: '51',
                        url: '/promotions/smartsoft-price-drop',
                        icon: '',
                        authkey:"showSmartSoftPriceDrop",
                        label: "PROMOTIONS@SmartSoftPriceDropTitle"
                    },
                    {
                        id: '52',
                        url: '/promotions/jili-jackpot-league',
                        icon: '',
                        authkey:"ShowJiliSpinWinLeaguePromo",
                        label: "PROMOTIONS@JiliSpinWinLeague"
                    },
                    {
                        id: '53',
                        url: '/promotions/crazy-prize-drop',
                        icon: '',
                        authkey:"ShowCrazyPrizeDropPromo",
                        label: "PROMOTIONS@EvolutionCrazyPrizeDrop"
                    },
                    {
                        id: '54',
                        url: '/promotions/ipl-jackpot',
                        icon: '',
                        authkey:"showIPLJackpotPromo",
                        label: "PROMOTIONS@IPLJackpotPromo2k25"
                    },
                    {
                        id: '55',
                        url: '/promotions/100-lossback-bonus',
                        icon: '',
                        authkey:"show100LossBackPromo25",
                        label: "PROMOTIONS@HundredLossbackPromo"
                    },
                    {
                        id: '56',
                        url: '/promotions/live-casino-league',
                        icon: '',
                        authkey:"showLiveCasinoLeaguePromo",
                        label: "PROMOTIONS@LiveCasinoLeaguePromo"
                    },
                    {
                        id: '57',
                        url: '/promotions/jili-bonus-spin',
                        icon: '',
                        authkey:"showJiliPlayPatrioticPromo",
                        label: "PROMOTIONS@JiliPlayPatrioticPromo"
                    },
                    {
                        id: '58',
                        url: '/promotions/twenty-free-spins',
                        icon: '',
                        authkey:"showFreeSpinsPromo",
                        label: "PROMOTIONS@TwentyFreeSpins"
                    },
                    {
                        id: '59',
                        url: '/promotions/evolution-games-bet-rewards',
                        icon: '',
                        authkey:"ShowAviatorBetToWinBoostPromo",
                        label: "PROMOTIONS@AviatorBetToWinBoost"
                    },
                    {
                        id: '60',
                        url: '/promotions/asiacup-cashback',
                        icon: '',
                        authkey:"showYoloCashbackSixer",
                        label: "PROMOTIONS@YoloCashbackSixer"
                    },
                    {
                        id: '61',
                        url: '/promotions/weekly-leaderboard',
                        icon: '',
                        authkey:"showWeeklyLeaderboard",
                        label: "PROMOTIONS@WeeklyLeaderBoard"
                    },
                    {
                        id: '62',
                        url: '/promotions/super-chicken-rush',
                        icon: '',
                        authkey:"showSuperChickenRushPromo",
                        label: "PROMOTIONS@superChickenRushPromo"
                    },
                    {
                        id: '64',
                        url: '/promotions/surprise-evolution',
                        icon: '',
                        authkey:"showSurpriseDhamakaPromo",
                        label: "PROMOTIONS@SurpriseDhamaka"
                    },
                    {
                        id: '65',
                        url: '/promotions/international-league-t20',
                        icon: '',
                        authkey:"showILT20Promo",
                        label: "PROMOTIONS@ILT20Promo"
                    },
                     {
                        id: '68',
                        url: '/promotions/exchange-safety-net',
                        icon: '',
                        authkey:"showHundredSafetyPromo",
                        label: "PROMOTIONS@ExchangeSafetyPromo"
                    },
                    {
                        id: '69',
                        url: '/promotions/aviator-26-free-bets-bonanza',
                        icon: '',
                        authkey:"ShowAviator26FBBPromo",
                        label: "PROMOTIONS@Aviator26FBBPromo"
                    },
                    {
                        id: '70',
                        url: '/promotions/deposit-with-6-win-26x-bonus',
                        icon: '',
                        authkey:"showDeposit6x26xBonusPromo",
                        label: "PROMOTIONS@Deposit6x26xBonusPromo"
                    },
                    {
                        id: '71',
                        url: '/promotions/monday-happy-hours',
                        icon: '',
                        authkey:"showMondayHappyHourPromo",
                        label: "PROMOTIONS@MondayHappyHourPromo"
                    },
                    {
                        id: '72',
                        url: '/promotions/chicken-road',
                        icon: '',
                        authkey:"showChickenRoadPromo",
                        label: "PROMOTIONS@chickenRoadPromo"
                    },
                    {
                        id: '73',
                        url: '/promotions/evolution-live-rewards',
                        icon: '',
                        authkey:"showEvoLiveRewrds2k26Promo",
                        label: "PROMOTIONS@EvoLiveRewrdsPromo"
                    },
                    {
                        id: '74',
                        url: '/promotions/welcome-free-spins',
                        icon: '',
                        authkey:"showWelcomeFreeSpins",
                        label: "PROMOTIONS@WelcomeFreeSpinsPromo"
                    },
                    {
                        id: '75',
                        url: '/promotions/aviator-free-bets-with-ipl-bets',
                        icon: '',
                        authkey:"showAviatorFreeBetsWthIPLBetsPromo",
                        label: "PROMOTIONS@AviatorFreeBetsWthIPLBetsPromo"
                    },
                    {
                        id: '76',
                        url: '/promotions/leaderboard-2026',
                        icon: '',
                        authkey:"showLeaderboard2k26Promo",
                        label: "PROMOTIONS@LeaderboardPromoTitle"
                    },
                    {
                        id: '77',
                        url: '/promotions/free-spins-jili',
                        icon: '',
                        authkey:"showJiliFreeSpinsPromo",
                        label: "PROMOTIONS@jiliFreeSpinsPromo"
                    },
                    {
                        id: '78',
                        url: '/promotions/weekly-deposits',
                        icon: '',
                        authkey:"showWeeklyDesposit",
                        label: "PROMOTIONS@WeeklyDespositPromo"
                    },
                    {
                        id: '79',
                        url: '/promotions/evolution-powerplay-strike',
                        icon: '',
                        authkey:"showEvolutionpPowerPlayPromo",
                        label: "PROMOTIONS@EvoPowerplayStrikePromo"
                    },
                    {
                        id: '80',
                        url: '/promotions/daily-betback',
                        icon: '',
                        authkey:"showDailyBetBackPromo",
                        label: "PROMOTIONS@DailyBetBackPromo"
                    },
                    {
                        id: '81',
                        url: '/promotions/playtech-new-launch-win-big',
                        icon: '',
                        authkey:"showPlaytechNewLaunch",
                        label: "PROMOTIONS@PlaytechNewLaunchPromo"
                    },
                    {
                        id: '82',
                        url: '/promotions/tower-rush-jackpot',
                        icon: '',
                        authkey:"showTowerRushJackpotPromo",
                        label: "PROMOTIONS@ToweRushJackpot"
                    },
                    {
                        id: '83',
                        url: '/promotions/place-9-bets-win-up-to-99x',
                        icon: '',
                        authkey:"showPlace9BetsWinUpTo99X",
                        label: "PROMOTIONS@Place9BetsWinUpTo99XPromo"
                    },
                    {
                        id: '84',
                        url: '/promotions/up-to-100-free-spins-on-ganesh-gold',
                        icon: '',
                        authkey:"show100FreeSpinOnGaneshGold",
                        label: "PROMOTIONS@100FreeSpinOnGaneshGold"
                    },
                    {
                        id: '82',
                        url: '/promotions',
                        icon: '',
                        authkey:"showOnlyOnFun",
                        label: "HEADER@VIEWALL"
                    }
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@ExploreALL'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm1',
                    url: '/promotions/welcome-bonus',
                    image: 'DROPDOWN_WELCOME_BONUS_NEW.png',
                    label: 'PROMOTIONSTITLE@WELCOME',
                    authkey: "showWelcomeBonus"
                },
                {
                    id: 'rm2',
                    url: '/promotions/refill-bonus',
                    image: 'DROPDOWN_REFILLBONUS_NEW.png',
                    label: 'PROMOTIONSTITLE@REFILL',
                    authkey: "showRefillBonus"
                },
                {
                    id: 'rm3',
                    url: '/promotions/cashback-bonus',
                    image: 'DROPDOWN_CASHBACKBONUS_NEW.png',
                    label: 'PROMOTIONSTITLE@CASHBACK',
                    authkey: "showCashbackBonus"
                }
            ]
        },
    },
    47:{
        casino: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/live-casino/roulette',
                        icon: '',
                        label: 'TITLE@ROULETTESIDEBAR',
                        authkey: 'showRoulette'
                    },
                    {
                        id: '2',
                        url: '/live-casino/blackjack',
                        icon: '',
                        label: 'TITLE@BLACKJACKSIDEBAR',
                        authkey: 'showBlackjack'
                    },
                    {
                        id: '3',
                        url: '/live-casino/baccarat',
                        icon: '',
                        label: 'TITLE@BACCARAT',
                        authkey: 'showBaccarat'
                    },
                    {
                        id: '4',
                        url: '/live-casino/dragon-tiger',
                        icon: '',
                        label: 'TITLE@DRAGON_TIGER',
                        authkey: 'showDragontiger'
                    }
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@ENJOY'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm3',
                    url:'/popular-games',
                    image: 'DROPDOWN_POPULAR.png',
                    label: 'TITLE@populargames'
                },
                {

                    id: 'rm1',
                    url:'/live-casino',
                    image: 'DROPDOWN_CASINO_LIVE_CASINO.png',
                    label: 'TITLE@LIVECASINO',
                    authkey: 'showOnlineCasinoGamesLink'
                },
                {
                    id: 'rm2',
                    url:'/slots',
                    image: 'DROPDOWN_SLOT_BINGO.png',
                    label: 'TITLE@SLOTBINGO'
                }
            
             
                    ]
        },
        instant_games: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/instant-games/smartsoft/plinkox',
                        icon: '',
                        label: "TITLE@Plinko",
                        authkey: "showInstantThumbs"
                    },
                    // {
                    //     id: '2',
                    //     url: '/instant-games/smartsoft/footballx',
                    //     icon: '',
                    //     label: 'TITLE@Footballx',
                    //     authkey: "showInstantThumbs"
                    // },
                    // {
                    //     id: '3',
                    //     url: '/instant-games/smartsoft/balloon',
                    //     icon: '',
                    //     label: 'TITLE@Baloon',
                    //     authkey: "showInstantThumbs"
                    // },
                    {
                        id: '4',
                        url: '/instant-games/inout/chicken-road-2',
                        icon: '',
                        authkey:"showInstantThumbs",
                        label: "TITLE@ChickenRoad2"
                    },
                    {
                        id: '5',
                        url: '/instant-games/galaxsys/ninja-crash',
                        icon: '',
                        authkey:"showInstantThumbs",
                        label: "TITLE@ninjacrush"
                    },
                  
                    {
                        id: '7',
                        url: '/instant-games',
                        icon: '',
                        authkey:"showInstantThumbs",
                        label: "HEADER@VIEWALL"
                    }
                
                
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@ExploreALL'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm1',
                    url: '/instant-games/spribe/aviator',
                    image: 'aviator-instant-cashsite-dropdown.png',
                    label: 'TITLE@AVIATOR',
                    authkey: "showInstantThumbs"
                },
                {
                    id: 'rm2',
                    url: '/instant-games/smartsoft/jetx',
                    image: 'jetx-instant-cashsite-drowpdown.png',
                    label: 'TITLE@JetX',
                    authkey: "showInstantThumbs"
                },
                {
                    id: 'rm3',
                    url: '/instant-games/aviatrix/play-aviatrix',
                    image: 'AviatriXdropdown.png',
                    label: 'GAME@AVIATRIX',
                    authkey: "showInstantThumbs"
                }
                
            ]
        },
        hotgames: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/live-casino/evolution/monopoly-live',
                        icon: '',
                        label: 'TITLE@MonopolyLive',
                        authkey: 'showTeenpatti'
                    },
                    {
                        id: '2',
                        url: '/live-casino/evolution/funky-time',
                        icon: '',
                        label: 'TITLE@FunkyTimes',
                        authkey: 'showTeenpatti2020'
                    },
                    {
                        id: '3',
                        url: '/live-casino/evolution/lightning-dice',
                        icon: '',
                        label: 'TITLE@LightningDice',
                        authkey: 'showTeenpatti2020'
                    },
                    {
                        id: '4',
                        url: '/live-casino/dragon-tiger',
                        icon: '',
                        label: 'TITLE@DragonTiger',
                        authkey: 'showTeenpatti2020'
                    },
                    {
                        id: '5',
                        url: '/instant-games/smartsoft/cricketx',
                        icon: '',
                        label: 'TITLE@CricketX',
                        authkey: 'showTeenpatti2020'
                    },
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@PLAYANDNEVER'
                    },
                ]
            },
            rightMenu: [

                {
                    id: 'rm1',
                    url:'/instant-games/spribe/mines',
                    image: 'spribe-minesdropdown.png',
                    label: 'TITLE@Mines',
                    authkey: 'showTeenpattiLink'
                },
                {
                    id: 'rm2',
                    url:'/live-casino/evolution/crazy-time',
                    image: 'DROPDOWN_CRAZY_TIME.png',
                    label: "TITLE@crazytime",
                    authkey: 'showTeenpattiLink'
                },
                {
                    id: 'rm3',
                    url:'/live-casino/evolution/lightning-roulette',
                    image: 'DROPDOWN_LIGHTNING_ROULETTE.png',
                    label: 'TITLE@LIGHTINGROULETTE',
                    authkey: 'showTeenpattiLink'
                }
               
            ]
        },
        sports: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/betting-exchange/cricket',
                        icon: '',
                        label: 'SPORT@CRICKET',
                        authkey: 'showSportCricket'
                    },
                    {
                        id: '2',
                        url: '/betting-exchange/football',
                        icon: '',
                        label: 'SPORT@FOOTBALL',
                        authkey: 'showSportFootball'
                    },
                    {
                        id: '3',
                        url: '/betting-exchange/tennis',
                        icon: '',
                        label: 'SPORT@TENNIS',
                        authkey: 'showSportTennis'
                    },
                    // {
                    //     id: '4',
                    //     url: '/betting-exchange/volleyball',
                    //     icon: '',
                    //     label: 'SPORT@VolleyBall',
                    //     authkey: 'showSportVolleyball'
                    // },
                    // {
                    //     id: '5',
                    //     url: '/virtualSports/vci',
                    //     icon: '',
                    //     label: 'TITLE@VIRTUALSPORTS',
                    //     authkey: 'showVirtualSportsvfec'
                    // },
                    {
                        id: '6',
                        url: '/sports/tournaments/',
                        icon: '',
                        label: 'TITLE@Tournaments',
                        authkey: 'showTournaments'
                    }
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@GOONTURN'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm1',
                    url:'/betting-exchange',
                    image: 'DROPDOWN_EXCHANGE_Fun88.png',
                    label: 'TITLE@EXCHANGE',
                    authkey: 'showExchangeLink',
                    itemsCount: '5'
                },
                // {
                //     id: 'rm5',
                //     url:'/premium-sportsbook/kabaddi-betting',
                //     image: 'kabbadiFun.png',
                //     label: 'MENU@Kabbadi',
                //     authkey: 'showProKabbadi',
                //     itemsCount: '5'
                // },
                {
                    id: 'rm2',
                    url:'/premium-sportsbook',
                    image: 'premiumSportsbookDropdownFun88.png',
                    label: 'TITLE@PREMIUM_SPORTSBOOK',
                    authkey: 'showPremiumSportsLink',
                    itemsCount: '5'
                },
                {
                    id: 'rm3',
                    url:'/sportsbook',
                    image: 'DROPDOWN_SPORTSBOOK_NEW.png',
                    label: 'MENU@SPORTBOOK',
                    authkey: 'showSportBookLink',
                    itemsCount: '5'
                },
                {
                    id: 'rm4',
                    url:'/saba-sports',
                    image: 'FunSabaDesk.png',
                    label: 'TITLE@SabaSports',
                    authkey: 'showSabaSportsStatement',
                    itemsCount: '5'
                },
                // {
                //     id: 'rm4',
                //     url:'/virtualSports/vci',
                //     image: 'virtualSportsDesktopDropdown.png',
                //     label: 'GAME@VIRTUALSPORTS',
                //     authkey: 'showVirtualSportsvfel'
                // },
            ]
        },
        promotions: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/promotions/welcome-bonus',
                        icon: '',
                        label: "PROMOTIONSTITLE@WELCOME"
                    },
                    {
                        id: '2',
                        url: '/promotions/refill-bonus',
                        icon: '',
                        label: 'PROMOTIONSTITLE@REFILL',
                        authkey: "showRefillBonus"
                    },
                    {
                        id: '3',
                        url: '/promotions/cashback-bonus',
                        icon: '',
                        label: 'PROMOTIONSTITLE@CASHBACK',
                        authkey: "showCashbackBonus"
                    },
                    {
                        id: '4',
                        url: '/promotions/referral-bonus',
                        icon: '',
                        authkey:"showReferralBonus",
                        label: "ProBonus@Referral"
                    },   
                    {
                        id: '5',
                        url: '/promotions/big-bash',
                        icon: '',
                        authkey:"showBBLBonus",
                        label: "PROMOTIONS@BBLBonus"
                    },
                    {
                        id: '6',
                        url: '/promotions/arjith_promo',
                        icon: '',
                        authkey:"showSingWithYolo",
                        label: "PROMOTIONS@singYolo"
                    },
                    {
                        id: '7',
                        url: '/promotions/jetx-tournament',
                        icon: '',
                        authkey:"jetxpromo",                                 
                        label:"jetx"
                    },
                    {
                        id: '8',
                        url: '/promotions/crazyCrash',
                        icon: '',
                        authkey:"showCrazyCrashPromo",
                        label:"PROMOTIONS@crazyCrashPromo"
                    },
                    {   id: '9',
                        url: '/promotions/aviator-bonus',
                        icon: '',
                        authkey:"showAviatorBonus",
                        label:"PROMOTIONS@AviatorBonus"
                    },   
                    {
                        id: '10',
                        url: '/promotions/evolution-first-bet',
                        icon: '',
                        authkey:"showEvolutionpromo",
                        label: "PROMOTIONS@firstperson"
                    },
                    {
                        id: '11',
                        url: '/promotions/funkytime',
                        icon: '',
                        authkey:"showFunkytimePromo",
                        label: "PROMOTIONS@funkytime"
                    },
                    {
                        id: '15',
                        url: '/promotions/evo-baccarat',
                        icon: '',
                        authkey:"showEvoCasinoCupPromo",
                        label: "PROMOTIONS@EvoCasinoCupPromo"
                    },
                    {
                        id: '12',
                        url: '/promotions/worldcup-cashback-bonanza',
                        icon: '',
                        authkey:"showWCBonusPromo",
                        label: "PROMOTIONS@WCCBONAZA"
                    },
                    {
                        id: '13',
                        url: '/promotions/platinum-rush',
                        icon: '',
                        authkey:"showPlatinumRush",
                        label: "PROMOTIONS@Platinumrush"
                    },
                    {
                        id: '14',
                        url: '/promotions/worldcup-betboost',
                        icon: '',
                        authkey:"showWCBonusPromo",
                        label: "TITLE@wcbetboost"
                    },
                    {
                        id: '15',
                        url: '/promotions/catch99-s2',
                        icon: '',
                        authkey:"showCatch99Bonus",
                        label: "PROMOTIONS@CATCH99"
                    },
                    // {
                    //     id: '16',
                    //     url: '/promotions/evolution-crazy-pachinko',
                    //     icon: '',
                    //     authkey:"showCrazyPachinkoPromo",
                    //     label: "TITLE@EvoCrazyPachinko"
                    // },
                    {
                        id: '17',
                        url: '/promotions/jetx-celestial-rush',
                        icon: '',
                        authkey:"showJetXCelestialRush",
                        label: "PROMOTIONS@JetxCelestial"
                    },
                    {
                        id: '18',
                        url: '/promotions/aviatrix-double-dhamaka',
                        icon: '',
                        authkey:"showAviatrixPromo",
                        label: "PROMOTIONS@AviatrixDoubleDhamaka"
                    },
                    {
                        id: '19',
                        url: '/promotions/cricket-cashback-marathon',
                        icon: '',
                        authkey:"showcircketCashbackMarathon",
                        label: "PROMOTIONS@CricketCashbackMarathon"
                    },
                    {
                        id: '20',
                        url: '/promotions/crazytime-epic-bonanza',
                        icon: '',
                        authkey:"showCrazyTimePromo",
                        label: "PROMOTIONS@CrazyTimeEpicBonanza"
                    },
                    {
                        id: '21',
                        url: '/promotions/aviator-high-flyer',
                        icon: '',
                        authkey:"showAviatorHighFlyerPromo",
                        label: "PROMOTIONS@AviatorHighFlyer"
                    }, 
                    {
                        id: '22',
                        url: '/promotions/smartsoft-spin-and-win',
                        icon: '',
                        authkey:"showSmartsoft",
                        label: "PROMOTIONS@Smartsoft"
                    },


                    {
                        id: '23',
                        url: '/promotions/evolution-casino-cup',
                        icon: '',
                        authkey:"showEvolutionCasionCup",
                        label: "PROMOTIONS@EvolutionCasionCup"
                    },




                    {
                        id: '24',
                        url: '/promotions/IPL-Betting-dhamaka-Power-Play-Bonus',
                        icon: '',
                        authkey:"shoeIPLpowerPlay",
                        label: "PROMOTIONS@IPLPOWERPLAY1"
                    },



                    {
                        id: '25',
                        url: '/promotions/indian-galaxsys-league',
                        icon: '',
                        authkey:"showIndianGalaxysLeague",
                        label: "PROMOTIONS@IndianGalaxsysLeague"
                    },
                   
                    



                        {
                        id: '26',
                        url: '/promotions/ipl-betting-dhamaka',
                        icon: '',
                        authkey:"showIplPromo",
                        label: "PROMOTIONS@iplmatka"},



                        {
                            id: '27',
                            url: '/promotions/double-cashback',
                            icon: '',
                            authkey:"showDoubleCashBack",
                            label: "PROMOTIONS@DoubleCashback"
                        },


                        {
                        id: '28',
                        url: '/promotions/aviator-sky-bound-miles',
                        icon: '',
                        authkey:"showAviatorSkyBoundMiles",
                        label: "PROMOTIONS@AviatorSkyBoundMiles"
                    },
                    {
                        id: '29',
                        url: '/promotions/wc-lossback',
                        icon: '',
                        authkey:"showWorldCupLossbackYolo",
                        label: "PROMOTIONS@WorldCupLossbackBonus"
                    },
                    {
                        id: '30',
                        url: '/promotions/wc-doubleCashback',
                        icon: '',
                        authkey:"showWorldCupDoubleCashbackBonus",
                        label: "PROMOTIONS@WorldCupDailyDepositBonus"
                    },
                    {
                        id: '31',
                        url: '/promotions/wc-evolutionCasinoCup',
                        icon: '',
                        authkey:"showWorldCupEvolutionCasinoCup",
                        label: "PROMOTIONS@WorldCupEvolutionCasinoCupBonus"
                    },
                    {
                        id: '34',
                        url: '/promotions/smartsoft-spin-and-win',
                        icon: '',
                        authkey:"showSmartSoftJetxCelestial",
                        label: "PROMOTIONS@SmartSoftJetxCelestial"
                    },
                    {
                        id: '35',
                        url: '/promotions/mines-legend-trophy',
                        icon: '',
                        authkey:"showMinesLegendTrophyPromo",
                        label: "PROMOTIONS@MinesLegendTrophy"
                    },
                    {
                        id: '36',
                        url: '/promotions/caribbean-premier-league',
                        icon: '',
                        authkey:"showCaribbeanLeagueBonusPromo",
                        label: "PROMOTIONS@CaribbeanLeagueBonus"
                    },
                    {
                        id: '37',
                        url: '/promotions/evolution-roulette-cup',
                        icon: '',
                        authkey:"showEvolutionRouletteCupPromo",
                        label: "PROMOTIONS@EvolutionRouletteCup"
                    },
                    {
                        id: '38',
                        url: '/promotions/aviatrix-fly-and-play',
                        icon: '',
                        authkey:"showAviatrixFlyAndPlayPromo",
                        label: "PROMOTIONS@AviatrixFlyAndPlay"
                    },
                    {
                        id: '40',
                        url: '/promotions/aviator-rain',
                        icon: '',
                        authkey:"showAviatorRainPromo",
                        label: "PROMOTIONS@AviatorRainPromo"
                    },
                    {
                        id: '41',
                        url: '/promotions/aviatrix-jet-to-cash',
                        icon: '',
                        authkey:"showAviatrixJetToCrash",
                        label: "PROMOTIONS@AviatrixJetToCrash"
                    },
                
                    {
                        id: '42',
                        url: '/promotions/big-bash-big-cash',
                        icon: '',
                        authkey:"showBigBashBigCashPromo",
                        label: "PROMOTIONS@BigBashBigCash"
                    },
                    {
                        id: '43',
                        url: '/promotions/instant-challenge-2025',
                        icon: '',
                        authkey:"showInstantChallengePromo",
                        label: "PROMOTIONS@InstantChallengePromo"
                    },
                    {
                        id: '44',
                        url: '/promotions/super-slots-challenge',
                        icon: '',
                        authkey:"showSuperSlotsChallengePromo",
                        label: "PROMOTIONS@SuperSlotsChallenge"
                    },
                    {
                        id: '45',
                        url: '/promotions/the-live-jackpot',
                        icon: '',
                        authkey:"showLiveJackPot2025Promo",
                        label: "PROMOTIONS@LiveJackPot2025"
                    },
                    {
                        id: '46',
                        url: '/promotions/icc-champions-trophy',
                        icon: '',
                        authkey:"showChampionsTrophyPromo",
                        label: "PROMOTIONS@ChampionsTrophy"
                    },
                    {
                        id: '48',
                        url: '/promotions/daily-leaderboard',
                        icon: '',
                        authkey:"showDailyLeaderboard",
                        label: "PROMOTIONS@DailyLeaderBoard"
                    },
                    {
                        id: '49',
                        url: '/promotions/aviatrix-sky-high-challenge',
                        icon: '',
                        authkey:"showAviatrixSkyHighChallengePromo",
                        label: "PROMOTIONS@AviatrixSKYHighChallenge"
                    },
                    {
                        id: '50',
                        url: '/promotions/lightning-cashback',
                        icon: '',
                        authkey:"showLightningCashback2k25",
                        label: "PROMOTIONS@LightningCashback2k25"
                    },
                    {
                        id: '51',
                        url: '/promotions/galaxsys-tournament',
                        icon: '',
                        authkey:"showGalaxsysTournament",
                        label: "PROMOTIONS@GalaxsysTournamentPromo"
                    },
                    {
                        id: '52',
                        url: '/promotions/smartsoft-price-drop',
                        icon: '',
                        authkey:"showSmartSoftPriceDrop",
                        label: "PROMOTIONS@SmartSoftPriceDropTitle"
                    },
                    {
                        id: '53',
                        url: '/promotions/jili-jackpot-league',
                        icon: '',
                        authkey:"ShowJiliSpinWinLeaguePromo",
                        label: "PROMOTIONS@JiliSpinWinLeague"
                    },
                    {
                        id: '54',
                        url: '/promotions/crazy-prize-drop',
                        icon: '',
                        authkey:"ShowCrazyPrizeDropPromo",
                        label: "PROMOTIONS@EvolutionCrazyPrizeDrop"
                    },
                    {
                        id: '55',
                        url: '/promotions/ipl-jackpot',
                        icon: '',
                        authkey:"showIPLJackpotPromo",
                        label: "PROMOTIONS@IPLJackpotPromo2k25"
                    },
                    {
                        id: '56',
                        url: '/promotions/100-lossback-bonus',
                        icon: '',
                        authkey:"show100LossBackPromo25",
                        label: "PROMOTIONS@HundredLossbackPromo"
                    },
                    {
                        id: '57',
                        url: '/promotions/live-casino-league',
                        icon: '',
                        authkey:"showLiveCasinoLeaguePromo",
                        label: "PROMOTIONS@LiveCasinoLeaguePromo"
                    },
                    {
                        id: '58',
                        url: '/promotions/jili-bonus-spin',
                        icon: '',
                        authkey:"showJiliPlayPatrioticPromo",
                        label: "PROMOTIONS@JiliPlayPatrioticPromo"
                    },
                    {
                        id: '59',
                        url: '/promotions/twenty-free-spins',
                        icon: '',
                        authkey:"showFreeSpinsPromo",
                        label: "PROMOTIONS@TwentyFreeSpins"
                    },
                    {
                        id: '60',
                        url: '/promotions/evolution-games-bet-rewards',
                        icon: '',
                        authkey:"ShowAviatorBetToWinBoostPromo",
                        label: "PROMOTIONS@AviatorBetToWinBoost"
                    },
                    {
                        id:'61',
                        url: '/promotions/asiacup-cashback',
                        icon: '',
                        authkey:"showYoloCashbackSixer",
                        label: "PROMOTIONS@YoloCashbackSixer"
                    },
                    {
                        id: '62',
                        url: '/promotions/weekly-leaderboard',
                        icon: '',
                        authkey:"showWeeklyLeaderboard",
                        label: "PROMOTIONS@WeeklyLeaderBoard"
                    },
                    {
                        id: '63',
                        url: '/promotions/super-chicken-rush',
                        icon: '',
                        authkey:"showSuperChickenRushPromo",
                        label: "PROMOTIONS@superChickenRushPromo"
                    },
                    {
                        id: '65',
                        url: '/promotions/surprise-evolution',
                        icon: '',
                        authkey:"showSurpriseDhamakaPromo",
                        label: "PROMOTIONS@SurpriseDhamaka"
                    },
                    {
                        id: '66',
                        url: '/promotions/international-league-t20',
                        icon: '',
                        authkey:"showILT20Promo",
                        label: "PROMOTIONS@ILT20Promo"
                    },
                    {
                        id: '68',
                        url: '/promotions/exchange-safety-net',
                        icon: '',
                        authkey:"showHundredSafetyPromo",
                        label: "PROMOTIONS@ExchangeSafetyPromo"
                    },
                    {
                        id: '69',
                        url: '/promotions/aviator-26-free-bets-bonanza',
                        icon: '',
                        authkey:"ShowAviator26FBBPromo",
                        label: "PROMOTIONS@Aviator26FBBPromo"
                    },
                    {
                        id: '71',
                        url: '/promotions/deposit-with-6-win-26x-bonus',
                        icon: '',
                        authkey:"showDeposit6x26xBonusPromo",
                        label: "PROMOTIONS@Deposit6x26xBonusPromo"
                    },
                    {
                        id: '72',
                        url: '/promotions/monday-happy-hours',
                        icon: '',
                        authkey:"showMondayHappyHourPromo",
                        label: "PROMOTIONS@MondayHappyHourPromo"
                    },
                    {
                        id: '73',
                        url: '/promotions/chicken-road',
                        icon: '',
                        authkey:"showChickenRoadPromo",
                        label: "PROMOTIONS@chickenRoadPromo"
                    },
                    {
                        id: '74',
                        url: '/promotions/evolution-live-rewards',
                        icon: '',
                        authkey:"showEvoLiveRewrds2k26Promo",
                        label: "PROMOTIONS@EvoLiveRewrdsPromo"
                    },
                    {
                        id: '75',
                        url: '/promotions/welcome-free-spins',
                        icon: '',
                        authkey:"showWelcomeFreeSpins",
                        label: "PROMOTIONS@WelcomeFreeSpinsPromo"
                    },
                    {
                        id: '76',
                        url: '/promotions/aviator-free-bets-with-ipl-bets',
                        icon: '',
                        authkey:"showAviatorFreeBetsWthIPLBetsPromo",
                        label: "PROMOTIONS@AviatorFreeBetsWthIPLBetsPromo"
                    },
                    {
                        id: '77',
                        url: '/promotions/leaderboard-2026',
                        icon: '',
                        authkey:"showLeaderboard2k26Promo",
                        label: "PROMOTIONS@LeaderboardPromoTitle"
                    },
                    {
                        id: '78',
                        url: '/promotions/free-spins-jili',
                        icon: '',
                        authkey:"showJiliFreeSpinsPromo",
                        label: "PROMOTIONS@jiliFreeSpinsPromo"
                    },
                    {
                        id: '79',
                        url: '/promotions/weekly-deposits',
                        icon: '',
                        authkey:"showWeeklyDesposit",
                        label: "PROMOTIONS@WeeklyDespositPromo"
                    },
                    {
                        id: '80',
                        url: '/promotions/evolution-powerplay-strike',
                        icon: '',
                        authkey:"showEvolutionpPowerPlayPromo",
                        label: "PROMOTIONS@EvoPowerplayStrikePromo"
                    },
                    {
                        id: '81',
                        url: '/promotions/daily-betback',
                        icon: '',
                        authkey:"showDailyBetBackPromo",
                        label: "PROMOTIONS@DailyBetBackPromo"
                    },
                    {
                        id: '82',
                        url: '/promotions/playtech-new-launch-win-big',
                        icon: '',
                        authkey:"showPlaytechNewLaunch",
                        label: "PROMOTIONS@PlaytechNewLaunchPromo"
                    },
                    {
                        id: '83',
                        url: '/promotions/tower-rush-jackpot',
                        icon: '',
                        authkey:"showTowerRushJackpotPromo",
                        label: "PROMOTIONS@ToweRushJackpot"
                    },
                    {
                        id: '84',
                        url: '/promotions/place-9-bets-win-up-to-99x',
                        icon: '',
                        authkey:"showPlace9BetsWinUpTo99X",
                        label: "PROMOTIONS@Place9BetsWinUpTo99XPromo"
                    },
                    {
                        id: '85',
                        url: '/promotions/up-to-100-free-spins-on-ganesh-gold',
                        icon: '',
                        authkey:"show100FreeSpinOnGaneshGold",
                        label: "PROMOTIONS@100FreeSpinOnGaneshGold"
                    },
                    {
                        id: '83',
                        url: '/promotions',
                        icon: '',
                        authkey:"showOnlyOnFun",
                        label: "HEADER@VIEWALL"
                    }
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@ExploreALL'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm1',
                    url: '/promotions/welcome-bonus',
                    image: 'DROPDOWN_WELCOME_BONUS_NEW.png',
                    label: 'PROMOTIONSTITLE@WELCOME',
                    authkey: "showWelcomeBonus"
                },
                {
                    id: 'rm2',
                    url: '/promotions/refill-bonus',
                    image: 'DROPDOWN_REFILLBONUS_NEW.png',
                    label: 'PROMOTIONSTITLE@REFILL',
                    authkey: "showRefillBonus"
                },
                {
                    id: 'rm3',
                    url: '/promotions/cashback-bonus',
                    image: 'DROPDOWN_CASHBACKBONUS_NEW.png',
                    label: 'PROMOTIONSTITLE@CASHBACK',
                    authkey: "showCashbackBonus"
                }
            ]
        },
    },
    61:{
        casino: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/live-casino/roulette',
                        icon: '',
                        label: 'TITLE@ROULETTESIDEBAR',
                        authkey: 'showRoulette'
                    },
                    {
                        id: '2',
                        url: '/live-casino/blackjack',
                        icon: '',
                        label: 'TITLE@BLACKJACKSIDEBAR',
                        authkey: 'showBlackjack'
                    },
                    {
                        id: '3',
                        url: '/live-casino/baccarat',
                        icon: '',
                        label: 'TITLE@BACCARAT',
                        authkey: 'showBaccarat'
                    },
                    {
                        id: '4',
                        url: '/live-casino/dragon-tiger',
                        icon: '',
                        label: 'TITLE@DRAGON_TIGER',
                        authkey: 'showDragontiger'
                    }
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@ENJOY'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm3',
                    url:'/popular-games',
                    image: 'DROPDOWN_POPULAR.png',
                    label: 'TITLE@populargames'
                },
                {

                    id: 'rm1',
                    url:'/live-casino',
                    image: 'DROPDOWN_CASINO_LIVE_CASINO.png',
                    label: 'TITLE@LIVECASINO',
                    authkey: 'showOnlineCasinoGamesLink'
                },
                {
                    id: 'rm2',
                    url:'/slots',
                    image: 'DROPDOWN_SLOT_BINGO.png',
                    label: 'TITLE@SLOTBINGO'
                }
            
             
                    ]
        },
        instant_games: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/instant-games/smartsoft/plinkox',
                        icon: '',
                        label: "TITLE@Plinko",
                        authkey: "showInstantThumbs"
                    },
                    // {
                    //     id: '2',
                    //     url: '/instant-games/smartsoft/footballx',
                    //     icon: '',
                    //     label: 'TITLE@Footballx',
                    //     authkey: "showInstantThumbs"
                    // },
                    // {
                    //     id: '3',
                    //     url: '/instant-games/smartsoft/balloon',
                    //     icon: '',
                    //     label: 'TITLE@Baloon',
                    //     authkey: "showInstantThumbs"
                    // },
                    {
                        id: '4',
                        url: '/instant-games/inout/chicken-road-2',
                        icon: '',
                        authkey:"showInstantThumbs",
                        label: "TITLE@ChickenRoad2"
                    },
                    {
                        id: '5',
                        url: '/instant-games/galaxsys/ninja-crash',
                        icon: '',
                        authkey:"showInstantThumbs",
                        label: "TITLE@ninjacrush"
                    },
                  
                    {
                        id: '7',
                        url: '/instant-games',
                        icon: '',
                        authkey:"showInstantThumbs",
                        label: "HEADER@VIEWALL"
                    }
                
                
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@ExploreALL'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm1',
                    url: '/instant-games/spribe/aviator',
                    image: 'aviator-instant-cashsite-dropdown.png',
                    label: 'TITLE@AVIATOR',
                    authkey: "showInstantThumbs"
                },
                {
                    id: 'rm2',
                    url: '/instant-games/smartsoft/jetx',
                    image: 'jetx-instant-cashsite-drowpdown.png',
                    label: 'TITLE@JetX',
                    authkey: "showInstantThumbs"
                },
                {
                    id: 'rm3',
                    url: '/instant-games/aviatrix/play-aviatrix',
                    image: 'AviatriXdropdown.png',
                    label: 'GAME@AVIATRIX',
                    authkey: "showInstantThumbs"
                }
                
            ]
        },
        hotgames: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/live-casino/evolution/monopoly-live',
                        icon: '',
                        label: 'TITLE@MonopolyLive',
                        authkey: 'showTeenpatti'
                    },
                    {
                        id: '2',
                        url: '/live-casino/evolution/funky-time',
                        icon: '',
                        label: 'TITLE@FunkyTimes',
                        authkey: 'showTeenpatti2020'
                    },
                    {
                        id: '3',
                        url: '/live-casino/evolution/lightning-dice',
                        icon: '',
                        label: 'TITLE@LightningDice',
                        authkey: 'showTeenpatti2020'
                    },
                    {
                        id: '4',
                        url: '/live-casino/dragon-tiger',
                        icon: '',
                        label: 'TITLE@DragonTiger',
                        authkey: 'showTeenpatti2020'
                    },
                    {
                        id: '5',
                        url: '/instant-games/smartsoft/cricketx',
                        icon: '',
                        label: 'TITLE@CricketX',
                        authkey: 'showTeenpatti2020'
                    },
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@PLAYANDNEVER'
                    },
                ]
            },
            rightMenu: [

                {
                    id: 'rm1',
                    url:'/instant-games/spribe/mines',
                    image: 'spribe-minesdropdown.png',
                    label: 'TITLE@Mines',
                    authkey: 'showTeenpattiLink'
                },
                {
                    id: 'rm2',
                    url:'/live-casino/evolution/crazy-time',
                    image: 'DROPDOWN_CRAZY_TIME.png',
                    label: "TITLE@crazytime",
                    authkey: 'showTeenpattiLink'
                },
                {
                    id: 'rm3',
                    url:'/live-casino/evolution/lightning-roulette',
                    image: 'DROPDOWN_LIGHTNING_ROULETTE.png',
                    label: 'TITLE@LIGHTINGROULETTE',
                    authkey: 'showTeenpattiLink'
                }
               
            ]
        },
        sports: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/betting-exchange/cricket',
                        icon: '',
                        label: 'SPORT@CRICKET',
                        authkey: 'showSportCricket'
                    },
                    {
                        id: '2',
                        url: '/betting-exchange/football',
                        icon: '',
                        label: 'SPORT@FOOTBALL',
                        authkey: 'showSportFootball'
                    },
                    {
                        id: '3',
                        url: '/betting-exchange/tennis',
                        icon: '',
                        label: 'SPORT@TENNIS',
                        authkey: 'showSportTennis'
                    },
                    // {
                    //     id: '4',
                    //     url: '/betting-exchange/volleyball',
                    //     icon: '',
                    //     label: 'SPORT@VolleyBall',
                    //     authkey: 'showSportVolleyball'
                    // },
                    // {
                    //     id: '5',
                    //     url: '/virtualSports/vci',
                    //     icon: '',
                    //     label: 'TITLE@VIRTUALSPORTS',
                    //     authkey: 'showVirtualSportsvfec'
                    // },
                    // {
                    //     id: '6',
                    //     url: '/sports/tournaments/',
                    //     icon: '',
                    //     label: 'TITLE@Tournaments',
                    //     authkey: 'showTournaments'
                    // },
                    // {
                    //     id: '7',
                    //     url: '/saba-sports',
                    //     icon: '',
                    //     label: 'TITLE@SabaSports',
                    //     authkey: 'showSabaSportsStatement'
                    // }
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@GOONTURN'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm1',
                    url:'/betting-exchange',
                    image: 'DROPDOWN_EXCHANGE_NEW.png',
                    label: 'TITLE@EXCHANGE',
                    authkey: 'showExchangeLink',
                    itemsCount: '5'
                },
                // {
                //     id: 'rm5',
                //     url:'/premium-sportsbook/kabaddi-betting',
                //     image: 'kabbadiYolo.png',
                //     label: 'MENU@Kabbadi',
                //     authkey: 'showProKabbadi',
                //     itemsCount: '5'
                // },
                {
                    id: 'rm2',
                    url:'/premium-sportsbook',
                    image: 'premiumSportsbookDropdownYolo1.png',
                    label: 'TITLE@PREMIUM_SPORTSBOOK',
                    authkey: 'showPremiumSportsLink',
                    itemsCount: '5'
                },
                {
                    id: 'rm3',
                    url:'/sportsbook',
                    image: 'DROPDOWN_SPORTSBOOK_NEW.png',
                    label: 'MENU@SPORTBOOK',
                    authkey: 'showSportBookLink',
                    itemsCount: '5'
                },
                {
                    id: 'rm4',
                    url:'/saba-sports',
                    image: 'YoloSabaDesk.png',
                    label: 'TITLE@SabaSports',
                    authkey: 'showSabaSportsStatement',
                    itemsCount: '5'
                },
                // {
                //     id: 'rm4',
                //     url:'/virtualSports/vci',
                //     image: 'virtualSportsDesktopDropdown.png',
                //     label: 'GAME@VIRTUALSPORTS',
                //     authkey: 'showVirtualSportsvfel'
                // },
            ]
        },
        promotions: {
            leftMenu: {
                links: [
                    {
                        id: '1',
                        url: '/promotions/welcome-bonus',
                        icon: '',
                        label: "PROMOTIONSTITLE@WELCOME"
                    },
                    {
                        id: '2',
                        url: '/promotions/refill-bonus',
                        icon: '',
                        label: 'PROMOTIONSTITLE@REFILL',
                        authkey: "showRefillBonus"
                    },
                    {
                        id: '3',
                        url: '/promotions/cashback-bonus',
                        icon: '',
                        label: 'PROMOTIONSTITLE@CASHBACK',
                        authkey: "showCashbackBonus"
                    },
                    {
                        id: '4',
                        url: '/promotions/referral-bonus',
                        icon: '',
                        authkey:"showReferralBonus",
                        label: "ProBonus@Referral"
                    },   
                    {
                        id: '5',
                        url: '/promotions/big-bash',
                        icon: '',
                        authkey:"showBBLBonus",
                        label: "PROMOTIONS@BBLBonus"
                    },
                    {
                        id: '6',
                        url: '/promotions/arjith_promo',
                        icon: '',
                        authkey:"showSingWithYolo",
                        label: "PROMOTIONS@singYolo"
                    },
                    {
                        id: '7',
                        url: '/promotions/jetx-tournament',
                        icon: '',
                        authkey:"jetxpromo",                                 
                        label:"jetx"
                    },
                    {
                        id: '8',
                        url: '/promotions/crazyCrash',
                        icon: '',
                        authkey:"showCrazyCrashPromo",
                        label:"PROMOTIONS@crazyCrashPromo"
                    },
                    {   id: '9',
                        url: '/promotions/aviator-bonus',
                        icon: '',
                        authkey:"showAviatorBonus",
                        label:"PROMOTIONS@AviatorBonus"
                    },   
                    {
                        id: '10',
                        url: '/promotions/evolution-first-bet',
                        icon: '',
                        authkey:"showEvolutionpromo",
                        label: "PROMOTIONS@firstperson"
                    },
                    {
                        id: '11',
                        url: '/promotions/funkytime',
                        icon: '',
                        authkey:"showFunkytimePromo",
                        label: "PROMOTIONS@funkytime"
                    },
                    {
                        id: '15',
                        url: '/promotions/evo-baccarat',
                        icon: '',
                        authkey:"showEvoCasinoCupPromo",
                        label: "PROMOTIONS@EvoCasinoCupPromo"
                    },
                    {
                        id: '12',
                        url: '/promotions/worldcup-cashback-bonanza',
                        icon: '',
                        authkey:"showWCBonusPromo",
                        label: "PROMOTIONS@WCCBONAZA"
                    },
                    {
                        id: '13',
                        url: '/promotions/platinum-rush',
                        icon: '',
                        authkey:"showPlatinumRush",
                        label: "PROMOTIONS@Platinumrush"
                    },
                    {
                        id: '14',
                        url: '/promotions/worldcup-betboost',
                        icon: '',
                        authkey:"showWCBonusPromo",
                        label: "TITLE@wcbetboost"
                    },
                    {
                        id: '15',
                        url: '/promotions/catch99-s2',
                        icon: '',
                        authkey:"showCatch99Bonus",
                        label: "PROMOTIONS@CATCH99"
                    },
                    // {
                    //     id: '16',
                    //     url: '/promotions/evolution-crazy-pachinko',
                    //     icon: '',
                    //     authkey:"showCrazyPachinkoPromo",
                    //     label: "TITLE@EvoCrazyPachinko"
                    // },
                    {
                        id: '17',
                        url: '/promotions/jetx-celestial-rush',
                        icon: '',
                        authkey:"showJetXCelestialRush",
                        label: "PROMOTIONS@JetxCelestial"
                    },
                    {
                        id: '18',
                        url: '/promotions/aviatrix-double-dhamaka',
                        icon: '',
                        authkey:"showAviatrixPromo",
                        label: "PROMOTIONS@AviatrixDoubleDhamaka"
                    },
                    {
                        id: '19',
                        url: '/promotions/cricket-cashback-marathon',
                        icon: '',
                        authkey:"showcircketCashbackMarathon",
                        label: "PROMOTIONS@CricketCashbackMarathon"
                    },
                    {
                        id: '20',
                        url: '/promotions/crazytime-epic-bonanza',
                        icon: '',
                        authkey:"showCrazyTimePromo",
                        label: "PROMOTIONS@CrazyTimeEpicBonanza"
                    },
                    {
                        id: '21',
                        url: '/promotions/aviator-high-flyer',
                        icon: '',
                        authkey:"showAviatorHighFlyerPromo",
                        label: "PROMOTIONS@AviatorHighFlyer"
                    }, 
                    {
                        id: '22',
                        url: '/promotions/smartsoft-spin-and-win',
                        icon: '',
                        authkey:"showSmartsoft",
                        label: "PROMOTIONS@Smartsoft"
                    },


                    {
                        id: '23',
                        url: '/promotions/evolution-casino-cup',
                        icon: '',
                        authkey:"showEvolutionCasionCup",
                        label: "PROMOTIONS@EvolutionCasionCup"
                    },




                    {
                        id: '24',
                        url: '/promotions/IPL-Betting-dhamaka-Power-Play-Bonus',
                        icon: '',
                        authkey:"shoeIPLpowerPlay",
                        label: "PROMOTIONS@IPLPOWERPLAY1"
                    },



                    {
                        id: '25',
                        url: '/promotions/indian-galaxsys-league',
                        icon: '',
                        authkey:"showIndianGalaxysLeague",
                        label: "PROMOTIONS@IndianGalaxsysLeague"
                    },
                   
                    



                        {
                        id: '26',
                        url: '/promotions/ipl-betting-dhamaka',
                        icon: '',
                        authkey:"showIplPromo",
                        label: "PROMOTIONS@iplmatka"},



                        {
                            id: '27',
                            url: '/promotions/double-cashback',
                            icon: '',
                            authkey:"showDoubleCashBack",
                            label: "PROMOTIONS@DoubleCashback"
                        },


                        {
                        id: '28',
                        url: '/promotions/aviator-sky-bound-miles',
                        icon: '',
                        authkey:"showAviatorSkyBoundMiles",
                        label: "PROMOTIONS@AviatorSkyBoundMiles"
                    },
                    {
                        id: '29',
                        url: '/promotions/wc-lossback',
                        icon: '',
                        authkey:"showWorldCupLossbackYolo",
                        label: "PROMOTIONS@WorldCupLossbackBonus"
                    },
                    {
                        id: '30',
                        url: '/promotions/daily-deposit-bonus',
                        icon: '',
                        authkey:"showCryptoDailyDepositBonus",
                        label: "PROMOTIONS@WorldCupDailyDepositBonus"
                    },
                    {
                        id: '31',
                        url: '/promotions/wc-evolutionCasinoCup',
                        icon: '',
                        authkey:"showWorldCupEvolutionCasinoCup",
                        label: "PROMOTIONS@WorldCupEvolutionCasinoCupBonus"
                    },
                    {
                        id: '34',
                        url: '/promotions/smartsoft-spin-and-win',
                        icon: '',
                        authkey:"showSmartSoftJetxCelestial",
                        label: "PROMOTIONS@SmartSoftJetxCelestial"
                    },
                    {
                        id: '35',
                        url: '/promotions/mines-legend-trophy',
                        icon: '',
                        authkey:"showMinesLegendTrophyPromo",
                        label: "PROMOTIONS@MinesLegendTrophy"
                    },
                    {
                        id: '36',
                        url: '/promotions/caribbean-premier-league',
                        icon: '',
                        authkey:"showCaribbeanLeagueBonusPromo",
                        label: "PROMOTIONS@CaribbeanLeagueBonus"
                    },
                    {
                        id: '37',
                        url: '/promotions/evolution-roulette-cup',
                        icon: '',
                        authkey:"showEvolutionRouletteCupPromo",
                        label: "PROMOTIONS@EvolutionRouletteCup"
                    },
                    {
                        id: '38',
                        url: '/promotions/aviatrix-fly-and-play',
                        icon: '',
                        authkey:"showAviatrixFlyAndPlayPromo",
                        label: "PROMOTIONS@AviatrixFlyAndPlay"
                    },
                    {
                        id: '39',
                        url: '/promotions/aviatrix-jet-to-cash',
                        icon: '',
                        authkey:"showAviatrixJetToCrash",
                        label: "PROMOTIONS@AviatrixJetToCrash"
                    },
                    {
                        id: '40',
                        url: '/promotions/aviator-rain',
                        icon: '',
                        authkey:"showAviatorRainPromo",
                        label: "PROMOTIONS@AviatorRainPromo"
                    },
                    {
                        id: '41',
                        url: '/promotions/jet-set-with-jetx',
                        icon: '',
                        authkey:"showJetSetWithJetXPromo",
                        label: "PROMOTIONS@JetSetWithJetX"
                    },
                    {
                        id: '42',
                        url: '/promotions/womens-world-cup',
                        icon: '',
                        authkey:"showWomensWorldCupPromo",
                        label: "PROMOTIONS@WomensWorldCup"
                    },
                    {
                        id: '43',
                        url: '/promotions/big-bash-big-cash',
                        icon: '',
                        authkey:"showBigBashBigCashPromo",
                        label: "PROMOTIONS@BigBashBigCash"
                    },
                    {
                        id: '44',
                        url: '/promotions/the-live-jackpot',
                        icon: '',
                        authkey:"showLiveJackPot2025Promo",
                        label: "PROMOTIONS@LiveJackPot2025"
                    },
                    {
                        id: '45',
                        url: '/promotions/instant-challenge-2025',
                        icon: '',
                        authkey:"showInstantChallengePromo",
                        label: "PROMOTIONS@InstantChallengePromo"
                    },
                    {
                        id: '46',
                        url: '/promotions/super-slots-challenge',
                        icon: '',
                        authkey:"showSuperSlotsChallengePromo",
                        label: "PROMOTIONS@SuperSlotsChallenge"
                    },
                    {
                        id: '47',
                        url: '/promotions/icc-champions-trophy',
                        icon: '',
                        authkey:"showChampionsTrophyPromo",
                        label: "PROMOTIONS@ChampionsTrophy"
                    },
                    {
                        id: '49',
                        url: '/promotions/daily-leaderboard',
                        icon: '',
                        authkey:"showDailyLeaderboard",
                        label: "PROMOTIONS@DailyLeaderBoard"
                    },
                    {
                        id: '50',
                        url: '/promotions/aviatrix-sky-high-challenge',
                        icon: '',
                        authkey:"showAviatrixSkyHighChallengePromo",
                        label: "PROMOTIONS@AviatrixSKYHighChallenge"
                    },
                    {
                        id: '51',
                        url: '/promotions/lightning-cashback',
                        icon: '',
                        authkey:"showLightningCashback2k25",
                        label: "PROMOTIONS@LightningCashback2k25"
                    },
                    {
                        id: '52',
                        url: '/promotions/galaxsys-tournament',
                        icon: '',
                        authkey:"showGalaxsysTournament",
                        label: "PROMOTIONS@GalaxsysTournamentPromo"
                    },
                    {
                        id: '53',
                        url: '/promotions/smartsoft-price-drop',
                        icon: '',
                        authkey:"showSmartSoftPriceDrop",
                        label: "PROMOTIONS@SmartSoftPriceDropTitle"
                    },
                    {
                        id: '54',
                        url: '/promotions/jili-jackpot-league',
                        icon: '',
                        authkey:"ShowJiliSpinWinLeaguePromo",
                        label: "PROMOTIONS@JiliSpinWinLeague"
                    },
                    {
                        id: '55',
                        url: '/promotions/crazy-prize-drop',
                        icon: '',
                        authkey:"ShowCrazyPrizeDropPromo",
                        label: "PROMOTIONS@EvolutionCrazyPrizeDrop"
                    },
                    {
                        id: '56',
                        url: '/promotions/ipl-jackpot',
                        icon: '',
                        authkey:"showIPLJackpotPromo",
                        label: "PROMOTIONS@IPLJackpotPromo2k25"
                    },
                    {
                        id: '57',
                        url: '/promotions/100-lossback-bonus',
                        icon: '',
                        authkey:"show100LossBackPromo25",
                        label: "PROMOTIONS@HundredLossbackPromo"
                    },
                    {
                        id: '58',
                        url: '/promotions/twenty-free-spins',
                        icon: '',
                        authkey:"showFreeSpinsPromo",
                        label: "PROMOTIONS@TwentyFreeSpins"
                    },
                    {
                        id: '59',
                        url: '/promotions/super-chicken-rush',
                        icon: '',
                        authkey:"showSuperChickenRushPromo",
                        label: "PROMOTIONS@superChickenRushPromo"
                    },
                    {
                        id: '60',
                        url: '/promotions/surprise-evolution',
                        icon: '',
                        authkey:"showSurpriseDhamakaPromo",
                        label: "PROMOTIONS@SurpriseDhamaka"
                    },
                    {
                        id: '61',
                        url: '/promotions/wbbl',
                        icon: '',
                        authkey:"showWBBLPromo",
                        label: "PROMOTIONS@WBBL"
                    },
                    {
                        id: '62',
                        url: '/promotions/international-league-t20',
                        icon: '',
                        authkey:"showILT20Promo",
                        label: "PROMOTIONS@ILT20Promo"                   
                    },
                    {
                        id: '64',
                        url: '/promotions/exchange-safety-net',
                        icon: '',
                        authkey:"showHundredSafetyPromo",
                        label: "PROMOTIONS@ExchangeSafetyPromo"
                    },
                    {
                        id: '65',
                        url: '/promotions/aviator-26-free-bets-bonanza',
                        icon: '',
                        authkey:"ShowAviator26FBBPromo",
                        label: "PROMOTIONS@Aviator26FBBPromo"
                    },
                    {
                        id: '66',
                        url: '/promotions/deposit-with-6-win-26x-bonus',
                        icon: '',
                        authkey:"showDeposit6x26xBonusPromo",
                        label: "PROMOTIONS@Deposit6x26xBonusPromo"
                    },
                    {
                        id: '67',
                        url: '/promotions/monday-happy-hours',
                        icon: '',
                        authkey:"showMondayHappyHourPromo",
                        label: "PROMOTIONS@MondayHappyHourPromo"
                    },
                    {
                        id: '68',
                        url: '/promotions/chicken-road',
                        icon: '',
                        authkey:"showChickenRoadPromo",
                        label: "PROMOTIONS@chickenRoadPromo"
                    },
                    {
                        id: '69',
                        url: '/promotions/evolution-live-rewards',
                        icon: '',
                        authkey:"showEvoLiveRewrds2k26Promo",
                        label: "PROMOTIONS@EvoLiveRewrdsPromo"
                    },
                    {
                        id: '70',
                        url: '/promotions/welcome-free-spins',
                        icon: '',
                        authkey:"showWelcomeFreeSpins",
                        label: "PROMOTIONS@WelcomeFreeSpinsPromo"
                    },
                    {
                        id: '71',
                        url: '/promotions/aviator-free-bets-with-ipl-bets',
                        icon: '',
                        authkey:"showAviatorFreeBetsWthIPLBetsPromo",
                        label: "PROMOTIONS@AviatorFreeBetsWthIPLBetsPromo"
                    },
                    {
                        id: '72',
                        url: '/promotions/leaderboard-2026',
                        icon: '',
                        authkey:"showLeaderboard2k26Promo",
                        label: "PROMOTIONS@LeaderboardPromoTitle"
                    },
                    {
                        id: '73',
                        url: '/promotions/free-spins-jili',
                        icon: '',
                        authkey:"showJiliFreeSpinsPromo",
                        label: "PROMOTIONS@jiliFreeSpinsPromo"
                    },
                    {
                        id: '74',
                        url: '/promotions/weekly-deposits',
                        icon: '',
                        authkey:"showWeeklyDesposit",
                        label: "PROMOTIONS@WeeklyDespositPromo"
                    },
                    {
                        id: '75',
                        url: '/promotions/evolution-powerplay-strike',
                        icon: '',
                        authkey:"showEvolutionpPowerPlayPromo",
                        label: "PROMOTIONS@EvoPowerplayStrikePromo"
                    },
                    {
                        id: '76',
                        url: '/promotions/daily-betback',
                        icon: '',
                        authkey:"showDailyBetBackPromo",
                        label: "PROMOTIONS@DailyBetBackPromo"
                    },
                    {
                        id: '77',
                        url: '/promotions/playtech-new-launch-win-big',
                        icon: '',
                        authkey:"showPlaytechNewLaunch",
                        label: "PROMOTIONS@PlaytechNewLaunchPromo"
                    },
                    {
                        id: '78',
                        url: '/promotions/place-9-bets-win-up-to-99x',
                        icon: '',
                        authkey:"showPlace9BetsWinUpTo99X",
                        label: "PROMOTIONS@Place9BetsWinUpTo99XPromo"
                    },
                    {
                        id: '79',
                        url: '/promotions/up-to-100-free-spins-on-ganesh-gold',
                        icon: '',
                        authkey:"show100FreeSpinOnGaneshGold",
                        label: "PROMOTIONS@100FreeSpinOnGaneshGold"
                    }
                ],
                footer: [
                    {
                        id: '1',
                        url: '',
                        icon: '',
                        label: 'MENU@ExploreALL'
                    },
                ]
            },
            rightMenu: [
                {
                    id: 'rm1',
                    url: '/promotions/welcome-bonus',
                    image: 'DROPDOWN_WELCOME_BONUS_NEW.png',
                    label: 'PROMOTIONSTITLE@WELCOME',
                    authkey: "showWelcomeBonus"
                },
                {
                    id: 'rm2',
                    url: '/promotions/refill-bonus',
                    image: 'DROPDOWN_REFILLBONUS_NEW.png',
                    label: 'PROMOTIONSTITLE@REFILL',
                    authkey: "showRefillBonus"
                },
                {
                    id: 'rm3',
                    url: '/promotions/cashback-bonus',
                    image: 'DROPDOWN_CASHBACKBONUS_NEW.png',
                    label: 'PROMOTIONSTITLE@CASHBACK',
                    authkey: "showCashbackBonus"
                }
            ]
        },
    },
}
